/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
(function (bodyScrollLock, themeAddresses, themeCurrency, Rellax, Flickity, FlickityFade, MicroModal, themeImages) {
    "use strict";
    function floatLabels(e) {
        e.querySelectorAll(".form-field").forEach((e) => {
            const t = e.querySelector("label"),
                s = e.querySelector("input, textarea");
            t &&
                s &&
                (s.addEventListener("keyup", (e) => {
                    "" !== e.target.value ? t.classList.add("label--float") : t.classList.remove("label--float");
                }),
                s.value && s.value.length && t.classList.add("label--float"));
        });
    }
    (window.theme = window.theme || {}),
        (window.theme.sizes = { mobile: 480, small: 750, large: 990, widescreen: 1400 }),
        (window.theme.keyboardKeys = { TAB: "Tab", ENTER: "Enter", ESCAPE: "Escape", SPACE: "Space", LEFTARROW: "ArrowLeft", RIGHTARROW: "ArrowRight" }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let screenOrientation = getScreenOrientation();
    function readHeights() {
        const e = {};
        return (
            (e.windowHeight = Math.min(window.screen.height, window.innerHeight)),
            (e.announcementHeight = getHeight('[data-section-type*="announcement"] [data-bar-top]')),
            (e.footerHeight = getHeight('[data-section-type*="footer"]')),
            (e.menuHeight = getHeight("[data-header-height]")),
            (e.headerHeight = e.menuHeight + e.announcementHeight),
            (e.collectionNavHeight = getHeight("[data-collection-nav]")),
            (e.logoHeight = getFooterLogoWithPadding()),
            e
        );
    }
    function setVarsOnResize() {
        document.addEventListener("theme:resize", resizeVars), setVars();
    }
    function setVars() {
        const { windowHeight: e, announcementHeight: t, headerHeight: s, logoHeight: i, menuHeight: o, footerHeight: r, collectionNavHeight: a } = readHeights();
        document.documentElement.style.setProperty("--full-screen", `${e}px`),
            document.documentElement.style.setProperty("--three-quarters", e * (3 / 4) + "px"),
            document.documentElement.style.setProperty("--two-thirds", e * (2 / 3) + "px"),
            document.documentElement.style.setProperty("--one-half", e / 2 + "px"),
            document.documentElement.style.setProperty("--one-third", e / 3 + "px"),
            document.documentElement.style.setProperty("--menu-height", `${o}px`),
            document.documentElement.style.setProperty("--announcement-height", `${t}px`),
            document.documentElement.style.setProperty("--header-height", `${s}px`),
            document.documentElement.style.setProperty("--collection-nav-height", `${a}px`),
            document.documentElement.style.setProperty("--footer-height", `${r}px`),
            document.documentElement.style.setProperty("--content-full", e - s - i / 2 + "px"),
            document.documentElement.style.setProperty("--content-min", e - s - r + "px"),
            document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
                document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`),
            document.documentElement.style.setProperty("--scrollbar-width", `${getScrollbarWidth()}px`);
    }
    function resizeVars() {
        const { windowHeight: e, announcementHeight: t, headerHeight: s, logoHeight: i, menuHeight: o, footerHeight: r, collectionNavHeight: a } = readHeights(),
            n = getScreenOrientation();
        n !== screenOrientation &&
            (document.documentElement.style.setProperty("--full-screen", `${e}px`),
            document.documentElement.style.setProperty("--three-quarters", e * (3 / 4) + "px"),
            document.documentElement.style.setProperty("--two-thirds", e * (2 / 3) + "px"),
            document.documentElement.style.setProperty("--one-half", e / 2 + "px"),
            document.documentElement.style.setProperty("--one-third", e / 3 + "px"),
            (screenOrientation = n)),
            document.documentElement.style.setProperty("--menu-height", `${o}px`),
            document.documentElement.style.setProperty("--announcement-height", `${t}px`),
            document.documentElement.style.setProperty("--header-height", `${s}px`),
            document.documentElement.style.setProperty("--collection-nav-height", `${a}px`),
            document.documentElement.style.setProperty("--footer-height", `${r}px`),
            document.documentElement.style.setProperty("--content-full", e - s - i / 2 + "px"),
            document.documentElement.style.setProperty("--content-min", e - s - r + "px"),
            document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
                document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`);
    }
    function getScreenOrientation() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0;
    }
    function getHeight(e) {
        const t = document.querySelector(e);
        return t ? t.offsetHeight : 0;
    }
    function getFooterLogoWithPadding() {
        const e = getHeight("[data-footer-logo]");
        return e > 0 ? e + 20 : 0;
    }
    function getScrollbarWidth() {
        const e = document.createElement("div");
        (e.style.visibility = "hidden"), (e.style.overflow = "scroll"), (e.style.msOverflowStyle = "scrollbar"), document.body.appendChild(e);
        const t = document.createElement("div");
        e.appendChild(t);
        const s = e.offsetWidth - t.offsetWidth;
        return e.parentNode.removeChild(e), s;
    }
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    let isCompleted = !1,
        docComplete = !1;
    function preloadImages() {
        (document.onreadystatechange = () => {
            "complete" === document.readyState && ((docComplete = !0), initImagesPreloader());
        }),
            requestIdleCallback(initImagesPreloader);
    }
    function initImagesPreloader() {
        setTimeout(() => {
            if (isCompleted) return;
            if (!docComplete) return void initImagesPreloader();
            const e = document.querySelectorAll('img[loading="lazy"]');
            e.length &&
                e.forEach((e) => {
                    e.setAttribute("loading", "eager");
                }),
                (isCompleted = !0);
        }, 3e3);
    }
    function debounce(e, t) {
        let s;
        return function () {
            if (e) {
                const i = () => e.apply(this, arguments);
                clearTimeout(s), (s = setTimeout(i, t));
            }
        };
    }
    function getWindowWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    function getWindowHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }
    function isDesktop() {
        return getWindowWidth() >= window.theme.sizes.small;
    }
    function isMobile() {
        return getWindowWidth() < window.theme.sizes.small;
    }
    let lastWindowWidth = getWindowWidth(),
        lastWindowHeight = getWindowHeight();
    function dispatch$1() {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
            lastWindowWidth !== getWindowWidth() && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (lastWindowWidth = getWindowWidth())),
            lastWindowHeight !== getWindowHeight() && (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })), (lastWindowHeight = getWindowHeight()));
    }
    function resizeListener() {
        window.addEventListener(
            "resize",
            debounce(function () {
                dispatch$1();
            }, 50)
        );
    }
    let prev = window.pageYOffset,
        up = null,
        down = null,
        wasUp = null,
        wasDown = null,
        scrollLockTimeout = 0,
        scrollPosition = 0,
        targetElement = null;
    function dispatch() {
        const e = window.pageYOffset;
        e > prev ? ((down = !0), (up = !1)) : e < prev ? ((down = !1), (up = !0)) : ((up = null), (down = null)),
            (prev = e),
            document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: up, down: down, position: e }, bubbles: !1 })),
            up && !wasUp && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: e }, bubbles: !1 })),
            down && !wasDown && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: e }, bubbles: !1 })),
            (wasDown = down),
            (wasUp = up);
    }
    function lock(e) {
        (targetElement = e.detail),
            bodyScrollLock.disableBodyScroll(targetElement, {
                allowTouchMove: (e) => {
                    for (; e && e !== document.body; ) {
                        if (null !== e.getAttribute("body-scroll-lock-ignore") || null !== e.getAttribute("data-popout-list") || "TEXTAREA" === e.tagName) return !0;
                        e = e.parentElement;
                    }
                },
            }),
            document.documentElement.hasAttribute("data-scroll-locked") ||
                ((scrollPosition = window.scrollY),
                document.documentElement.style.setProperty("scroll-behavior", "auto"),
                requestAnimationFrame(() => {
                    document.documentElement.setAttribute("data-scroll-locked", ""), document.body.style.setProperty("--scroll-top-position", `-${scrollPosition}px`), document.documentElement.style.removeProperty("scroll-behavior");
                }));
    }
    function unlock() {
        if (
            ((scrollLockTimeout = setTimeout(() => {
                document.body.removeAttribute("data-drawer-closing");
            }, 20)),
            document.body.hasAttribute("data-drawer-closing"))
        )
            return document.body.removeAttribute("data-drawer-closing"), void (scrollLockTimeout && clearTimeout(scrollLockTimeout));
        document.body.setAttribute("data-drawer-closing", ""),
            bodyScrollLock.clearAllBodyScrollLocks(),
            document.documentElement.removeAttribute("data-scroll-locked"),
            document.documentElement.style.setProperty("scroll-behavior", "auto"),
            window.scrollTo({ top: scrollPosition, behavior: "auto" }),
            document.documentElement.style.removeProperty("scroll-behavior");
    }
    function scrollListener() {
        let e;
        window.addEventListener(
            "scroll",
            function () {
                e && window.cancelAnimationFrame(e),
                    (e = window.requestAnimationFrame(function () {
                        dispatch();
                    }));
            },
            { passive: !0 }
        ),
            window.addEventListener("theme:scroll:lock", lock),
            window.addEventListener("theme:scroll:unlock", unlock);
    }
    const wrap = (e, t = "", s) => {
        const i = s || document.createElement("div");
        return i.classList.add(t), e.parentNode.insertBefore(i, e), i.appendChild(e);
    };
    function wrapElements(e) {
        e.querySelectorAll(".rte table").forEach((e) => {
            wrap(e, "rte__table-wrapper");
        });
        e.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((e) => {
            wrap(e, "rte__video-wrapper");
        });
    }
    function isTouchDevice() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    function isTouch() {
        isTouchDevice() ? ((document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch")), (window.theme.touch = !0)) : (window.theme.touch = !1);
    }
    function ariaToggle(e) {
        const t = e.querySelectorAll("[data-aria-toggle]");
        t.length &&
            t.forEach((e) => {
                e.addEventListener("click", function (e) {
                    e.preventDefault();
                    const t = e.currentTarget;
                    t.setAttribute("aria-expanded", "false" == t.getAttribute("aria-expanded") ? "true" : "false");
                    const s = t.getAttribute("aria-controls"),
                        i = document.querySelector(`#${s}`),
                        o = () => {
                            i.classList.remove("expanding"), i.removeEventListener("transitionend", o);
                        },
                        r = () => {
                            i.classList.add("expanding"), i.removeEventListener("transitionstart", r);
                        };
                    i.addEventListener("transitionstart", r), i.addEventListener("transitionend", o), i.classList.toggle("expanded");
                });
            });
    }
    function loading() {
        document.body.classList.add("is-loaded");
    }
    const classes$O = { loading: "is-loading" },
        selectors$Z = { img: "img.is-loading" };
    function loadedImagesEventHook() {
        document.addEventListener(
            "load",
            (e) => {
                "IMG" == e.target.tagName && e.target.classList.contains(classes$O.loading) && (e.target.classList.remove(classes$O.loading), e.target.parentNode.classList.remove(classes$O.loading));
            },
            !0
        );
    }
    function removeLoadingClassFromLoadedImages(e) {
        e.querySelectorAll(selectors$Z.img).forEach((e) => {
            e.complete && (e.classList.remove(classes$O.loading), e.parentNode.classList.remove(classes$O.loading));
        });
    }
    function isVisible(e) {
        var t = window.getComputedStyle(e);
        return "none" !== t.display && "hidden" !== t.visibility;
    }
    function forceFocus(e, t) {
        t = t || {};
        var s = e.tabIndex;
        (e.tabIndex = -1),
            (e.dataset.tabIndex = s),
            e.focus(),
            void 0 !== t.className && e.classList.add(t.className),
            e.addEventListener("blur", function i(o) {
                o.target.removeEventListener(o.type, i), (e.tabIndex = s), delete e.dataset.tabIndex, void 0 !== t.className && e.classList.remove(t.className);
            });
    }
    function focusHash(e) {
        e = e || {};
        var t = window.location.hash,
            s = document.getElementById(t.slice(1));
        if (s && e.ignore && s.matches(e.ignore)) return !1;
        t && s && forceFocus(s, e);
    }
    function bindInPageLinks(e) {
        return (
            (e = e || {}),
            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (t) {
                if ("#" === t.hash || "" === t.hash) return !1;
                if (e.ignore && t.matches(e.ignore)) return !1;
                if (((s = t.hash.substr(1)), null === document.getElementById(s))) return !1;
                var s,
                    i = document.querySelector(t.hash);
                return (
                    !!i &&
                    (t.addEventListener("click", function () {
                        forceFocus(i, e);
                    }),
                    !0)
                );
            })
        );
    }
    function focusable(e) {
        return Array.prototype.slice.call(e.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter(function (e) {
            return !(!(e.offsetWidth || e.offsetHeight || e.getClientRects().length) || !isVisible(e));
        });
    }
    var trapFocusHandlers = {};
    function trapFocus(e, t) {
        t = t || {};
        var s = focusable(e),
            i = t.elementToFocus || e,
            o = s[0],
            r = s[s.length - 1];
        removeTrapFocus(),
            (trapFocusHandlers.focusin = function (t) {
                e !== t.target && !e.contains(t.target) && o && o === t.target && o.focus(), (t.target !== e && t.target !== r && t.target !== o) || document.addEventListener("keydown", trapFocusHandlers.keydown);
            }),
            (trapFocusHandlers.focusout = function () {
                document.removeEventListener("keydown", trapFocusHandlers.keydown);
            }),
            (trapFocusHandlers.keydown = function (t) {
                t.code === window.theme.keyboardKeys.TAB && (t.target !== r || t.shiftKey || (t.preventDefault(), o.focus()), (t.target !== e && t.target !== o) || !t.shiftKey || (t.preventDefault(), r.focus()));
            }),
            document.addEventListener("focusout", trapFocusHandlers.focusout),
            document.addEventListener("focusin", trapFocusHandlers.focusin),
            forceFocus(i, t);
    }
    function removeTrapFocus() {
        document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }
    function accessibleLinks(e, t) {
        if ("string" != typeof e) throw new TypeError(e + " is not a String.");
        if (0 !== (e = document.querySelectorAll(e)).length) {
            (t = t || {}).messages = t.messages || {};
            var s,
                i,
                o,
                r = { newWindow: t.messages.newWindow || "Opens in a new window.", external: t.messages.external || "Opens external website.", newWindowExternal: t.messages.newWindowExternal || "Opens external website in a new window." },
                a = t.prefix || "a11y",
                n = { newWindow: a + "-new-window-message", external: a + "-external-message", newWindowExternal: a + "-new-window-external-message" };
            e.forEach(function (e) {
                var t = e.getAttribute("target"),
                    s = e.getAttribute("rel"),
                    i = (function (e) {
                        return e.hostname !== window.location.hostname;
                    })(e),
                    o = "_blank" === t,
                    r = null === s || -1 === s.indexOf("noopener");
                if (o && r) {
                    var a = null === s ? "noopener" : s + " noopener";
                    e.setAttribute("rel", a);
                }
                i && o ? e.setAttribute("aria-describedby", n.newWindowExternal) : i ? e.setAttribute("aria-describedby", n.external) : o && e.setAttribute("aria-describedby", n.newWindow);
            }),
                (s = r),
                (i = document.createElement("ul")),
                (o = Object.keys(s).reduce(function (e, t) {
                    return e + "<li id=" + n[t] + ">" + s[t] + "</li>";
                }, "")),
                i.setAttribute("hidden", !0),
                (i.innerHTML = o),
                document.body.appendChild(i);
        }
    }
    var a11y = Object.freeze({
        __proto__: null,
        forceFocus: forceFocus,
        focusHash: focusHash,
        bindInPageLinks: bindInPageLinks,
        focusable: focusable,
        trapFocus: trapFocus,
        removeTrapFocus: removeTrapFocus,
        accessibleLinks: accessibleLinks,
    });
    const selectors$Y = { inputSearch: 'input[type="search"]', focusedElements: '[aria-selected="true"] a', resetButton: 'button[type="reset"]' },
        classes$N = { hidden: "hidden" };
    let HeaderSearchForm = class extends HTMLElement {
        toggleResetButton() {
            const e = this.resetButton.classList.contains(classes$N.hidden);
            this.input.value.length > 0 && e ? this.resetButton.classList.remove(classes$N.hidden) : 0 !== this.input.value.length || e || this.resetButton.classList.add(classes$N.hidden);
        }
        onChange() {
            this.toggleResetButton();
        }
        shouldResetForm() {
            return !document.querySelector(selectors$Y.focusedElements);
        }
        onFormReset(e) {
            e.preventDefault(), this.shouldResetForm() && ((this.input.value = ""), this.input.focus(), this.toggleResetButton());
        }
        constructor() {
            super(),
                (this.input = this.querySelector(selectors$Y.inputSearch)),
                (this.resetButton = this.querySelector(selectors$Y.resetButton)),
                this.input &&
                    (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                    this.input.addEventListener(
                        "input",
                        debounce((e) => {
                            this.onChange(e);
                        }, 300).bind(this)
                    ));
        }
    };
    customElements.define("header-search-form", HeaderSearchForm);
    const selectors$X = {
        allVisibleElements: '[role="option"]',
        ariaSelected: '[aria-selected="true"]',
        header: "[data-header-height]",
        popularSearches: "[data-popular-searches]",
        predictiveSearch: "predictive-search",
        predictiveSearchResults: "[data-predictive-search-results]",
        predictiveSearchStatus: "[data-predictive-search-status]",
        searchInput: 'input[type="search"]',
        searchPopdown: "[data-popdown]",
        searchResultsLiveRegion: "[data-predictive-search-live-region-count-value]",
        searchResultsGroupsWrapper: "data-search-results-groups-wrapper",
        searchForText: "[data-predictive-search-search-for-text]",
        sectionPredictiveSearch: "#shopify-section-predictive-search",
        selectedLink: '[aria-selected="true"] a',
        selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
    };
    let PredictiveSearch = class extends HeaderSearchForm {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                this.addEventListener("focusout", this.onFocusOut.bind(this)),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        getQuery() {
            return this.input.value.trim();
        }
        onChange() {
            super.onChange();
            const e = this.getQuery();
            var t;
            (this.searchTerm && e.startsWith(this.searchTerm)) || null === (t = this.querySelector(selectors$X.searchResultsGroupsWrapper)) || void 0 === t || t.remove();
            this.updateSearchForTerm(this.searchTerm, e), (this.searchTerm = e), this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset();
        }
        onFormSubmit(e) {
            (this.getQuery().length && !this.querySelector(selectors$X.selectedLink)) || e.preventDefault();
        }
        onFormReset(e) {
            super.onFormReset(e), super.shouldResetForm() && ((this.searchTerm = ""), this.abortController.abort(), (this.abortController = new AbortController()), this.closeResults(!0));
        }
        shouldResetForm() {
            return !document.querySelector(selectors$X.selectedLink);
        }
        onFocus() {
            const e = this.getQuery();
            e.length && (this.searchTerm !== e ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
        }
        onFocusOut() {
            setTimeout(() => {
                this.contains(document.activeElement) || this.close();
            });
        }
        onKeyup(e) {
            switch ((this.getQuery().length || this.close(!0), e.preventDefault(), e.code)) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        onKeydown(e) {
            ("ArrowUp" !== e.code && "ArrowDown" !== e.code) || e.preventDefault();
        }
        updateSearchForTerm(e, t) {
            const s = this.querySelector(selectors$X.searchForText),
                i = null == s ? void 0 : s.innerText;
            if (i) {
                var o;
                if ((null === (o = i.match(new RegExp(e, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                const r = i.replace(e, t);
                s.innerText = r;
            }
        }
        switchOption(e) {
            if (!this.getAttribute("open")) return;
            const t = "up" === e,
                s = this.querySelector(selectors$X.ariaSelected),
                i = Array.from(this.querySelectorAll(selectors$X.allVisibleElements)).filter((e) => null !== e.offsetParent);
            let o = 0;
            if (t && !s) return;
            let r = -1,
                a = 0;
            for (; -1 === r && a <= i.length; ) i[a] === s && (r = a), a++;
            if (((this.statusElement.textContent = ""), !t && s ? (o = r === i.length - 1 ? 0 : r + 1) : t && (o = 0 === r ? i.length - 1 : r - 1), o === r)) return;
            const n = i[o];
            n.setAttribute("aria-selected", !0), s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", n.id);
        }
        selectOption() {
            const e = this.querySelector(selectors$X.selectedOption);
            e && e.click();
        }
        getSearchResults(e) {
            const t = e.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(),
                this.cachedResults[t]
                    ? this.renderSearchResults(this.cachedResults[t])
                    : fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`, { signal: this.abortController.signal })
                          .then((e) => {
                              if (!e.ok) {
                                  var t = new Error(e.status);
                                  throw (this.close(), t);
                              }
                              return e.text();
                          })
                          .then((e) => {
                              const s = new DOMParser().parseFromString(e, "text/html").querySelector(selectors$X.sectionPredictiveSearch).innerHTML;
                              this.allPredictiveSearchInstances.forEach((e) => {
                                  e.cachedResults[t] = s;
                              }),
                                  this.renderSearchResults(s);
                          })
                          .catch((e) => {
                              if (20 !== (null == e ? void 0 : e.code)) throw (this.close(), e);
                          });
        }
        setLiveRegionLoadingState() {
            (this.statusElement = this.statusElement || this.querySelector(selectors$X.predictiveSearchStatus)),
                (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
                this.setLiveRegionText(this.loadingText),
                this.setAttribute("loading", !0);
        }
        setLiveRegionText(e) {
            this.statusElement.setAttribute("aria-hidden", "false"),
                (this.statusElement.textContent = e),
                setTimeout(() => {
                    this.statusElement.setAttribute("aria-hidden", "true");
                }, 1e3);
        }
        renderSearchResults(e) {
            (this.predictiveSearchResults.innerHTML = e), this.setAttribute("results", !0), this.setLiveRegionResults(), this.open();
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(selectors$X.searchResultsLiveRegion).textContent);
        }
        getResultsMaxHeight() {
            return (this.resultsMaxHeight = getWindowHeight() - document.querySelector(selectors$X.header).getBoundingClientRect().bottom), this.resultsMaxHeight;
        }
        open() {
            (this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`), this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), (this.isOpen = !0);
        }
        close(e = !1) {
            this.closeResults(e), (this.isOpen = !1);
        }
        closeResults(e = !1) {
            var t;
            e && ((this.input.value = ""), this.removeAttribute("results"));
            const s = this.querySelector(selectors$X.ariaSelected);
            s && s.setAttribute("aria-selected", !1),
                this.input.setAttribute("aria-activedescendant", ""),
                this.removeAttribute("loading"),
                this.removeAttribute("open"),
                this.input.setAttribute("aria-expanded", !1),
                (this.resultsMaxHeight = !1),
                null === (t = this.predictiveSearchResults) || void 0 === t || t.removeAttribute("style");
        }
        reset() {
            (this.predictiveSearchResults.innerHTML = ""),
                (this.input.val = ""),
                this.a11y.removeTrapFocus(),
                this.popularSearches && (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })), this.a11y.trapFocus(this.searchPopdown, { elementToFocus: this.input }));
        }
        constructor() {
            var e;
            super(),
                (this.a11y = a11y),
                (this.abortController = new AbortController()),
                (this.allPredictiveSearchInstances = document.querySelectorAll(selectors$X.predictiveSearch)),
                (this.cachedResults = {}),
                (this.input = this.querySelector(selectors$X.searchInput)),
                (this.isOpen = !1),
                (this.predictiveSearchResults = this.querySelector(selectors$X.predictiveSearchResults)),
                (this.searchPopdown = this.closest(selectors$X.searchPopdown)),
                (this.popularSearches = null === (e = this.searchPopdown) || void 0 === e ? void 0 : e.querySelector(selectors$X.popularSearches)),
                (this.searchTerm = "");
        }
    };
    customElements.define("predictive-search", PredictiveSearch);
    const selectors$W = { aos: "[data-aos]:not(.aos-animate)", aosAnchor: "[data-aos-anchor]" },
        classes$M = { aosAnimate: "aos-animate" },
        observerConfig = { attributes: !1, childList: !0, subtree: !0 },
        mutationCallback = (e) => {
            for (const t of e)
                if ("childList" === t.type) {
                    const e = t.target,
                        s = e.querySelectorAll(selectors$W.aos),
                        i = e.querySelectorAll(selectors$W.aosAnchor);
                    s.length &&
                        s.forEach((e) => {
                            aosItemObserver.observe(e);
                        }),
                        i.length && initAnchorObservers(i);
                }
        },
        aosItemObserver = new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting && (e.target.classList.add(classes$M.aosAnimate), t.unobserve(e.target));
                });
            },
            { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
        ),
        aosAnchorObserver = new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    if (e.intersectionRatio > 0.1) {
                        const s = e.target.querySelectorAll(selectors$W.aos);
                        s.length &&
                            s.forEach((e) => {
                                e.classList.add(classes$M.aosAnimate);
                            }),
                            t.unobserve(e.target);
                    }
                });
            },
            { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
        );
    function bodyMutationObserver() {
        new MutationObserver(mutationCallback).observe(document.body, observerConfig);
    }
    function elementsIntersectionObserver() {
        const e = document.querySelectorAll(selectors$W.aos);
        e.length &&
            e.forEach((e) => {
                aosItemObserver.observe(e);
            });
    }
    function anchorsIntersectionObserver() {
        const e = document.querySelectorAll(selectors$W.aosAnchor);
        e.length && initAnchorObservers(e);
    }
    function initAnchorObservers(e) {
        let t = [];
        e.length &&
            e.forEach((e) => {
                const s = e.dataset.aosAnchor;
                if (s && -1 === t.indexOf(s)) {
                    const e = document.querySelector(s);
                    e && (aosAnchorObserver.observe(e), t.push(s));
                }
            });
    }
    function initAnimations() {
        elementsIntersectionObserver(), anchorsIntersectionObserver(), bodyMutationObserver();
    }
    (window.requestIdleCallback =
        window.requestIdleCallback ||
        function (e) {
            var t = Date.now();
            return setTimeout(function () {
                e({
                    didTimeout: !1,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - t));
                    },
                });
            }, 1);
        }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (e) {
                clearTimeout(e);
            }),
        window.theme.settings.enableAnimations && initAnimations(),
        resizeListener(),
        scrollListener(),
        isTouch(),
        setVars(),
        loadedImagesEventHook(),
        window.addEventListener("DOMContentLoaded", () => {
            setVarsOnResize(), ariaToggle(document), floatLabels(document), wrapElements(document), removeLoadingClassFromLoadedImages(document), loading(), window.fastNetworkAndCPU && preloadImages();
        }),
        document.addEventListener("shopify:section:load", (e) => {
            const t = e.target;
            floatLabels(t), wrapElements(t), ariaToggle(document), setVarsOnResize();
        });
    const showElement = (e, t = !1, s = "block") => {
        e && (t ? e.style.removeProperty("display") : (e.style.display = s));
    };
    Shopify.Products = (function () {
        const e = { howManyToShow: 4, howManyToStoreInMemory: 10, wrapperId: "recently-viewed-products", section: null, onComplete: null };
        let t = [],
            s = null,
            i = null;
        const o = {
                configuration: { expires: 90, path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 },
                name: "shopify_recently_viewed",
                write: function (e) {
                    const t = e.join(" ");
                    document.cookie = `${this.name}=${t}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
                },
                read: function () {
                    let e = [],
                        t = null;
                    return (
                        -1 !== document.cookie.indexOf("; ") &&
                            document.cookie.split("; ").find((e) => e.startsWith(this.name)) &&
                            (t = document.cookie
                                .split("; ")
                                .find((e) => e.startsWith(this.name))
                                .split("=")[1]),
                        null !== t && (e = t.split(" ")),
                        e
                    );
                },
                destroy: function () {
                    document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                },
                remove: function (e) {
                    const t = this.read(),
                        s = t.indexOf(e);
                    -1 !== s && (t.splice(s, 1), this.write(t));
                },
            },
            r = (t, s, a, n) => {
                s.length && t < e.howManyToShow
                    ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=api-product-grid-item`)
                          .then((e) => e.text())
                          .then((e) => {
                              const i = 150 * t,
                                  o = 100 * t + 800,
                                  l = 50 * t + 800,
                                  c = a.id ? `#${a.id}` : "",
                                  d = document.createElement("div");
                              let h = e.includes("||itemIndex||") ? e.replaceAll("||itemIndex||", t) : e;
                              (h = h.includes("||itemAosDelay||") ? h.replaceAll("||itemAosDelay||", i) : h),
                                  (h = h.includes("||itemAosImageDuration||") ? h.replaceAll("||itemAosImageDuration||", o) : h),
                                  (h = h.includes("||itemAosTextDuration||") ? h.replaceAll("||itemAosTextDuration||", l) : h),
                                  (h = h.includes("||itemAnimationAnchor||") ? h.replaceAll("||itemAnimationAnchor||", c) : h),
                                  (d.innerHTML = h),
                                  (a.innerHTML += d.querySelector("[data-api-content]").innerHTML),
                                  s.shift(),
                                  t++,
                                  r(t, s, a, n);
                          })
                          .catch(() => {
                              o.remove(s[0]), s.shift(), r(t, s, a, n);
                          })
                    : ((t, s) => {
                          showElement(t, !0);
                          const r = o.read().length;
                          if (Shopify.recentlyViewed && i && r && r < i && t.children.length) {
                              let e = [],
                                  s = [],
                                  i = 0;
                              for (const t in Shopify.recentlyViewed) {
                                  i += 1;
                                  const r = Shopify.recentlyViewed[t].split(" "),
                                      a = parseInt(t.split("_")[1]);
                                  (e = [...e, ...r]), (o.read().length === a || (i === Object.keys(Shopify.recentlyViewed).length && !s.length)) && (s = [...s, ...r]);
                              }
                              for (let i = 0; i < t.children.length; i++) {
                                  const o = t.children[i];
                                  e.length && o.classList.remove(...e), s.length && o.classList.add(...s);
                              }
                          }
                          if (e.onComplete)
                              try {
                                  e.onComplete(t, s);
                              } catch (e) {
                                  console.log(e);
                              }
                      })(a, n);
            };
        return {
            showRecentlyViewed: function (a) {
                const n = a || {};
                Object.assign(e, n), (t = o.read()), (s = document.querySelector(`#${e.wrapperId}`)), (i = e.howManyToShow), (e.howManyToShow = Math.min(t.length, e.howManyToShow)), e.howManyToShow && s && r(0, t, s, e.section);
            },
            getConfig: function () {
                return e;
            },
            clearList: function () {
                o.destroy();
            },
            recordRecentlyViewed: function (t) {
                const s = t || {};
                Object.assign(e, s);
                let i = o.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    let t = decodeURIComponent(window.location.pathname)
                        .match(
                            /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                        )[0]
                        .split("/products/")[1];
                    e.handle && (t = e.handle);
                    const s = i.indexOf(t);
                    -1 === s ? (i.unshift(t), (i = i.splice(0, e.howManyToStoreInMemory))) : (i.splice(s, 1), i.unshift(t)), o.write(i);
                }
            },
            hasProducts: o.read().length > 0,
        };
    })();
    const getUrlString = (e, t = [], s = !1) => {
            const i = Object.keys(e)
                .map((i) => {
                    let o = e[i];
                    if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(e) ? t.push("") : t.push(i), getUrlString(o, t, Array.isArray(o));
                    {
                        let e = i;
                        if (t.length > 0) {
                            e = (s ? t : [...t, i]).reduce((e, t) => ("" === e ? t : `${e}[${t}]`), "");
                        }
                        return s ? `${e}[]=${o}` : `${e}=${o}`;
                    }
                })
                .join("&");
            return t.pop(), i;
        },
        hideElement = (e) => {
            e && (e.style.display = "none");
        },
        fadeIn = (e, t, s = null) => {
            (e.style.opacity = 0), (e.style.display = t || "block");
            let i = !0;
            !(function t() {
                let o = parseFloat(e.style.opacity);
                (o += 0.1) > 1 || ((e.style.opacity = o), requestAnimationFrame(t)), 1 === parseInt(o) && i && "function" == typeof s && ((i = !1), s());
            })();
        };
    function FetchError(e) {
        (this.status = e.status || null), (this.headers = e.headers || null), (this.json = e.json || null), (this.body = e.body || null);
    }
    void 0 === Shopify.Cart && (Shopify.Cart = {}),
        (Shopify.Cart.ShippingCalculator = (function () {
            const _config = {
                    submitButton: theme.strings.shippingCalcSubmitButton,
                    submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                    templateId: "shipping-calculator-response-template",
                    wrapperId: "wrapper-response",
                    customerIsLoggedIn: !1,
                },
                _render = function (e) {
                    const t = document.querySelector(`#${_config.templateId}`),
                        s = document.querySelector(`#${_config.wrapperId}`);
                    if (t && s) {
                        s.innerHTML = "";
                        let i = "",
                            o = "",
                            r = "error center",
                            a = t.innerHTML;
                        const n = /[^[\]]+(?=])/g;
                        if (e.rates && e.rates.length) {
                            let t = n.exec(a)[0];
                            e.rates.forEach((e) => {
                                let s = t;
                                (s = s.replace(/\|\|rateName\|\|/, e.name)), (s = s.replace(/\|\|ratePrice\|\|/, Shopify.Cart.ShippingCalculator.formatRate(e.price))), (i += s);
                            });
                        }
                        if (e.success) {
                            r = "success center";
                            const s = document.createElement("div");
                            s.innerHTML = t.innerHTML;
                            const i = s.querySelector("[data-template-no-shipping]");
                            e.rates.length < 1 && i && (o = i.getAttribute("data-template-no-shipping"));
                        } else o = e.errorFeedback;
                        (a = a.replace(n, "").replace("[]", "")), (a = a.replace(/\|\|ratesList\|\|/g, i)), (a = a.replace(/\|\|successClass\|\|/g, r)), (a = a.replace(/\|\|ratesText\|\|/g, o)), (s.innerHTML += a);
                    }
                },
                _enableButtons = function () {
                    const e = document.querySelector(".get-rates");
                    e.removeAttribute("disabled"), e.classList.remove("disabled"), (e.value = _config.submitButton);
                },
                _disableButtons = function () {
                    const e = document.querySelector(".get-rates");
                    e.setAttribute("disabled", "disabled"), e.classList.add("disabled"), (e.value = _config.submitButtonDisabled);
                },
                _getCartShippingRatesForDestination = function (e) {
                    const t = encodeURI(getUrlString({ shipping_address: e })),
                        s = `${window.theme.routes.cart}/shipping_rates.json?${t}`,
                        i = new XMLHttpRequest();
                    i.open("GET", s, !0),
                        (i.onload = function () {
                            if (this.status >= 200 && this.status < 400) {
                                const t = JSON.parse(this.response).shipping_rates;
                                _onCartShippingRatesUpdate(t, e);
                            } else _onError(this);
                        }),
                        (i.onerror = function () {
                            _onError(this);
                        }),
                        i.send();
                },
                _fullMessagesFromErrors = function (e) {
                    const t = [];
                    for (const s in e) for (const i of e[s]) t.push(s + " " + i);
                    return t;
                },
                _onError = function (XMLHttpRequest) {
                    hideElement(document.querySelector("#estimated-shipping"));
                    const shippingChild = document.querySelector("#estimated-shipping em");
                    if (shippingChild) for (; shippingChild.firstChild; ) shippingChild.removeChild(shippingChild.firstChild);
                    _enableButtons();
                    let feedback = "";
                    const data = eval("(" + XMLHttpRequest.responseText + ")");
                    (feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + _fullMessagesFromErrors(data).join("; ")),
                        "Error : country is not supported." === feedback && (feedback = "We do not ship to this destination."),
                        _render({ rates: [], errorFeedback: feedback, success: !1 }),
                        showElement(document.querySelector(`#${_config.wrapperId}`));
                },
                _onCartShippingRatesUpdate = function (e, t) {
                    _enableButtons();
                    let s = "";
                    t.zip && (s += t.zip + ", "), t.province && (s += t.province + ", "), (s += t.country);
                    const i = document.querySelector("#estimated-shipping em");
                    e.length && i && (i.textContent = "0.00" == e[0].price ? window.theme.strings.free : themeCurrency.formatMoney(e[0].price, theme.moneyFormat)), _render({ rates: e, address: s, success: !0 });
                    const o = document.querySelectorAll(`#${_config.wrapperId}, #estimated-shipping`);
                    o.length &&
                        o.forEach((e) => {
                            fadeIn(e);
                        });
                },
                _init = function () {
                    const e = document.querySelector(".get-rates"),
                        t = document.querySelector("#address_container"),
                        s = document.querySelector("#address_country"),
                        i = document.querySelector("#address_province"),
                        o = document.querySelector("html");
                    let r = "en";
                    if (
                        (o.hasAttribute("lang") && "" !== o.getAttribute("lang") && (r = o.getAttribute("lang")),
                        t && themeAddresses.AddressForm(t, r, { shippingCountriesOnly: !0 }),
                        s &&
                            s.hasAttribute("data-default") &&
                            i &&
                            i.hasAttribute("data-default") &&
                            s.addEventListener("change", function () {
                                s.removeAttribute("data-default"), i.removeAttribute("data-default");
                            }),
                        e &&
                            (e.addEventListener("click", function (e) {
                                _disableButtons();
                                const t = document.querySelector(`#${_config.wrapperId}`);
                                for (; t.firstChild; ) t.removeChild(t.firstChild);
                                hideElement(t);
                                const o = {};
                                let r = s.value,
                                    a = i.value;
                                const n = s.getAttribute("data-default-fullname");
                                "" === r && n && "" !== n && (r = n);
                                const l = i.getAttribute("data-default-fullname");
                                "" === a && l && "" !== l && (a = l), (o.zip = document.querySelector("#address_zip").value || ""), (o.country = r || ""), (o.province = a || ""), _getCartShippingRatesForDestination(o);
                            }),
                            _config.customerIsLoggedIn && e.classList.contains("get-rates--trigger")))
                    ) {
                        const t = document.querySelector("#address_zip");
                        t && t.value && e.dispatchEvent(new Event("click"));
                    }
                };
            return {
                show: function (e) {
                    (e = e || {}),
                        Object.assign(_config, e),
                        document.addEventListener("DOMContentLoaded", function () {
                            _init();
                        });
                },
                getConfig: function () {
                    return _config;
                },
                formatRate: function (e) {
                    return "0.00" === e ? window.theme.strings.free : themeCurrency.formatMoney(e, theme.moneyFormat);
                },
            };
        })()),
        (FetchError.prototype = Error.prototype);
    const selectors$V = {
        quantityHolder: "[data-quantity-holder]",
        quantityField: "[data-quantity-field]",
        quantityButton: "[data-quantity-button]",
        quantityMinusButton: "[data-quantity-minus]",
        quantityPlusButton: "[data-quantity-plus]",
        quantityReadOnly: "read-only",
        isDisabled: "is-disabled",
    };
    let QuantityCounter = class {
        init() {
            (this.settings = selectors$V),
                (this.quantity = this.holder.querySelector(this.settings.quantityHolder)),
                this.quantity &&
                    ((this.field = this.quantity.querySelector(this.settings.quantityField)),
                    (this.buttons = this.quantity.querySelectorAll(this.settings.quantityButton)),
                    (this.increaseButton = this.quantity.querySelector(this.settings.quantityPlusButton)),
                    (this.quantityValue = Number(this.field.value || 0)),
                    (this.cartItemID = this.field.getAttribute("data-id")),
                    (this.maxValue = Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null),
                    (this.minValue = Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0),
                    (this.disableIncrease = this.disableIncrease.bind(this)),
                    (this.emptyField = !1),
                    (this.updateQuantity = this.updateQuantity.bind(this)),
                    (this.decrease = this.decrease.bind(this)),
                    (this.increase = this.increase.bind(this)),
                    this.disableIncrease(),
                    this.quantity.classList.contains(this.settings.quantityReadOnly) || (this.changeValueOnClick(), this.changeValueOnInput()));
        }
        changeValueOnClick() {
            const e = this;
            this.buttons.forEach((t) => {
                t.addEventListener("click", (t) => {
                    t.preventDefault();
                    const s = t.target,
                        i = s.matches(e.settings.quantityMinusButton) || s.closest(e.settings.quantityMinusButton),
                        o = s.matches(e.settings.quantityPlusButton) || s.closest(e.settings.quantityPlusButton);
                    i && e.decrease(), o && e.increase(), e.updateQuantity();
                });
            });
        }
        changeValueOnInput() {
            this.field.addEventListener("change", () => {
                (this.quantityValue = this.field.value), "" === this.field.value && (this.emptyField = !0), this.updateQuantity();
            });
        }
        updateQuantity() {
            this.maxValue < this.quantityValue && null !== this.maxValue && (this.quantityValue = this.maxValue),
                this.minValue > this.quantityValue && (this.quantityValue = this.minValue),
                (this.field.value = this.quantityValue),
                this.disableIncrease(),
                this.quantityUpdateCart && this.updateCart();
        }
        decrease() {
            this.quantityValue > this.minValue ? this.quantityValue-- : (this.quantityValue = 0);
        }
        increase() {
            this.quantityValue++;
        }
        disableIncrease() {
            this.increaseButton.classList.toggle(this.settings.isDisabled, this.quantityValue >= this.maxValue && null !== this.maxValue);
        }
        updateCart() {
            const e = new CustomEvent("theme:cart:update", { bubbles: !0, detail: { id: this.cartItemID, quantity: this.quantityValue, valueIsEmpty: this.emptyField } });
            this.holder.dispatchEvent(e);
        }
        constructor(e, t = !1) {
            (this.holder = e), (this.quantityUpdateCart = t);
        }
    };
    const classes$L = {
            animated: "is-animated",
            active: "is-active",
            added: "is-added",
            disabled: "is-disabled",
            error: "has-error",
            headerStuck: "js__header__stuck",
            hidden: "is-hidden",
            hiding: "is-hiding",
            loading: "is-loading",
            open: "is-open",
            removed: "is-removed",
            success: "is-success",
            visible: "is-visible",
            focused: "is-focused",
            expanded: "is-expanded",
            updated: "is-updated",
        },
        selectors$U = {
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiUpsellItems: "[data-api-upsell-items]",
            animation: "[data-animation]",
            additionalCheckoutButtons: ".additional-checkout-buttons",
            burgerButton: "[data-drawer-toggle]",
            buttonAddToCart: "[data-add-to-cart]",
            buttonQuickAddMobile: "[data-quick-add-btn-mobile]",
            buttonHolder: "[data-foot-holder]",
            buttonSkipUpsellProduct: "[data-skip-upsell-product]",
            cartBarAdd: "[data-add-to-cart-bar]",
            cartCloseError: "[data-cart-error-close]",
            cartDiscountsHolder: "[data-cart-discounts-holder]",
            cartDrawer: "[data-cart-drawer]",
            cartDrawerBody: "[data-cart-drawer-body]",
            cartEmpty: "[data-cart-empty]",
            cartErrors: "[data-cart-errors]",
            cartItemRemove: "[data-item-remove]",
            cartOriginalTotal: "[data-cart-original-total]",
            cartOriginaTotalPrice: "[data-cart-original-total-price]",
            cartPage: "[data-cart-page]",
            cartToggleElement: "[data-cart-toggle]",
            cartTotal: "[data-cart-total]",
            cartTotalDiscountsTemplate: "[data-cart-total-discount-template]",
            cartTotalDiscountTitle: "[data-cart-discount-title]",
            cartTotalDiscountAmount: "[data-cart-discount-price]",
            cartWidget: "[data-cart-widget]",
            cartWidgetContent: "[data-cart-widget-content]",
            expandButton: "[data-expand-button]",
            errorMessage: "[data-error-message]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            freeShipping: "[data-free-shipping]",
            freeShippingGraph: "[data-progress-graph]",
            freeShippingProgress: "[data-progress-bar]",
            headerWrapper: "[data-header-wrapper]",
            item: "[data-item]",
            itemsHolder: "[data-items-holder]",
            leftToSpend: "[data-left-to-spend]",
            navDrawer: "[data-drawer]",
            outerSection: "[data-section-id]",
            upsellProductsHolder: "[data-upsell-products]",
            quickAddHolder: "[data-quick-add-holder]",
            quickAddModal: "[data-quick-add-modal]",
            qtyInput: "[data-quantity-field]",
            drawerUnderlay: "[data-drawer-underlay]",
        },
        attributes$j = { disabled: "disabled", quickAddHolder: "data-quick-add-holder", quickAddVariant: "data-quick-add-variant", freeShipping: "data-free-shipping", freeShippingLimit: "data-free-shipping-limit" },
        settings$3 = { cartDrawerEnabled: window.theme.settings.cartDrawerEnabled, times: { timeoutAnimationComplete: 500, timeoutButtonReset: 1e3 } };
    let CartDrawer = class {
        init() {
            (this.html = document.documentElement),
                (this.body = document.body),
                (this.cartPage = document.querySelector(selectors$U.cartPage)),
                (this.cartDrawer = document.querySelector(selectors$U.cartDrawer)),
                (this.cartDrawerBody = document.querySelector(selectors$U.cartDrawerBody)),
                (this.cartEmpty = document.querySelector(selectors$U.cartEmpty)),
                (this.buttonHolder = document.querySelector(selectors$U.buttonHolder)),
                (this.itemsHolder = document.querySelector(selectors$U.itemsHolder)),
                (this.items = document.querySelectorAll(selectors$U.item)),
                (this.cartTotal = document.querySelector(selectors$U.cartTotal)),
                (this.freeShipping = document.querySelectorAll(selectors$U.freeShipping)),
                (this.cartOriginalTotal = document.querySelector(selectors$U.cartOriginalTotal)),
                (this.cartOriginaTotalPrice = document.querySelector(selectors$U.cartOriginaTotalPrice)),
                (this.cartDiscountHolder = document.querySelector(selectors$U.cartDiscountsHolder)),
                (this.expandButton = document.querySelectorAll(selectors$U.expandButton)),
                (this.cartTotalDiscountTemplate = document.querySelector(selectors$U.cartTotalDiscountsTemplate).innerHTML),
                (this.cartErrorHolder = document.querySelector(selectors$U.cartErrors)),
                (this.cartCloseErrorMessage = document.querySelector(selectors$U.cartCloseError)),
                (this.headerWrapper = document.querySelector(selectors$U.headerWrapper)),
                (this.accessibility = a11y),
                (this.navDrawer = document.querySelector(selectors$U.navDrawer)),
                (this.upsellProductsHolder = document.querySelector(selectors$U.upsellProductsHolder)),
                (this.cart = this.cartDrawer || this.cartPage),
                (this.form = null),
                (this.build = this.build.bind(this)),
                (this.addToCart = this.addToCart.bind(this)),
                (this.updateCart = this.updateCart.bind(this)),
                (this.addToCartCallback = this.addToCartCallback.bind(this)),
                (this.productAddCallback = this.productAddCallback.bind(this)),
                (this.openCartDrawer = this.openCartDrawer.bind(this)),
                (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                (this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this)),
                (this.animateItems = this.animateItems.bind(this)),
                (this.requestItemsAnimationFrame = this.requestItemsAnimationFrame.bind(this)),
                (this.updateProgress = this.updateProgress.bind(this)),
                (this.cartAnimationTimeout = 0),
                (this.skipUpsellProductsArray = []),
                this.skipUpsellProductEvent(),
                this.checkSkippedUpsellProductsFromStorage(),
                this.toggleCartUpsellWidgetVisibility(),
                (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                (this.subtotal = window.theme.subtotal),
                (this.totalItems = this.items.length),
                (this.cartDrawerIsOpen = !1),
                (this.cartDiscounts = 0),
                (this.cartDrawerEnabled = settings$3.cartDrawerEnabled),
                (this.cartUpdateFailed = !1),
                this.cartToggleEvents(),
                this.expandEvents(),
                this.cartEvents(),
                this.cartEventAdd(),
                this.cartEventRemoveError(),
                this.initQuantity(),
                this.estimateShippingCalculator(),
                (this.circumference = 28 * Math.PI),
                (this.cartFreeShippingLimit = 0),
                this.freeShippingMessageHandle(this.subtotal),
                this.updateProgress(),
                document.addEventListener("theme:cart:add", this.addToCartCallback),
                document.addEventListener("theme:cart:loaded", this.requestItemsAnimationFrame),
                document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
                document.addEventListener("theme:product:add", this.productAddCallback),
                document.addEventListener("theme:product:add-error", this.productAddCallback),
                document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded),
                document.addEventListener("theme:announcement:init", this.updateProgress);
        }
        initQuantity() {
            (this.items = document.querySelectorAll(selectors$U.item)),
                this.items.forEach((e) => {
                    new QuantityCounter(e, !0).init(), this.cartUpdateEvent(e);
                });
        }
        expandEvents() {
            const e = document.querySelectorAll(selectors$U.cartWidget);
            this.expandButton.forEach((t) => {
                t.addEventListener("click", (s) => {
                    s.preventDefault();
                    const i = document.querySelector(t.getAttribute("href"));
                    t.classList.toggle(classes$L.active),
                        i.classList.toggle(classes$L.expanded),
                        e.length > 1 &&
                            e.forEach((e) => {
                                if (e !== i.parentElement) {
                                    const t = e.querySelector(selectors$U.expandButton);
                                    t.classList.remove(classes$L.active), t.nextElementSibling.classList.remove(classes$L.expanded);
                                }
                            });
                });
            });
        }
        cartUpdateEvent(e) {
            e.addEventListener("theme:cart:update", (t) => {
                this.updateCart({ id: t.detail.id, quantity: t.detail.quantity }, e, t.detail.valueIsEmpty);
            });
        }
        addToCartCallback(e) {
            if (!e.detail.data) return;
            const t = e.detail,
                s = e.detail.button,
                i = JSON.stringify({ items: [e.detail.data] });
            this.addToCart(i, t, s);
        }
        cartEvents() {
            document.querySelectorAll(selectors$U.cartItemRemove).forEach((e) => {
                const t = e.closest(selectors$U.item);
                e.addEventListener("click", (s) => {
                    s.preventDefault(), e.classList.contains(classes$L.disabled) || this.updateCart({ id: e.dataset.id, quantity: 0 }, t);
                });
            }),
                this.cartCloseErrorMessage &&
                    this.cartCloseErrorMessage.addEventListener("click", (e) => {
                        e.preventDefault(), this.cartErrorHolder.classList.remove(classes$L.expanded);
                    });
        }
        cartEventAdd() {
          document.addEventListener("click", (e) => {
              const t = e.target;
              if (t.matches(selectors$U.buttonAddToCart) || (t.closest(selectors$U.buttonAddToCart) && t)) {
                  let s = "",
                      i = t.matches(selectors$U.buttonAddToCart) ? t : t.closest(selectors$U.buttonAddToCart);
                  if (i.hasAttribute("disabled")) return;
                  if (i.hasAttribute(attributes$j.quickAddVariant)) s = JSON.stringify({ items: [{ id: Number(i.getAttribute(attributes$j.quickAddVariant)), quantity: 1 }] });
                  else {
                      if (((this.form = t.closest("form")), !this.form.checkValidity())) return void this.form.reportValidity();
                      s = new FormData(this.form);
                  }
                  if (null !== this.form && this.form.querySelector('[type="file"]')) return;
                  e.preventDefault(), this.addToCart(s, null, i), document.dispatchEvent(new CustomEvent("theme:cart:add", { bubbles: !0, detail: { selector: t } }));
              }
          });
      }
        cartEventRemoveError() {
            document.addEventListener("click", (e) => {
                const t = e.target;
                if (t.matches(selectors$U.formCloseError) || t.closest(selectors$U.formCloseError)) {
                    e.preventDefault();
                    const s = t.closest(selectors$U.formErrorsContainer);
                    s && s.classList.remove(classes$L.visible);
                }
            });
        }
        estimateShippingCalculator() {
            Shopify.Cart.ShippingCalculator.show({
                submitButton: theme.strings.shippingCalcSubmitButton,
                submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                customerIsLoggedIn: theme.settings.customerLoggedIn,
                moneyFormat: theme.moneyWithCurrencyFormat,
            });
        }
        getCart() {
            fetch(theme.routes.root + "cart.js")
                .then(this.cartErrorsHandler)
                .then((e) => e.json())
                .then(
                    (e) => (
                        (this.newTotalItems = e.items.length),
                        (this.subtotal = e.total_price),
                        (this.itemCount = e.item_count),
                        (this.cartDiscounts = e.total_discount),
                        this.buildTotalPrice(e),
                        document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: !0, detail: { cart: e } })),
                        fetch(theme.routes.cart + "?section_id=api-cart-items")
                    )
                )
                .then((e) => e.text())
                .then((e) => {
                    const t = document.createElement("div");
                    t.innerHTML = e;
                    const s = t.querySelector(selectors$U.apiContent);
                    this.build(s);
                })
                .catch((e) => console.log(e));
        }
        addToCart(e, t = null, s = null) {
            console.trace()
            console.log("e",e)
            this.cart && this.cart.classList.add(classes$L.loading);
            const i = t ? t.element : null;
            let o = null;
            this.cartDrawerEnabled && (s && (s.classList.add(classes$L.loading), (s.disabled = !0)), i && (i.classList.add(classes$L.visible), (o = i.querySelector(selectors$U.buttonQuickAddMobile))));
            let r = e,
                a = { "Content-Type": "application/json" };
            "string" != typeof e && ((r = new URLSearchParams(e).toString()), (a = { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/x-www-form-urlencoded" })),
                fetch(theme.routes.root + "cart/add.js", { method: "POST", headers: a, body: r })
                    .then((e) => e.json())
                    .then((e) => {
                        if (e.status) {
                           this.addToCartError(e, i, s), s
                        }
                        else{
                          this.cartDrawerEnabled
                              ? (s && (s.classList.remove(classes$L.hidden, classes$L.loading), s.classList.add(classes$L.added), s.dispatchEvent(new CustomEvent("theme:product:add", { detail: { response: e, button: s }, bubbles: !0 }))),
                                o && (o.classList.remove(classes$L.hidden, classes$L.loading), o.classList.add(classes$L.added)),
                                this.getCart())
                              : (window.location = theme.routes.cart);
                        }
                    })
                    .catch((e) => {
                        this.addToCartError(e, i, s), this.enableCartButtons();
                    });
        }
        updateCart(e = {}, t = null, s = !1) {
            this.cart.classList.add(classes$L.loading);
            let i = null,
                o = null,
                r = null,
                a = e.quantity;
            null !== t && (a ? t.classList.add(classes$L.loading) : t.classList.add(classes$L.removed)),
                this.disableCartButtons(),
                fetch(theme.routes.root + "cart.js")
                    .then(this.cartErrorsHandler)
                    .then((e) => e.json())
                    .then((t) => {
                        var s;
                        const i = t.items.findIndex((t) => t.key === e.id);
                        (o = t.item_count), (r = null === (s = t.items[i]) || void 0 === s ? void 0 : s.title);
                        const n = { line: `${i + 1}`, quantity: a };
                        return fetch(theme.routes.root + "cart/change.js", { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify(n) });
                    })
                    .then(this.cartErrorsHandler)
                    .then((e) => e.json())
                    .then((e) => {
                        (i = e.item_count), s && (a = 1), 0 !== a && ((this.cartUpdateFailed = i === o), this.updateErrorText(r)), this.getCart();
                    })
                    .catch((e) => {
                        console.log(e), this.enableCartButtons();
                    });
        }
        disableCartButtons() {
            const e = this.cart.querySelectorAll("input"),
                t = this.cart.querySelectorAll(`button, ${selectors$U.cartItemRemove}`);
            e.length &&
                e.forEach((e) => {
                    e.classList.add(classes$L.disabled), e.blur(), (e.disabled = !0);
                }),
                t.length &&
                    t.forEach((e) => {
                        e.setAttribute(attributes$j.disabled, !0);
                    });
        }
        enableCartButtons() {
            const e = this.cart.querySelectorAll("input"),
                t = this.cart.querySelectorAll(`button, ${selectors$U.cartItemRemove}`);
            e.length &&
                e.forEach((e) => {
                    e.classList.remove(classes$L.disabled), (e.disabled = !1);
                }),
                t.length &&
                    t.forEach((e) => {
                        e.removeAttribute(attributes$j.disabled);
                    }),
                this.cart.classList.remove(classes$L.loading);
        }
        updateErrorText(e) {
            this.cartErrorHolder.querySelector(selectors$U.errorMessage).innerText = e;
        }
        toggleErrorMessage() {
            this.cartErrorHolder && (this.cartUpdateFailed ? this.cartErrorHolder.classList.add(classes$L.expanded) : this.cartErrorHolder.classList.remove(classes$L.expanded), (this.cartUpdateFailed = !1));
        }
        cartErrorsHandler(e) {
            return e.ok
                ? e
                : e.json().then(function (t) {
                      throw new FetchError({ status: e.statusText, headers: e.headers, json: t });
                  });
        }
        addToCartError(e, t, s) {
            if ((this.cartDrawerEnabled && s && null !== s.closest(selectors$U.cartDrawer) && !s.closest(selectors$U.cartDrawer) && this.closeCartDrawer(), null !== s)) {
                const t = s.closest(selectors$U.outerSection) || s.closest(selectors$U.quickAddHolder) || s.closest(selectors$U.quickAddModal);
                let i = null == t ? void 0 : t.querySelector(selectors$U.formErrorsContainer);
                const o = s.closest(selectors$U.quickAddHolder);
                o && o.querySelector(selectors$U.formErrorsContainer) && (i = o.querySelector(selectors$U.formErrorsContainer)),
                    i &&
                        ((i.innerHTML = `<div class="errors">${e.message}: ${e.description}<span class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></div>`),
                        i.classList.add(classes$L.visible)),
                    s.dispatchEvent(new CustomEvent("theme:product:add-error", { detail: { response: e }, bubbles: !0 }));
            }
            t && t.dispatchEvent(new CustomEvent("theme:cart:error", { bubbles: !0, detail: { message: e.message, description: e.description, holder: t } }));

          const formErrorsContainer = document.querySelector(selectors$U.formErrorsContainer);
          if (formErrorsContainer) {
              formErrorsContainer.classList.add(classes$L.visible);
              setTimeout(() => {
                  formErrorsContainer.classList.remove(classes$L.visible);
              }, 7000);
          }
        }
        productAddCallback(e) {
            if (theme.settings.cartDrawerEnabled) {
                let t = [],
                    s = null,
                    i = null;
                const o = "theme:product:add-error" == e.type,
                    r = e.target,
                    a = document.querySelector(selectors$U.cartBarAdd);
                t.push(r),
                    (s = r.closest(selectors$U.quickAddHolder)),
                    s && ((i = s.querySelector(selectors$U.buttonQuickAddMobile)), i && t.push(i)),
                    a && t.push(a),
                    t.forEach((e) => {
                        e.classList.remove(classes$L.loading), o || e.classList.add(classes$L.added);
                    }),
                    setTimeout(() => {
                        t.forEach((e) => {
                            e.classList.remove(classes$L.added), (e.disabled = !1);
                        }),
                            s && s.classList.remove(classes$L.visible);
                    }, settings$3.times.timeoutButtonReset);
            }
        }
        openCartDrawerOnProductAdded() {
            this.cartDrawer && !this.cartDrawerIsOpen && this.openCartDrawer();
        }
        openCartDrawer() {
            this.cartDrawer &&
                ((this.cartDrawerIsOpen = !0),
                document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: !0 })),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawer })),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawerBody })),
                this.cartDrawer.classList.add(classes$L.open),
                this.observeAdditionalCheckoutButtons(),
                this.requestItemsAnimationFrame(),
                this.accessibility.trapFocus(this.cartDrawer, { elementToFocus: this.cartDrawer.querySelector(selectors$U.cartToggleElement) }));
        }
        closeCartDrawer() {
            if (this.cartDrawer && this.cartDrawer.classList.contains(classes$L.open)) {
                if (
                    ((this.cartDrawerIsOpen = !1),
                    document.dispatchEvent(new CustomEvent("theme:cart:close", { bubbles: !0 })),
                    this.resetAnimatedItems(),
                    this.itemsHolder.classList.remove(classes$L.updated),
                    this.cartEmpty.classList.remove(classes$L.updated),
                    this.cartErrorHolder.classList.remove(classes$L.expanded),
                    this.cartDrawer.querySelectorAll(selectors$U.animation).forEach((e) => {
                        const t = () => {
                            e.classList.remove(classes$L.hiding), e.removeEventListener("animationend", t);
                        };
                        e.classList.add(classes$L.hiding), e.addEventListener("animationend", t);
                    }),
                    this.cartDrawer.classList.remove(classes$L.open),
                    this.accessibility.removeTrapFocus(),
                    this.body.classList.contains(classes$L.focused))
                ) {
                    const e = this.headerWrapper.querySelectorAll(`${selectors$U.cartToggleElement}`);
                    e.length &&
                        e.forEach((e) => {
                            if (isVisible(e))
                                return (
                                    setTimeout(() => {
                                        e.focus();
                                    }, 200),
                                    !0
                                );
                        });
                }
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
            }
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
        }
        cartToggleEvents() {
            document.addEventListener("click", (e) => {
                const t = e.target,
                    s = !(t.matches(selectors$U.cartToggleElement) || t.closest(selectors$U.cartToggleElement)),
                    i = !(t.matches(selectors$U.drawerUnderlay) || t.closest(selectors$U.drawerUnderlay)),
                    o = !(t.matches(selectors$U.cartDrawer) || t.closest(selectors$U.cartDrawer)) || !i,
                    r = !(t.matches(selectors$U.buttonSkipUpsellProduct) || t.closest(selectors$U.buttonSkipUpsellProduct));
                t.matches(selectors$U.cartToggleElement) || t.closest(selectors$U.cartToggleElement) ? (e.preventDefault(), this.toggleCartDrawer()) : this.cartDrawerIsOpen && s && o && r && this.closeCartDrawer();
            }),
                this.cartDrawer &&
                    this.cartDrawer.addEventListener("keyup", (e) => {
                        e.code === window.theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
                    });
        }
        toggleClassesOnContainers() {
            const e = this.hasItemsInCart();
            this.cartEmpty.classList.toggle(classes$L.hidden, e), this.buttonHolder.classList.toggle(classes$L.hidden, !e), this.itemsHolder.classList.toggle(classes$L.hidden, !e);
        }
        build(e) {
            const t = e.querySelector(selectors$U.apiLineItems),
                s = e.querySelector(selectors$U.apiUpsellItems);
            Boolean(null === t && null === s)
                ? ((this.itemsHolder.innerHTML = e), (this.upsellProductsHolder.innerHTML = ""))
                : ((this.itemsHolder.innerHTML = t.innerHTML), (this.upsellProductsHolder.innerHTML = s.innerHTML), this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility()),
                (this.cartTotal.innerHTML = 0 === this.subtotal ? window.theme.strings.free : themeCurrency.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
                this.cart.classList.remove(classes$L.loading),
                this.totalItems !== this.newTotalItems && ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
                this.cartDrawerIsOpen && this.itemsHolder.classList.add(classes$L.updated),
                this.hasItemsInCart() ||
                    this.cartEmpty.querySelectorAll(selectors$U.animation).forEach((e) => {
                        e.classList.remove(classes$L.animated);
                    }),
                this.freeShippingMessageHandle(this.subtotal),
                this.cartEvents(),
                this.initQuantity(),
                this.toggleErrorMessage(),
                this.enableCartButtons(),
                this.updateProgress(),
                document.dispatchEvent(new CustomEvent("theme:cart:loaded", { bubbles: !0 })),
                document.dispatchEvent(new CustomEvent("theme:product:added", { bubbles: !0 }));
        }
        hasItemsInCart() {
            return this.totalItems > 0;
        }
        buildTotalPrice(e) {
            if (
                (e.original_total_price > e.total_price && e.cart_level_discount_applications.length > 0
                    ? (this.cartOriginalTotal.classList.remove(classes$L.hidden),
                      (this.cartOriginaTotalPrice.innerHTML = 0 === e.original_total_price ? window.theme.strings.free : themeCurrency.formatMoney(e.original_total_price, theme.moneyFormat)))
                    : this.cartOriginalTotal.classList.add(classes$L.hidden),
                e.cart_level_discount_applications.length > 0)
            ) {
                const t = this.buildCartTotalDiscounts(e.cart_level_discount_applications);
                this.cartDiscountHolder.classList.remove(classes$L.hidden), (this.cartDiscountHolder.innerHTML = t);
            } else this.cartDiscountHolder.classList.add(classes$L.hidden);
        }
        buildCartTotalDiscounts(e) {
            let t = "";
            return (
                e.forEach((e) => {
                    const s = document.createElement("div");
                    (s.innerHTML = this.cartTotalDiscountTemplate),
                        (s.querySelector(selectors$U.cartTotalDiscountTitle).innerHTML = e.title),
                        (s.querySelector(selectors$U.cartTotalDiscountAmount).innerHTML = themeCurrency.formatMoney(e.total_allocated_amount, theme.moneyFormat)),
                        (t += s.innerHTML);
                }),
                t
            );
        }
        freeShippingMessageHandle(e) {
            this.freeShipping.length &&
                ((this.cartFreeShippingLimit = 100 * Number(this.freeShipping[0].getAttribute(attributes$j.freeShippingLimit)) * window.Shopify.currency.rate),
                this.freeShipping.forEach((t) => {
                    const s = t.hasAttribute(attributes$j.freeShipping) && "true" === t.getAttribute(attributes$j.freeShipping) && e >= 0;
                    t.classList.toggle(classes$L.success, s && e >= this.cartFreeShippingLimit);
                }));
        }
        updateProgress() {
            if (((this.freeShipping = document.querySelectorAll(selectors$U.freeShipping)), !this.freeShipping.length)) return;
            const e = isNaN(this.subtotal / this.cartFreeShippingLimit) ? 100 : this.subtotal / this.cartFreeShippingLimit,
                t = Math.min(100 * e, 100),
                s = this.circumference - ((t / 100) * this.circumference) / 2,
                i = themeCurrency.formatMoney(this.cartFreeShippingLimit - this.subtotal, theme.moneyFormat);
            this.freeShipping.forEach((e) => {
                const o = e.querySelector(selectors$U.freeShippingProgress),
                    r = e.querySelector(selectors$U.freeShippingGraph),
                    a = e.querySelector(selectors$U.leftToSpend);
                a && (a.innerHTML = i.replace(".00", "").replace(",00", "")), o && (o.value = t), r && r.style.setProperty("--stroke-dashoffset", `${s}`);
            });
        }
        skipUpsellProductEvent() {
            if (null === this.upsellProductsHolder) return;
            const e = this.upsellProductsHolder.querySelectorAll(selectors$U.buttonSkipUpsellProduct);
            e.length &&
                e.forEach((e) => {
                    e.addEventListener("click", (t) => {
                        t.preventDefault();
                        const s = e.closest(selectors$U.quickAddHolder).getAttribute(attributes$j.quickAddHolder);
                        this.skipUpsellProductsArray.includes(s) || this.skipUpsellProductsArray.push(s),
                            window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray),
                            this.removeUpsellProduct(s),
                            this.toggleCartUpsellWidgetVisibility();
                    });
                });
        }
        checkSkippedUpsellProductsFromStorage() {
            const e = window.sessionStorage.getItem("skip_upsell_products");
            if (!e) return;
            e.split(",").forEach((e) => {
                this.skipUpsellProductsArray.includes(e) || this.skipUpsellProductsArray.push(e), this.removeUpsellProduct(e);
            });
        }
        removeUpsellProduct(e) {
            if (!this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelector(`[${attributes$j.quickAddHolder}="${e}"]`);
            t && t.parentNode.remove();
        }
        toggleCartUpsellWidgetVisibility() {
            if (!this.upsellProductsHolder) return;
            const e = this.upsellProductsHolder.querySelectorAll(selectors$U.quickAddHolder),
                t = this.upsellProductsHolder.closest(selectors$U.cartWidget);
            if (!t) return;
            const s = t.querySelector(selectors$U.expandButton),
                i = t.querySelector(selectors$U.cartWidgetContent);
            t.classList.toggle(classes$L.hidden, !e.length),
                this.cartDrawer && this.cartDrawerIsOpen && t.classList.toggle(classes$L.animated, e.length),
                s && s.classList.toggle(classes$L.active, e.length),
                i && i.classList.toggle(classes$L.expanded, e.length);
        }
        observeAdditionalCheckoutButtons() {
            const e = this.cartDrawer.querySelector(selectors$U.additionalCheckoutButtons);
            if (e) {
                const t = new MutationObserver(() => {
                    this.accessibility.trapFocus(this.cartDrawer, { elementToFocus: this.cartDrawer.querySelector(selectors$U.cartToggleElement) }), t.disconnect();
                });
                t.observe(e, { subtree: !0, childList: !0 });
            }
        }
        resetAnimatedItems() {
            this.cart.querySelectorAll(selectors$U.animation).forEach((e) => {
                e.classList.remove(classes$L.animated), e.classList.remove(classes$L.hiding);
            });
        }
        requestItemsAnimationFrame() {
            requestAnimationFrame(this.animateItems);
        }
        animateItems() {
            this.cart.querySelectorAll(selectors$U.animation).forEach((e) => {
                e.classList.add(classes$L.animated);
            });
        }
        constructor() {
            window.location.pathname.endsWith("/password") || this.init();
        }
    };
    window.cart = new CartDrawer();
    const classes$K = { sliding: "is-sliding" },
        slideUp = (e, t = 500) => {
            e.classList.contains(classes$K.sliding) ||
                (e.classList.add(classes$K.sliding),
                (e.style.transitionProperty = "height, margin, padding"),
                (e.style.transitionDuration = t + "ms"),
                (e.style.boxSizing = "border-box"),
                (e.style.height = e.offsetHeight + "px"),
                e.offsetHeight,
                (e.style.overflow = "hidden"),
                (e.style.height = 0),
                (e.style.paddingTop = 0),
                (e.style.paddingBottom = 0),
                (e.style.marginTop = 0),
                (e.style.marginBottom = 0),
                window.setTimeout(() => {
                    (e.style.display = "none"),
                        e.style.removeProperty("height"),
                        e.style.removeProperty("padding-top"),
                        e.style.removeProperty("padding-bottom"),
                        e.style.removeProperty("margin-top"),
                        e.style.removeProperty("margin-bottom"),
                        e.style.removeProperty("overflow"),
                        e.style.removeProperty("transition-duration"),
                        e.style.removeProperty("transition-property"),
                        e.classList.remove(classes$K.sliding);
                }, t));
        },
        classes$J = { focus: "is-focused", open: "is-open", accordionToggle: "accordion-toggle", tabLink: "tab-link" },
        selectors$T = { inPageLink: "[data-skip-content]", linkesWithOnlyHash: 'a[href="#"]', triggerFocusElement: "[data-focus-element]", accordionContent: ".accordion-content", accordionToggle: "data-accordion-toggle" };
    let Accessibility = class {
        init() {
            (this.a11y = a11y),
                (this.html = document.documentElement),
                (this.body = document.body),
                (this.inPageLink = document.querySelector(selectors$T.inPageLink)),
                (this.linkesWithOnlyHash = document.querySelectorAll(selectors$T.linkesWithOnlyHash)),
                (this.lastFocused = null),
                (this.isFocused = !1),
                this.a11y.focusHash(),
                this.a11y.bindInPageLinks(),
                this.clickEvents(),
                this.focusEvents(),
                this.focusEventsOff(),
                this.closeExpandedElements();
        }
        clickEvents() {
            this.inPageLink &&
                this.inPageLink.addEventListener("click", (e) => {
                    e.preventDefault();
                }),
                this.linkesWithOnlyHash &&
                    this.linkesWithOnlyHash.forEach((e) => {
                        e.addEventListener("click", (e) => {
                            e.preventDefault();
                        });
                    });
        }
        focusEvents() {
            document.addEventListener("keyup", (e) => {
                e.code === window.theme.keyboardKeys.TAB && (this.body.classList.add(classes$J.focus), (this.isFocused = !0));
            }),
                document.addEventListener("keyup", (e) => {
                    if (!this.isFocused) return;
                    const t = e.target,
                        s = e.code === window.theme.keyboardKeys.ENTER || e.code === window.theme.keyboardKeys.SPACE,
                        i = t.matches(selectors$T.triggerFocusElement) || t.closest(selectors$T.triggerFocusElement),
                        o =
                            t.classList.contains(classes$J.accordionToggle) ||
                            t.parentNode.classList.contains(classes$J.accordionToggle) ||
                            t.hasAttribute(selectors$T.accordionToggle) ||
                            t.parentNode.hasAttribute(selectors$T.accordionToggle),
                        r = t.classList.contains(classes$J.tabLink) || t.parentNode.classList.contains(classes$J.tabLink);
                    s && i && (null === this.lastFocused && (this.lastFocused = t), o && t.click(), r && t.click());
                }),
                document.addEventListener("theme:cart:add", (e) => {
                    this.lastFocused = e.detail.selector;
                });
        }
        focusEventsOff() {
            document.addEventListener("mousedown", () => {
                this.body.classList.remove(classes$J.focus), (this.isFocused = !1);
            });
        }
        closeExpandedElements() {
            document.addEventListener("keyup", (e) => {
                if (e.code !== window.theme.keyboardKeys.ESCAPE) return;
                const t = document.querySelectorAll(selectors$T.accordionContent);
                if (t.length)
                    for (let e = 0; e < t.length; e++) {
                        if ("block" !== t[e].style.display) continue;
                        t[e].previousElementSibling.classList.remove(classes$J.open), slideUp(t[e]);
                    }
                null !== this.lastFocused &&
                    setTimeout(() => {
                        this.lastFocused.focus(), (this.lastFocused = null);
                    }, 600);
            });
        }
        constructor() {
            this.init();
        }
    };
    window.accessibility = new Accessibility();
    const selectors$S = { inputSearch: 'input[type="search"]' };
    let MainSearch = class extends HeaderSearchForm {
        setupEventListeners() {
            let e = [];
            this.allSearchInputs.forEach((t) => e.push(t.form)),
                this.input.addEventListener("focus", this.onInputFocus.bind(this)),
                e.length < 2 || (e.forEach((e) => e.addEventListener("reset", this.onFormReset.bind(this))), this.allSearchInputs.forEach((e) => e.addEventListener("input", this.onInput.bind(this))));
        }
        onFormReset(e) {
            super.onFormReset(e), super.shouldResetForm() && this.keepInSync("", this.input);
        }
        onInput(e) {
            const t = e.target;
            this.keepInSync(t.value, t);
        }
        onInputFocus() {
            isDesktop() || this.scrollIntoView({ behavior: "smooth" });
        }
        keepInSync(e, t) {
            this.allSearchInputs.forEach((s) => {
                s !== t && (s.value = e);
            });
        }
        constructor() {
            super(), (this.allSearchInputs = document.querySelectorAll(selectors$S.inputSearch)), this.setupEventListeners();
        }
    };
    customElements.define("main-search", MainSearch);
    const selectors$R = { details: "details", popdown: "[data-popdown]", popdownClose: "[data-popdown-close]", popdownToggle: "[data-popdown-toggle]", input: 'input:not([type="hidden"])' },
        attributes$i = { popdownUnderlay: "data-popdown-underlay" };
    let SearchPopdown = class extends HTMLElement {
        connectedCallback() {
            this.popdownContainer.addEventListener("keyup", (e) => "ESCAPE" === e.code.toUpperCase() && this.close()),
                this.popdownClose.addEventListener("click", this.close.bind(this)),
                this.popdownToggle.addEventListener("click", this.onPopdownToggleClick.bind(this)),
                this.popdownToggle.setAttribute("role", "button"),
                this.popdown.addEventListener("transitionend", (e) => {
                    "visibility" == e.propertyName && this.popdownContainer.hasAttribute("open") && "false" == this.popdownContainer.getAttribute("open") && this.popdownContainer.removeAttribute("open");
                });
        }
        onPopdownToggleClick(e) {
            e.preventDefault(), e.target.closest(selectors$R.details).hasAttribute("open") ? this.close() : this.open(e);
        }
        onBodyClick(e) {
            (this.contains(e.target) && !e.target.hasAttribute(attributes$i.popdownUnderlay)) || this.close();
        }
        open(e) {
            (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                e.target.closest(selectors$R.details).setAttribute("open", ""),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popdown })),
                requestAnimationFrame(() => {
                    e.target.closest(selectors$R.details).setAttribute("open", "true"), this.a11y.trapFocus(this.popdown, { elementToFocus: this.popdown.querySelector(selectors$R.input) });
                });
        }
        close() {
            this.a11y.removeTrapFocus(),
                this.popdownContainer.setAttribute("open", "false"),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        constructor() {
            super(),
                (this.popdown = this.querySelector(selectors$R.popdown)),
                (this.popdownContainer = this.querySelector(selectors$R.details)),
                (this.popdownToggle = this.querySelector(selectors$R.popdownToggle)),
                (this.popdownClose = this.querySelector(selectors$R.popdownClose)),
                (this.a11y = a11y);
        }
    };
    customElements.define("header-search-popdown", SearchPopdown),
        (theme.ProductModel = (function () {
            let e = {},
                t = {},
                s = {};
            const i = "[data-product-single-media-wrapper]",
                o = "[data-product-slideshow]",
                r = "[data-shopify-xr]",
                a = "data-media-id",
                n = "data-shopify-model3d-id",
                l = "#ModelJson-",
                c = "media--hidden",
                d = "[data-deferred-media]",
                h = "[data-deferred-media-button]",
                u = "is-loading";
            function p(e, i) {
                if (e.querySelector(d).getAttribute("loaded")) return;
                e.classList.add(u);
                const a = document.createElement("div");
                a.appendChild(e.querySelector("template").content.firstElementChild.cloneNode(!0));
                const n = a.querySelector("model-viewer"),
                    l = e.querySelector(d);
                l.appendChild(n).focus(), l.setAttribute("loaded", !0);
                const c = e.dataset.mediaId,
                    h = n.dataset.modelId,
                    p = e.closest(o).parentElement.querySelector(r);
                (s[i] = { element: p, defaultId: h }),
                    (t[c] = { modelId: h, mediaId: c, sectionId: i, container: e, element: n }),
                    window.Shopify.loadFeatures([
                        { name: "shopify-xr", version: "1.0", onLoad: m },
                        { name: "model-viewer-ui", version: "1.0", onLoad: g },
                    ]);
            }
            function m(t) {
                if (t) console.warn(t);
                else if (window.ShopifyXR) {
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            const s = e[t];
                            if (s.loaded) continue;
                            const i = document.querySelector(`${l}${t}`);
                            i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), (s.loaded = !0));
                        }
                    window.ShopifyXR.setupXRElements();
                } else
                    document.addEventListener("shopify_xr_initialized", function () {
                        m();
                    });
            }
            function g(e) {
                if (e) console.warn(e);
                else
                    for (const e in t)
                        if (t.hasOwnProperty(e)) {
                            const s = t[e];
                            s.modelViewerUi || (s.modelViewerUi = new Shopify.ModelViewerUI(s.element)), y(s);
                        }
            }
            function y(e) {
                const t = s[e.sectionId];
                e.container.addEventListener("theme:media:visible", function () {
                    t.element.setAttribute(n, e.modelId), b(e.mediaId), window.theme.touch || e.modelViewerUi.play();
                }),
                    e.container.addEventListener("theme:media:hidden", function () {
                        e.modelViewerUi.pause();
                    }),
                    e.container.addEventListener("xrLaunch", function () {
                        e.modelViewerUi.pause();
                    }),
                    e.element.addEventListener("load", () => {
                        e.container.classList.remove(u), b(e.mediaId);
                    }),
                    e.element.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
                        b(e.mediaId);
                    });
            }
            function b(e) {
                const t = `[${a}="${e}"]`,
                    s = document.querySelector(`${i}${t}`),
                    o = document.querySelectorAll(`${i}:not(${t})`);
                s.classList.remove(c),
                    o.length &&
                        o.forEach((e) => {
                            e.dispatchEvent(new CustomEvent("theme:media:hidden")), e.classList.add(c);
                        });
            }
            return {
                init: function (t, s) {
                    e[s] = { loaded: !1 };
                    const i = t.querySelector(h);
                    i && i.addEventListener("click", p.bind(this, t, s));
                },
                loadContent: p,
                removeSectionModels: function (s) {
                    for (const e in t)
                        if (t.hasOwnProperty(e)) {
                            t[e].sectionId === s && delete t[e];
                        }
                    delete e[s], delete theme.mediaInstances[s];
                },
            };
        })());
    const selectors$Q = {
            templateAddresses: ".template-addresses",
            addressNewForm: "#AddressNewForm",
            btnNew: ".address-new-toggle",
            btnEdit: ".address-edit-toggle",
            btnDelete: ".address-delete",
            dataFormId: "data-form-id",
            dataConfirmMessage: "data-confirm-message",
            editAddress: "#EditAddress",
            addressCountryNew: "AddressCountryNew",
            addressProvinceNew: "AddressProvinceNew",
            addressProvinceContainerNew: "AddressProvinceContainerNew",
            addressCountryOption: ".address-country-option",
            addressCountry: "AddressCountry",
            addressProvince: "AddressProvince",
            addressProvinceContainer: "AddressProvinceContainer",
        },
        classes$I = { hidden: "hidden" };
    let Addresses = class {
        init() {
            if (this.addressNewForm) {
                const e = this.section,
                    t = this.addressNewForm;
                this.customerAddresses();
                const s = e.querySelectorAll(selectors$Q.btnNew);
                s.length &&
                    s.forEach((e) => {
                        e.addEventListener("click", function () {
                            t.classList.toggle(classes$I.hidden);
                        });
                    });
                const i = e.querySelectorAll(selectors$Q.btnEdit);
                i.length &&
                    i.forEach((t) => {
                        t.addEventListener("click", function () {
                            const t = this.getAttribute(selectors$Q.dataFormId);
                            e.querySelector(`${selectors$Q.editAddress}_${t}`).classList.toggle(classes$I.hidden);
                        });
                    });
                const o = e.querySelectorAll(selectors$Q.btnDelete);
                o.length &&
                    o.forEach((e) => {
                        e.addEventListener("click", function () {
                            const e = this.getAttribute(selectors$Q.dataFormId),
                                t = this.getAttribute(selectors$Q.dataConfirmMessage);
                            confirm(t) && Shopify.postLink(window.theme.routes.addresses_url + "/" + e, { parameters: { _method: "delete" } });
                        });
                    });
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(selectors$Q.addressCountryNew, selectors$Q.addressProvinceNew, { hideElement: selectors$Q.addressProvinceContainerNew });
            this.section.querySelectorAll(selectors$Q.addressCountryOption).forEach((e) => {
                const t = e.getAttribute(selectors$Q.dataFormId),
                    s = `${selectors$Q.addressCountry}_${t}`,
                    i = `${selectors$Q.addressProvince}_${t}`,
                    o = `${selectors$Q.addressProvinceContainer}_${t}`;
                new Shopify.CountryProvinceSelector(s, i, { hideElement: o });
            });
        }
        constructor(e) {
            (this.section = e), (this.addressNewForm = this.section.querySelector(selectors$Q.addressNewForm)), this.init();
        }
    };
    const template$1 = document.querySelector(selectors$Q.templateAddresses);
    template$1 && new Addresses(template$1);
    const selectors$P = { accountTemplateLogged: ".customer-logged-in", account: ".account", accountSidebarMobile: ".account-sidebar--mobile" };
    let Account = class {
        init() {
            this.section.querySelector(selectors$P.account) && this.accountMobileSidebar();
        }
        accountMobileSidebar() {
            this.section.querySelector(selectors$P.accountSidebarMobile) &&
                this.section.querySelector(selectors$P.accountSidebarMobile).addEventListener("click", function () {
                    const e = this.nextElementSibling;
                    e && "UL" === e.tagName && e.classList.toggle("visible");
                });
        }
        constructor(e) {
            (this.section = e), this.init();
        }
    };
    const template = document.querySelector(selectors$P.accountTemplateLogged);
    template && new Account(template);
    const selectors$O = {
        form: "[data-account-form]",
        showReset: "[data-show-reset]",
        hideReset: "[data-hide-reset]",
        recover: "[data-recover-password]",
        recoverSuccess: "[data-recover-success]",
        login: "[data-login-form]",
        recoverHash: "#recover",
        hideClass: "is-hidden",
    };
    let Login = class {
        init() {
            window.location.hash == selectors$O.recoverHash || this.recoverSuccess ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
                this.showButton.addEventListener(
                    "click",
                    function (e) {
                        e.preventDefault(), this.showRecoverPasswordForm();
                    }.bind(this),
                    !1
                ),
                this.hideButton.addEventListener(
                    "click",
                    function (e) {
                        e.preventDefault(), this.hideRecoverPasswordForm();
                    }.bind(this),
                    !1
                );
        }
        showRecoverPasswordForm() {
            return this.login.classList.add(selectors$O.hideClass), this.recover.classList.remove(selectors$O.hideClass), (window.location.hash = selectors$O.recoverHash), !1;
        }
        hideRecoverPasswordForm() {
            return this.recover.classList.add(selectors$O.hideClass), this.login.classList.remove(selectors$O.hideClass), (window.location.hash = ""), !1;
        }
        constructor(e) {
            (this.form = e),
                (this.showButton = e.querySelector(selectors$O.showReset)),
                (this.hideButton = e.querySelector(selectors$O.hideReset)),
                (this.recover = e.querySelector(selectors$O.recover)),
                (this.recoverSuccess = e.querySelector(selectors$O.recoverSuccess)),
                (this.login = e.querySelector(selectors$O.login)),
                this.init();
        }
    };
    const loginForm = document.querySelector(selectors$O.form);
    loginForm && new Login(loginForm),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const registered = window.Shopify.theme.sections.registered,
        instances = window.Shopify.theme.sections.instances,
        selectors$N = { id: "data-section-id", type: "data-section-type" };
    let Registration = class {
            getStack() {
                return this.callStack;
            }
            constructor(e = null, t = []) {
                (this.type = e),
                    (this.components = validateComponentsArray(t)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    t.forEach((e) => {
                        for (const [t, s] of Object.entries(e)) {
                            const e = this.callStack[t];
                            Array.isArray(e) && "function" == typeof s ? e.push(s) : (console.warn(`Unregisted function: '${t}' in component: '${this.type}'`), console.warn(s));
                        }
                    });
            }
        },
        Section = class {
            callFunctions(e, t = null) {
                this.callStack[e].forEach((e) => {
                    const s = { id: this.id, type: this.type, container: this.container };
                    t ? e.call(s, t) : e.call(s);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(e) {
                this.callFunctions("onSelect", e);
            }
            onDeselect(e) {
                this.callFunctions("onDeselect", e);
            }
            onBlockSelect(e) {
                this.callFunctions("onBlockSelect", e);
            }
            onBlockDeselect(e) {
                this.callFunctions("onBlockDeselect", e);
            }
            onReorder(e) {
                this.callFunctions("onReorder", e);
            }
            constructor(e, t) {
                (this.container = validateContainerElement(e)), (this.id = e.getAttribute(selectors$N.id)), (this.type = t.type), (this.callStack = t.getStack());
                try {
                    this.onLoad();
                } catch (e) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(e);
                }
            }
        };
    function validateContainerElement(e) {
        if (!(e instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
        if (null === e.getAttribute(selectors$N.id)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + selectors$N.id + " attribute.");
        return e;
    }
    function validateComponentsArray(e) {
        if ((void 0 !== e && "object" != typeof e) || null === e) throw new TypeError("Theme Sections: The components object provided is not a valid");
        return e;
    }
    function register(e, t) {
        if ("string" != typeof e) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== registered[e]) throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(t) || (t = [t]);
        const s = new Registration(e, t);
        return (registered[e] = s), registered;
    }
    function load(e, t) {
        (e = normalizeType(e)),
            void 0 === t && (t = document.querySelectorAll("[" + selectors$N.type + "]")),
            (t = normalizeContainers(t)),
            e.forEach(function (e) {
                const s = registered[e];
                void 0 !== s &&
                    (t = t.filter(function (t) {
                        return !isInstance(t) && null !== t.getAttribute(selectors$N.type) && (t.getAttribute(selectors$N.type) !== e || (instances.push(new Section(t, s)), !1));
                    }));
            });
    }
    function reorder(e) {
        getInstances(e).forEach(function (e) {
            e.onReorder();
        });
    }
    function unload(e) {
        getInstances(e).forEach(function (e) {
            var t = instances
                .map(function (e) {
                    return e.id;
                })
                .indexOf(e.id);
            instances.splice(t, 1), e.onUnload();
        });
    }
    function getInstances(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var s = e[0];
        if (e instanceof Element || s instanceof Element)
            normalizeContainers(e).forEach(function (e) {
                t = t.concat(
                    instances.filter(function (t) {
                        return t.container === e;
                    })
                );
            });
        else if ("string" == typeof e || "string" == typeof s) {
            normalizeType(e).forEach(function (e) {
                t = t.concat(
                    instances.filter(function (t) {
                        return t.type === e;
                    })
                );
            });
        }
        return t;
    }
    function getInstanceById(e) {
        for (var t, s = 0; s < instances.length; s++)
            if (instances[s].id === e) {
                t = instances[s];
                break;
            }
        return t;
    }
    function isInstance(e) {
        return getInstances(e).length > 0;
    }
    function normalizeType(e) {
        return (
            "*" === e
                ? (e = Object.keys(registered))
                : "string" == typeof e
                ? (e = [e])
                : e.constructor === Section
                ? (e = [e.prototype.type])
                : Array.isArray(e) &&
                  e[0].constructor === Section &&
                  (e = e.map(function (e) {
                      return e.type;
                  })),
            (e = e.map(function (e) {
                return e.toLowerCase();
            }))
        );
    }
    function normalizeContainers(e) {
        return (
            NodeList.prototype.isPrototypeOf(e) && e.length > 0
                ? (e = Array.prototype.slice.call(e))
                : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e
                ? (e = [])
                : !Array.isArray(e) && e instanceof Element && (e = [e]),
            e
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (e) {
            var t = e.detail.sectionId,
                s = e.target.querySelector("[" + selectors$N.id + '="' + t + '"]');
            null !== s && load(s.getAttribute(selectors$N.type), s);
        }),
        document.addEventListener("shopify:section:reorder", function (e) {
            var t = e.detail.sectionId,
                s = e.target.querySelector("[" + selectors$N.id + '="' + t + '"]');
            "object" == typeof getInstances(s)[0] && reorder(s);
        }),
        document.addEventListener("shopify:section:unload", function (e) {
            var t = e.detail.sectionId,
                s = e.target.querySelector("[" + selectors$N.id + '="' + t + '"]');
            "object" == typeof getInstances(s)[0] && unload(s);
        }),
        document.addEventListener("shopify:section:select", function (e) {
            var t = getInstanceById(e.detail.sectionId);
            "object" == typeof t && t.onSelect(e);
        }),
        document.addEventListener("shopify:section:deselect", function (e) {
            var t = getInstanceById(e.detail.sectionId);
            "object" == typeof t && t.onDeselect(e);
        }),
        document.addEventListener("shopify:block:select", function (e) {
            var t = getInstanceById(e.detail.sectionId);
            "object" == typeof t && t.onBlockSelect(e);
        }),
        document.addEventListener("shopify:block:deselect", function (e) {
            var t = getInstanceById(e.detail.sectionId);
            "object" == typeof t && t.onBlockDeselect(e);
        }));
    const throttle = (e, t) => {
            let s, i;
            return function o(...r) {
                const a = Date.now();
                (i = clearTimeout(i)), !s || a - s >= t ? (e.apply(null, r), (s = a)) : (i = setTimeout(o.bind(null, ...r), t - (a - s)));
            };
        },
        selectors$M = { tooltip: "data-tooltip", tooltipStopMouseEnter: "data-tooltip-stop-mouseenter" },
        classes$H = { tooltipDefault: "tooltip-default", visible: "is-visible", hiding: "is-hiding" };
    let sections$s = {},
        Tooltip = class {
            init() {
                if (!document.querySelector(`.${this.class}`)) {
                    const e = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
                        t = document.createElement("div");
                    (t.className = this.class), (t.innerHTML = e), document.body.appendChild(t);
                }
                this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
                    this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
                    this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
                    document.addEventListener("theme:tooltip:close", this.removePinEvent);
            }
            addPin(e = !1) {
                const t = document.querySelector(`.${this.class}`);
                if (t && ((e && !this.tooltip.hasAttribute(selectors$M.tooltipStopMouseEnter)) || !e)) {
                    const e = t.querySelector(`.${this.class}__arrow`),
                        s = t.querySelector(`.${this.class}__inner`);
                    t.querySelector(`.${this.class}__text`).textContent = this.label;
                    const i = s.offsetWidth,
                        o = this.tooltip.getBoundingClientRect(),
                        r = o.top,
                        a = o.width,
                        n = r + o.height + window.scrollY;
                    let l = o.left - i / 2 + a / 2;
                    const c = l + i - getWindowWidth();
                    c > 0 && (l -= c),
                        l < 0 && (l = 0),
                        (e.style.left = `${o.left + a / 2}px`),
                        t.style.setProperty("--tooltip-top", `${n}px`),
                        (s.style.transform = `translateX(${l}px)`),
                        t.classList.remove(classes$H.hiding),
                        t.classList.add(classes$H.visible),
                        document.addEventListener("theme:scroll", this.removePinEvent);
                }
            }
            removePin(e, t = !1, s = !1) {
                const i = document.querySelector(`.${this.class}`),
                    o = i.classList.contains(classes$H.visible);
                i &&
                    ((t && !this.tooltip.hasAttribute(selectors$M.tooltipStopMouseEnter)) || !t) &&
                    (o &&
                        (s || e.detail.hideTransition) &&
                        (i.classList.add(classes$H.hiding),
                        this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                        (this.hideTransitionTimeout = setTimeout(() => {
                            i.classList.remove(classes$H.hiding);
                        }, this.transitionSpeed))),
                    i.classList.remove(classes$H.visible),
                    document.removeEventListener("theme:scroll", this.removePinEvent));
            }
            unload() {
                this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
                    this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent),
                    this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent),
                    document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                    document.removeEventListener("theme:scroll", this.removePinEvent);
            }
            constructor(e, t = {}) {
                (this.tooltip = e),
                    this.tooltip.hasAttribute(selectors$M.tooltip) &&
                        ((this.label = this.tooltip.getAttribute(selectors$M.tooltip)),
                        (this.class = t.class || classes$H.tooltipDefault),
                        (this.transitionSpeed = t.transitionSpeed || 200),
                        (this.hideTransitionTimeout = 0),
                        (this.addPinEvent = () => this.addPin()),
                        (this.addPinMouseEvent = () => this.addPin(!0)),
                        (this.removePinEvent = (e) => throttle(this.removePin(e), 50)),
                        (this.removePinMouseEvent = (e) => this.removePin(e, !0, !0)),
                        this.init());
            }
        };
    const tooltipSection = {
        onLoad() {
            sections$s[this.id] = [];
            this.container.querySelectorAll(`[${selectors$M.tooltip}]`).forEach((e) => {
                sections$s[this.id].push(new Tooltip(e));
            });
        },
        onUnload: function () {
            sections$s[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    };
    var sections$r = {};
    const parallaxHero = {
            onLoad() {
                sections$r[this.id] = [];
                this.container.querySelectorAll("[data-parallax-wrapper]").forEach((e) => {
                    const t = e.querySelector("[data-parallax-img]");
                    sections$r[this.id].push(new Rellax(t, { center: !0, round: !0, frame: e }));
                }),
                    window.addEventListener("load", () => {
                        sections$r[this.id].forEach((e) => {
                            "function" == typeof e.refresh && e.refresh();
                        });
                    });
            },
            onUnload: function () {
                sections$r[this.id].forEach((e) => {
                    "function" == typeof e.destroy && e.destroy();
                });
            },
        },
        classes$G = { sliding: "is-sliding" },
        slideDown = (e, t = 500, s = "block", i = !0) => {
            let o = window.getComputedStyle(e).display;
            if ((i && "none" !== o) || e.classList.contains(classes$G.sliding)) return;
            e.style.removeProperty("display"), "none" === o && (o = s), e.classList.add(classes$G.sliding), (e.style.display = o);
            let r = e.offsetHeight;
            (e.style.overflow = "hidden"),
                (e.style.height = 0),
                (e.style.paddingTop = 0),
                (e.style.paddingBottom = 0),
                (e.style.marginTop = 0),
                (e.style.marginBottom = 0),
                e.offsetHeight,
                (e.style.boxSizing = "border-box"),
                (e.style.transitionProperty = "height, margin, padding"),
                (e.style.transitionDuration = t + "ms"),
                (e.style.height = r + "px"),
                e.style.removeProperty("padding-top"),
                e.style.removeProperty("padding-bottom"),
                e.style.removeProperty("margin-top"),
                e.style.removeProperty("margin-bottom"),
                window.setTimeout(() => {
                    e.style.removeProperty("height"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property"), e.classList.remove(classes$G.sliding);
                }, t);
        },
        slideToggle = (e, t = 500, s = "block") => ("none" === window.getComputedStyle(e).display ? slideDown(e, t, s) : slideUp(e, t)),
        selectors$L = { accordionHolder: "[data-accordion-holder]", accordion: "[data-accordion]", accordionToggle: "[data-accordion-toggle]", accordionBody: "[data-accordion-body]" },
        attributes$h = { accordionExpandValue: "data-accordion-expand", accordionStopClose: "data-accordion-stop-close", accordionBlockValue: "data-block-id" },
        classes$F = { open: "is-open", sliding: "is-sliding" },
        sections$q = {};
    let GlobalAccordions = class {
        accordionEvents() {
            this.accordionToggles.forEach((e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault();
                    const s = e.parentElement.querySelector(selectors$L.accordionBody);
                    s && !s.classList.contains(classes$F.sliding) && this.onAccordionToggle(e, s);
                });
            }),
                "true" === this.accordion.getAttribute(attributes$h.accordionExpandValue) &&
                    (this.accordionToggles[0].classList.add(classes$F.open), (this.accordionToggles[0].ariaExpanded = "true"), showElement(this.accordionToggles[0].parentElement.querySelector(selectors$L.accordionBody)));
        }
        closeOtherAccordions(e, t = !0) {
            if (this.accordion.hasAttribute(attributes$h.accordionStopClose)) return;
            let s = [...this.accordionToggles];
            const i = this.container.closest(selectors$L.accordionHolder);
            i && (s = [...i.querySelectorAll(selectors$L.accordionToggle)]),
                s.filter((s) => {
                    const i = s.parentElement.querySelector(selectors$L.accordionBody);
                    s !== e && s.classList.contains(classes$F.open) && i && this.onAccordionClose(s, i, t);
                });
        }
        onAccordionOpen(e, t, s = !0) {
            e.classList.add(classes$F.open), (e.ariaExpanded = "true"), slideDown(t), this.closeOtherAccordions(e, s);
        }
        onAccordionClose(e, t, s = !0) {
            e.classList.remove(classes$F.open), (e.ariaExpanded = "false"), s ? slideUp(t) : hideElement(t);
        }
        onAccordionToggle(e, t) {
            e.classList.toggle(classes$F.open),
                (e.ariaExpanded = e.classList.contains(classes$F.open) ? "true" : "false"),
                slideToggle(t),
                this.closeOtherAccordions(e),
                e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } }));
        }
        onBlockToggle(e, t = !0) {
            const s = this.container.querySelector(`${selectors$L.accordionToggle}[${attributes$h.accordionBlockValue}="${e.detail.blockId}"]`);
            if (!s) return;
            const i = s.parentElement.querySelector(selectors$L.accordionBody);
            i && (t ? this.onAccordionOpen(s, i, !1) : this.onAccordionClose(s, i));
        }
        onSelectToggle(e = !0) {
            this.accordionBody &&
                this.accordionTogglesLength &&
                this.accordionTogglesLength < 2 &&
                (e ? this.onAccordionOpen(this.accordionToggles[0], this.accordionBody, !1) : this.onAccordionClose(this.accordionToggles[0], this.accordionBody));
        }
        onSelect() {
            this.onSelectToggle(!0);
        }
        onDeselect() {
            this.onSelectToggle(!1);
        }
        onBlockSelect(e) {
            this.onBlockToggle(e, !0);
        }
        onBlockDeselect(e) {
            this.onBlockToggle(e, !1);
        }
        constructor(e) {
            (this.container = e.container),
                (this.accordion = this.container.querySelector(selectors$L.accordion)),
                (this.accordionToggles = this.container.querySelectorAll(selectors$L.accordionToggle)),
                (this.accordionTogglesLength = this.accordionToggles.length),
                (this.accordionBody = this.container.querySelector(selectors$L.accordionBody)),
                this.accordionTogglesLength && this.accordionBody && this.accordionEvents();
        }
    };
    const accordions = {
        onLoad() {
            sections$q[this.id] = new GlobalAccordions(this);
        },
        onSelect() {
            sections$q[this.id].onSelect();
        },
        onDeselect() {
            sections$q[this.id].onDeselect();
        },
        onBlockSelect(e) {
            sections$q[this.id].onBlockSelect(e);
        },
        onBlockDeselect(e) {
            sections$q[this.id].onBlockDeselect(e);
        },
    };
    register("article", [tooltipSection, parallaxHero, accordions]);
    const selectors$K = {
            aos: "[data-aos]",
            collectionImage: ".collection-item__image",
            columnImage: "[data-column-image]",
            flickityNextArrow: ".flickity-button.next",
            flickityPrevArrow: ".flickity-button.previous",
            link: "a:not(.btn)",
            nextArrow: "[data-next-arrow]",
            prevArrow: "[data-prev-arrow]",
            productItemImage: ".product-item__image",
            slide: "[data-slide]",
            slideValue: "data-slide",
            slider: "[data-slider]",
            sliderThumb: "[data-slider-thumb]",
        },
        attributes$g = { arrowPositionMiddle: "data-arrow-position-middle", equalizeHeight: "data-equalize-height", slideIndex: "data-slide-index", sliderOptions: "data-options", slideTextColor: "data-slide-text-color" },
        classes$E = {
            aosAnimate: "aos-animate",
            desktop: "desktop",
            focused: "is-focused",
            flickityResize: "flickity-resize",
            flickityResizing: "flickity-resizing",
            flickityEnabled: "flickity-enabled",
            heroContentTransparent: "hero__content--transparent",
            initialized: "is-initialized",
            isLoading: "is-loading",
            isSelected: "is-selected",
            mobile: "mobile",
            sliderInitialized: "js-slider--initialized",
        },
        sections$p = {};
    let Slider = class {
        init() {
            this.slideshow.classList.add(classes$E.isLoading),
                (this.sliderOptions = {
                    contain: !0,
                    wrapAround: !0,
                    adaptiveHeight: !0,
                    ...this.customOptions,
                    on: {
                        ready: () => {
                            requestAnimationFrame(() => {
                                this.slideshow.classList.add(classes$E.initialized),
                                    this.slideshow.classList.remove(classes$E.isLoading),
                                    this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", { bubbles: !0, detail: { slider: this } }));
                            }),
                                this.slideActions(),
                                this.sliderOptions.prevNextButtons && this.positionArrows();
                        },
                        change: (e) => {
                            const t = this.slideshowSlides[e];
                            if (!t || this.sliderOptions.groupCells) return;
                            const s = t.querySelectorAll(selectors$K.aos);
                            s.length &&
                                s.forEach((e) => {
                                    e.classList.remove(classes$E.aosAnimate),
                                        requestAnimationFrame(() => {
                                            e.classList.add(classes$E.aosAnimate);
                                        });
                                });
                        },
                        resize: () => {
                            this.sliderOptions.prevNextButtons && this.positionArrows();
                        },
                    },
                }),
                this.sliderOptions.fade && (this.flkty = new FlickityFade(this.slideshow, this.sliderOptions)),
                this.sliderOptions.fade || (this.flkty = new Flickity(this.slideshow, this.sliderOptions)),
                this.isHeightEqualized && this.equalizeHeight(),
                this.sliderPrev &&
                    this.sliderPrev.addEventListener("click", (e) => {
                        e.preventDefault(), this.flkty.previous(!0);
                    }),
                this.sliderNext &&
                    this.sliderNext.addEventListener("click", (e) => {
                        e.preventDefault(), this.flkty.next(!0);
                    }),
                this.flkty.on("change", () => this.slideActions(!0)),
                this.addRemoveSlidesForDevices(),
                document.addEventListener("theme:resize", this.addRemoveSlidesForDevicesOnResize),
                this.multipleSlides && document.addEventListener("theme:resize", this.sliderCallbackEventOnResize),
                this.sliderThumbs.length &&
                    this.sliderThumbs.forEach((e) => {
                        e.addEventListener("click", (t) => {
                            t.preventDefault();
                            const s = [...e.parentElement.children].indexOf(e);
                            this.flkty.select(s);
                        });
                    }),
                this.container.addEventListener("theme:tab:change", this.resetSliderEvent);
        }
        resetSlider() {
            this.slideshow && (this.flkty && this.flkty.isActive ? this.flkty.select(0, !1, !0) : this.slideshow.scrollTo({ left: 0, behavior: "auto" }));
        }
        addRemoveSlidesForDevices() {
            if (
                ((this.hasDiffSlidesForMobileDesktop =
                    Array.prototype.filter.call(this.slideshowSlides, (e) => {
                        if (e.classList.contains(classes$E.desktop) || e.classList.contains(classes$E.mobile)) return e;
                    }).length > 0),
                !this.hasDiffSlidesForMobileDesktop)
            )
                return;
            let e = null;
            (e = isDesktop() ? `${selectors$K.slide}.${classes$E.desktop}, ${selectors$K.slide}:not(.${classes$E.mobile})` : `${selectors$K.slide}.${classes$E.mobile}, ${selectors$K.slide}:not(.${classes$E.desktop})`),
                (this.flkty.options.cellSelector = e),
                this.flkty.selectCell(0, !1, !0),
                this.flkty.reloadCells(),
                this.flkty.reposition(),
                this.flkty.resize(),
                this.slideActions();
        }
        sliderCallbackEvent() {
            this.multipleSlides && (this.flkty.resize(), this.slideshow.classList.contains(classes$E.sliderInitialized) || this.flkty.select(0));
        }
        slideActions(e = !1) {
            const t = this.slideshow.querySelector(`.${classes$E.isSelected}`),
                s = t.getAttribute(attributes$g.slideTextColor),
                i = t.querySelector(selectors$K.link),
                o = this.slideshow.querySelectorAll(`${selectors$K.slide} a, ${selectors$K.slide} button`);
            if (
                (document.body.classList.contains(classes$E.focused) && i && this.sliderOptions.groupCells && e && i.focus(),
                o.length &&
                    o.forEach((e) => {
                        const t = e.closest(selectors$K.slide);
                        if (t) {
                            const s = t.classList.contains(classes$E.isSelected) ? 0 : -1;
                            e.setAttribute("tabindex", s);
                        }
                    }),
                "rgba(0,0,0,0)" !== s && "" !== s && this.slideshow.style.setProperty("--text", s),
                this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && t.hasAttribute(attributes$g.slideIndex))
            ) {
                const e = parseInt(t.getAttribute(attributes$g.slideIndex)),
                    s = this.container.querySelector(`${selectors$K.sliderThumb}.${classes$E.isSelected}`);
                s && s.classList.remove(classes$E.isSelected), this.sliderThumbs[e].classList.add(classes$E.isSelected);
            }
        }
        positionArrows() {
            if (this.slideshow.hasAttribute(attributes$g.arrowPositionMiddle) && this.sliderOptions.prevNextButtons) {
                const e = this.slideshow.querySelector(selectors$K.collectionImage) || this.slideshow.querySelector(selectors$K.productItemImage) || this.slideshow.querySelector(selectors$K.columnImage);
                if (!e) return;
                (this.slideshow.querySelector(selectors$K.flickityPrevArrow).style.top = e.clientHeight / 2 + "px"), (this.slideshow.querySelector(selectors$K.flickityNextArrow).style.top = e.clientHeight / 2 + "px");
            }
        }
        equalizeHeight() {
            (Flickity.prototype._createResizeClass = function () {
                requestAnimationFrame(() => {
                    this.element.classList.add(classes$E.flickityResize);
                });
            }),
                this.flkty._createResizeClass();
            const e = Flickity.prototype.resize;
            Flickity.prototype.resize = function () {
                this.element.classList.remove(classes$E.flickityResize),
                    this.element.classList.add(classes$E.flickityResizing),
                    e.call(this),
                    requestAnimationFrame(() => {
                        this.element.classList.add(classes$E.flickityResize), this.element.classList.remove(classes$E.flickityResizing);
                    });
            };
        }
        onUnload() {
            this.multipleSlides && document.removeEventListener("theme:resize", this.sliderCallbackEventOnResize),
                this.slideshow && this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy()),
                this.container.removeEventListener("theme:tab:change", this.resetSliderEvent),
                document.removeEventListener("theme:resize", this.addRemoveSlidesForDevicesOnResize);
        }
        onBlockSelect(e) {
            if (!this.slideshow) return;
            const t = this.slideshow.querySelector(`[${selectors$K.slideValue}="${e.detail.blockId}"]`);
            if (!t) return;
            let s = parseInt(t.getAttribute(attributes$g.slideIndex));
            this.multipleSlides && !this.slideshow.classList.contains(classes$E.sliderInitialized) && (s = 0),
                this.slideshow.classList.add(classes$E.isSelected),
                this.flkty && this.slideshow.classList.contains(classes$E.flickityEnabled) && (this.flkty.selectCell(s), this.flkty.stopPlayer());
        }
        onBlockDeselect() {
            this.slideshow && (this.slideshow.classList.remove(classes$E.isSelected), this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay && this.flkty.playPlayer());
        }
        constructor(e, t = null) {
            (this.container = e),
                (this.slideshow = t || this.container.querySelector(selectors$K.slider)),
                this.slideshow &&
                    ((this.slideshowSlides = this.slideshow.querySelectorAll(selectors$K.slide)),
                    this.slideshowSlides.length <= 1 ||
                        ((this.sliderPrev = this.container.querySelector(selectors$K.prevArrow)),
                        (this.sliderNext = this.container.querySelector(selectors$K.nextArrow)),
                        (this.sliderThumbs = this.container.querySelectorAll(selectors$K.sliderThumb)),
                        (this.multipleSlides = this.slideshow.hasAttribute(attributes$g.slidesLargeDesktop)),
                        (this.isHeightEqualized = "true" === this.slideshow.getAttribute(attributes$g.equalizeHeight)),
                        (this.sliderCallbackEventOnResize = () => this.sliderCallbackEvent()),
                        (this.addRemoveSlidesForDevicesOnResize = () => this.addRemoveSlidesForDevices()),
                        (this.resetSliderEvent = () => this.resetSlider()),
                        this.slideshow.hasAttribute(attributes$g.sliderOptions) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(attributes$g.sliderOptions)))),
                        (this.flkty = null),
                        this.init()));
        }
    };
    const slider = {
        onLoad() {
            sections$p[this.id] = [];
            this.container.querySelectorAll(selectors$K.slider).forEach((e) => {
                sections$p[this.id].push(new Slider(this.container, e));
            });
        },
        onUnload() {
            sections$p[this.id].forEach((e) => {
                "function" == typeof e.onUnload && e.onUnload();
            });
        },
        onBlockSelect(e) {
            sections$p[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
        onBlockDeselect(e) {
            sections$p[this.id].forEach((t) => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
            });
        },
    };
    register("blog-section", [slider]), register("hero", parallaxHero), register("double", slider);
    const selectors$J = {
            popoutWrapper: "[data-popout]",
            popoutList: "[data-popout-list]",
            popoutToggle: "[data-popout-toggle]",
            popoutToggleText: "[data-popout-toggle-text]",
            popoutToggleTextValue: "data-popout-toggle-text",
            popoutInput: "[data-popout-input]",
            popoutOptions: "[data-popout-option]",
            popoutPrevent: "data-popout-prevent",
            popoutQuantity: "data-quantity-field",
            dataValue: "data-value",
            ariaExpanded: "aria-expanded",
            ariaCurrent: "aria-current",
            productGridImage: "[data-product-image]",
            productGrid: "[data-product-grid-item]",
        },
        classes$D = { listVisible: "popout-list--visible", visible: "is-visible", active: "is-active", selectPopoutTop: "select-popout--top" };
    let sections$o = {},
        Popout = class {
            popupToggleClick(e) {
                const t = "true" === e.currentTarget.getAttribute(selectors$J.ariaExpanded);
                if (this.productGrid) {
                    const e = this.productGrid.querySelector(selectors$J.productGridImage);
                    e && e.classList.toggle(classes$D.visible, !t), (this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom - this.productGrid.getBoundingClientRect().bottom)}px`);
                }
                e.currentTarget.setAttribute(selectors$J.ariaExpanded, !t), this.popoutList.classList.toggle(classes$D.listVisible), this.popupListMaxWidth(), this.toggleListPosition();
            }
            popupToggleFocusout(e) {
                this.container.contains(e.relatedTarget) || this._hideList();
            }
            popupListFocusout(e) {
                const t = e.currentTarget.contains(e.relatedTarget);
                this.popoutList.classList.contains(classes$D.listVisible) && !t && this._hideList();
            }
            toggleListPosition() {
                const e = this.popoutList.closest(selectors$J.popoutWrapper),
                    t = "true" === e.querySelector(selectors$J.popoutToggle).getAttribute(selectors$J.ariaExpanded),
                    s = window.innerHeight,
                    i = this.popoutList.getBoundingClientRect().bottom,
                    o = () => {
                        e.classList.remove(classes$D.selectPopoutTop), this.popoutList.removeEventListener("transitionend", o);
                    };
                t ? s < i && e.classList.add(classes$D.selectPopoutTop) : this.popoutList.addEventListener("transitionend", o);
            }
            popupListMaxWidth() {
                this.popoutList.style.maxWidth = `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`;
            }
            popupOptionsClick(e) {
                if ("#" === e.target.closest(selectors$J.popoutOptions).attributes.href.value) {
                    e.preventDefault();
                  
                    let t = "";
                    if ((e.currentTarget.getAttribute(selectors$J.dataValue) && (t = e.currentTarget.getAttribute(selectors$J.dataValue)), (this.popoutInput.value = t), this.popoutPrevent)) {
                        const s = e.currentTarget.parentElement,
                            i = this.popoutList.querySelector(`.${classes$D.active}`),
                            o = this.popoutList.querySelector(`[${selectors$J.ariaCurrent}]`);
                        this.popoutInput.dispatchEvent(new Event("change")),
                            i && (i.classList.remove(classes$D.active), s.classList.add(classes$D.active)),
                            this.popoutInput.hasAttribute(selectors$J.popoutQuantity) && !s.nextSibling && this.container.classList.add(classes$D.active),
                            o && o.hasAttribute(`${selectors$J.ariaCurrent}`) && (o.removeAttribute(`${selectors$J.ariaCurrent}`), e.currentTarget.setAttribute(`${selectors$J.ariaCurrent}`, "true")),
                            "" !== t &&
                                ((this.popoutToggleText.textContent = t),
                                this.popoutToggleText.hasAttribute(selectors$J.popoutToggleTextValue) &&
                                    "" !== this.popoutToggleText.getAttribute(selectors$J.popoutToggleTextValue) &&
                                    this.popoutToggleText.setAttribute(selectors$J.popoutToggleTextValue, t)),
                            this.popupToggleFocusout(e),
                            this.popupListFocusout(e);
                    } else this._submitForm(t);
                }
            }
            containerKeyup(e) {
                e.code === window.theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
            }
            bodyClick(e) {
                const t = this.container.contains(e.target);
                this.popoutList.classList.contains(classes$D.listVisible) && !t && this._hideList();
            }
            unload() {
                document.body.removeEventListener("click", this.bodyClickEvent);
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
            }
            _connectOptions() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((e) => {
                        e.addEventListener("click", (e) => this.popupOptionsClick(e));
                    });
            }
            _onFocusOut() {
                this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent),
                    this.container.addEventListener("keyup", this.containerKeyupEvent),
                    document.body.addEventListener("click", this.bodyClickEvent);
            }
            _submitForm() {
                const e = this.container.closest("form");
                e && e.submit();
            }
            _hideList() {
                this.popoutList.classList.remove(classes$D.listVisible), this.popoutToggle.setAttribute(selectors$J.ariaExpanded, !1), this.toggleListPosition();
            }
            constructor(e) {
                (this.container = e),
                    (this.popoutList = this.container.querySelector(selectors$J.popoutList)),
                    (this.popoutToggle = this.container.querySelector(selectors$J.popoutToggle)),
                    (this.popoutToggleText = this.container.querySelector(selectors$J.popoutToggleText)),
                    (this.popoutInput = this.container.querySelector(selectors$J.popoutInput)),
                    (this.popoutOptions = this.container.querySelectorAll(selectors$J.popoutOptions)),
                    (this.productGrid = this.popoutList.closest(selectors$J.productGrid)),
                    (this.popoutPrevent = "true" === this.container.getAttribute(selectors$J.popoutPrevent)),
                    (this.popupToggleFocusoutEvent = (e) => this.popupToggleFocusout(e)),
                    (this.popupListFocusoutEvent = (e) => this.popupListFocusout(e)),
                    (this.popupToggleClickEvent = (e) => this.popupToggleClick(e)),
                    (this.containerKeyupEvent = (e) => this.containerKeyup(e)),
                    (this.bodyClickEvent = (e) => this.bodyClick(e)),
                    this._connectOptions(),
                    this._connectToggle(),
                    this._onFocusOut(),
                    this.popupListMaxWidth();
            }
        };
    const popoutSection = {
            onLoad() {
                sections$o[this.id] = [];
                this.container.querySelectorAll(selectors$J.popoutWrapper).forEach((e) => {
                    sections$o[this.id].push(new Popout(e));
                });
            },
            onUnload() {
                sections$o[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        selectors$I = { headerSticky: "[data-header-sticky]", headerHeight: "[data-header-height]" },
        scrollTo = (e) => {
            const t = document.querySelector(selectors$I.headerSticky) && document.querySelector(selectors$I.headerHeight) ? document.querySelector(selectors$I.headerHeight).getBoundingClientRect().height : 0;
            window.scrollTo({ top: e + window.scrollY - t, left: 0, behavior: "smooth" });
        };
    let PopupCookie = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((e) => e.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((e) => e.startsWith(this.name))) {
                return document.cookie
                    .split("; ")
                    .find((e) => e.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((e) => e.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
        }
        constructor(e, t, s) {
            (this.configuration = { expires: s, path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 }), (this.name = e), (this.value = t);
        }
    };
    const selectors$H = { newsletterForm: "[data-newsletter-form]", newsletterHeading: "[data-newsletter-heading]", newsletterPopup: "[data-newsletter]" },
        classes$C = { success: "has-success", error: "has-error", hidden: "hidden" },
        attributes$f = { cookieNameAttribute: "data-cookie-name" },
        sections$n = {};
    let NewsletterCheckForResult = class {
        init() {
            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
        }
        newsletterSubmitEvent(e) {
            this.stopSubmit && (e.preventDefault(), e.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
        }
        checkForChallengePage() {
            this.isChallengePage = "/challenge" === window.location.pathname;
        }
        writeStorage() {
            void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
        }
        readStorage() {
            this.formID = this.sessionStorage.getItem("newsletter_form_id");
        }
        removeStorage() {
            this.sessionStorage.removeItem("newsletter_form_id");
        }
        showMessage() {
            if ((this.readStorage(), this.newsletter.id === this.formID)) {
                const e = document.getElementById(this.formID),
                    t = e.parentElement.querySelector(selectors$H.newsletterHeading),
                    s = -1 !== window.location.search.indexOf("?customer_posted=true"),
                    i = -1 !== window.location.search.indexOf("accepts_marketing");
                s
                    ? (e.classList.remove(classes$C.error), e.classList.add(classes$C.success), t && (t.classList.add(classes$C.hidden), e.classList.remove(classes$C.hidden)), this.popup && this.cookie.write())
                    : i && (e.classList.remove(classes$C.success), e.classList.add(classes$C.error), t && (t.classList.add(classes$C.hidden), e.classList.remove(classes$C.hidden))),
                    (s || i) &&
                        window.addEventListener("load", () => {
                            this.scrollToForm(e);
                        });
            }
        }
        scrollToForm(e) {
            const t = e.getBoundingClientRect();
            (t.top >= 0 && t.left >= 0 && t.bottom <= getWindowHeight() && t.right <= getWindowWidth()) ||
                setTimeout(() => {
                    scrollTo(e.getBoundingClientRect().top);
                }, 500);
        }
        unload() {
            this.newsletter.removeEventListener("submit", this.newsletterSubmit);
        }
        constructor(e) {
            (this.sessionStorage = window.sessionStorage),
                (this.newsletter = e),
                (this.popup = this.newsletter.closest(selectors$H.newsletterPopup)),
                this.popup && (this.cookie = new PopupCookie(this.popup.getAttribute(attributes$f.cookieNameAttribute), "user_has_closed", null)),
                (this.stopSubmit = !0),
                (this.isChallengePage = !1),
                (this.formID = null),
                this.checkForChallengePage(),
                (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e)),
                this.isChallengePage || this.init();
        }
    };
    const newsletterCheckForResultSection = {
        onLoad() {
            sections$n[this.id] = [];
            this.container.querySelectorAll(selectors$H.newsletterForm).forEach((e) => {
                sections$n[this.id].push(new NewsletterCheckForResult(e));
            });
        },
        onUnload() {
            sections$n[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    };
    function Listeners() {
        this.entries = [];
    }
    function getVariantFromSerializedArray(e, t) {
        return _validateProductStructure(e), getVariantFromOptionArray(e, _createOptionArrayFromOptionCollection(e, t));
    }
    function getVariantFromOptionArray(e, t) {
        return (
            _validateProductStructure(e),
            _validateOptionsArray(t),
            e.variants.filter(function (e) {
                return t.every(function (t, s) {
                    return e.options[s] === t;
                });
            })[0] || null
        );
    }
    function _createOptionArrayFromOptionCollection(e, t) {
        _validateProductStructure(e), _validateSerializedArray(t);
        var s = [];
        return (
            t.forEach(function (t) {
                for (var i = 0; i < e.options.length; i++) {
                    if ((e.options[i].name || e.options[i]).toLowerCase() === t.name.toLowerCase()) {
                        s[i] = t.value;
                        break;
                    }
                }
            }),
            s
        );
    }
    function _validateProductStructure(e) {
        if ("object" != typeof e) throw new TypeError(e + " is not an object.");
        if (0 === Object.keys(e).length && e.constructor === Object) throw new Error(e + " is empty.");
    }
    function _validateSerializedArray(e) {
        if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
        if (0 === e.length) throw new Error(e + " is empty.");
        if (!e[0].hasOwnProperty("name")) throw new Error(e[0] + "does not contain name key.");
        if ("string" != typeof e[0].name) throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.");
    }
    function _validateOptionsArray(e) {
        if (Array.isArray(e) && "object" == typeof e[0]) throw new Error(e + "is not a valid array of options.");
    }
    register("footer", [popoutSection, parallaxHero, newsletterCheckForResultSection]),
        (Listeners.prototype.add = function (e, t, s) {
            this.entries.push({ element: e, event: t, fn: s }), e.addEventListener(t, s);
        }),
        (Listeners.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (e) {
                return e.element.removeEventListener(e.event, e.fn), !1;
            });
        });
    var selectors$G = { idInput: '[name="id"]', planInput: '[name="selling_plan"]', optionInput: '[name^="options"]', quantityInput: '[name="quantity"]', propertyInput: '[name^="properties"]' };
    function getUrlWithVariant(e, t) {
        return /variant=/.test(e) ? e.replace(/(variant=)[^&]+/, "$1" + t) : /\?/.test(e) ? e.concat("&variant=").concat(t) : e.concat("?variant=").concat(t);
    }
    let ProductForm = class {
        destroy() {
            this._listeners.removeAll();
        }
        options() {
            return this._serializeInputValues(this.optionInputs, function (e) {
                return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
            });
        }
        variant() {
            const e = this.options();
            return e.length ? getVariantFromSerializedArray(this.product, e) : this.product.variants[0];
        }
        plan(e) {
            let t = { allocation: null, group: null, detail: null };
            const s = this.element.querySelector(`${selectors$G.planInput}:checked`);
            if (!s) return null;
            const i = s.value,
                o = i && "" !== i ? i : null;
            return (
                o &&
                    e &&
                    (t.allocation = e.selling_plan_allocations.find(function (e) {
                        return e.selling_plan_id.toString() === o.toString();
                    })),
                t.allocation &&
                    (t.group = this.product.selling_plan_groups.find(function (e) {
                        return e.id.toString() === t.allocation.selling_plan_group_id.toString();
                    })),
                t.group &&
                    (t.detail = t.group.selling_plans.find(function (e) {
                        return e.id.toString() === o.toString();
                    })),
                t && t.allocation && t.detail && t.allocation ? t : null
            );
        }
        properties() {
            return this._serializeInputValues(this.propertyInputs, function (e) {
                return (e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2]), e;
            });
        }
        quantity() {
            return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
        }
        getFormState() {
            const e = this.variant();
            return { options: this.options(), variant: e, properties: this.properties(), quantity: this.quantity(), plan: this.plan(e) };
        }
        _setIdInputValue(e) {
            e && e.id ? (this.variantElement.value = e.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
        }
        _onSubmit(e, t) {
            (t.dataset = this.getFormState()), e.onFormSubmit && e.onFormSubmit(t);
        }
        _onOptionChange(e) {
            this._setIdInputValue(e.dataset.variant);
        }
        _onFormEvent(e) {
            return void 0 === e
                ? Function.prototype.bind()
                : function (t) {
                      (t.dataset = this.getFormState()), this._setIdInputValue(t.dataset.variant), e(t);
                  }.bind(this);
        }
        _initInputs(e, t) {
            return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
                function (e) {
                    return this._listeners.add(e, "change", this._onFormEvent(t)), e;
                }.bind(this)
            );
        }
        _serializeInputValues(e, t) {
            return e.reduce(function (e, s) {
                return (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) && e.push(t({ name: s.name, value: s.value })), e;
            }, []);
        }
        _validateProductObject(e) {
            if ("object" != typeof e) throw new TypeError(e + " is not an object.");
            if (void 0 === e.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
            return e;
        }
        constructor(e, t, s) {
            (this.element = e),
                (this.product = this._validateProductObject(t)),
                (this.variantElement = this.element.querySelector(selectors$G.idInput)),
                (s = s || {}),
                (this._listeners = new Listeners()),
                this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)),
                (this.optionInputs = this._initInputs(selectors$G.optionInput, s.onOptionChange)),
                (this.planInputs = this._initInputs(selectors$G.planInput, s.onPlanChange)),
                (this.quantityInputs = this._initInputs(selectors$G.quantityInput, s.onQuantityChange)),
                (this.propertyInputs = this._initInputs(selectors$G.propertyInput, s.onPropertyChange));
        }
    };
    function fetchProduct(e) {
        const t = `${window.theme.routes.root}products/${e}.js`;
        return window
            .fetch(t)
            .then((e) => e.json())
            .catch((e) => {
                console.error(e);
            });
    }
    function getScript(e, t, s) {
        let i = document.getElementsByTagName("head")[0],
            o = !1,
            r = document.createElement("script");
        (r.src = e),
            (r.onload = r.onreadystatechange = function () {
                o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? s() : ((o = !0), t());
            }),
            i.appendChild(r);
    }
    const loaders = {};
    function loadScript(e = {}) {
        if ((e.type || (e.type = "json"), e.url)) return loaders[e.url] ? loaders[e.url] : getScriptWithPromise(e.url, e.type);
        if (e.json)
            return loaders[e.json]
                ? Promise.resolve(loaders[e.json])
                : window
                      .fetch(e.json)
                      .then((e) => e.json())
                      .then((t) => ((loaders[e.json] = t), t));
        if (e.name) {
            const t = "".concat(e.name, e.version);
            return loaders[t] ? loaders[t] : loadShopifyWithPromise(e);
        }
        return Promise.reject();
    }
    function getScriptWithPromise(e, t) {
        const s = new Promise((s, i) => {
            "text" === t
                ? fetch(e)
                      .then((e) => e.text())
                      .then((e) => {
                          s(e);
                      })
                      .catch((e) => {
                          i(e);
                      })
                : getScript(
                      e,
                      function () {
                          s();
                      },
                      function () {
                          i();
                      }
                  );
        });
        return (loaders[e] = s), s;
    }
    function loadShopifyWithPromise(e) {
        const t = "".concat(e.name, e.version),
            s = new Promise((t, s) => {
                try {
                    window.Shopify.loadFeatures([
                        {
                            name: e.name,
                            version: e.version,
                            onLoad: (e) => {
                                onLoadFromShopify(t, s, e);
                            },
                        },
                    ]);
                } catch (e) {
                    s(e);
                }
            });
        return (loaders[t] = s), s;
    }
    function onLoadFromShopify(e, t, s) {
        return s ? t(s) : e();
    }
    (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
    const selectors$F = {
            scrollbarAttribute: "data-scrollbar",
            scrollbar: "data-scrollbar-slider",
            scrollbarSlideFullWidth: "data-scrollbar-slide-fullwidth",
            scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
            scrollbarArrowNext: "[data-scrollbar-arrow-next]",
        },
        classes$B = { hidden: "is-hidden" },
        settings$2 = { delay: 200 };
    let NativeScrollbar = class {
        init() {
            this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events());
        }
        resize() {
            document.addEventListener("theme:resize", () => {
                this.toggleNextArrow();
            });
        }
        events() {
            this.arrowNext.addEventListener("click", (e) => {
                e.preventDefault(), this.goToNext();
            }),
                this.arrowPrev.addEventListener("click", (e) => {
                    e.preventDefault(), this.goToPrev();
                }),
                this.scrollbar.addEventListener("scroll", () => {
                    this.togglePrevArrow(), this.toggleNextArrow();
                });
        }
        goToNext() {
            const e = (this.scrollbar.hasAttribute(selectors$F.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2) + this.scrollbar.scrollLeft;
            this.move(e), this.arrowPrev.classList.remove(classes$B.hidden), this.toggleNextArrow();
        }
        goToPrev() {
            const e = this.scrollbar.hasAttribute(selectors$F.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                t = this.scrollbar.scrollLeft - e;
            this.move(t), this.arrowNext.classList.remove(classes$B.hidden), this.togglePrevArrow();
        }
        toggleNextArrow() {
            setTimeout(() => {
                this.arrowNext.classList.toggle(classes$B.hidden, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
            }, settings$2.delay);
        }
        togglePrevArrow() {
            setTimeout(() => {
                this.arrowPrev.classList.toggle(classes$B.hidden, this.scrollbar.scrollLeft <= 0);
            }, settings$2.delay);
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault(), this.move(e.offsetLeft - e.clientWidth);
                });
            });
        }
        move(e) {
            this.scrollbar.scrollTo({ top: 0, left: e, behavior: "smooth" });
        }
        constructor(e) {
            (this.scrollbar = e),
                (this.arrowNext = this.scrollbar.parentNode.querySelector(selectors$F.scrollbarArrowNext)),
                (this.arrowPrev = this.scrollbar.parentNode.querySelector(selectors$F.scrollbarArrowPrev)),
                this.scrollbar.hasAttribute(selectors$F.scrollbarAttribute) && (this.init(), this.resize()),
                this.scrollbar.hasAttribute(selectors$F.scrollbar) && this.scrollToVisibleElement();
        }
    };
    const defaults = { color: "ash" },
        selectors$E = {
            gridSwatchForm: "[data-grid-swatch-form]",
            swatch: "data-swatch",
            outerGrid: "[data-product-grid-item]",
            slide: "[data-product-image]",
            image: "data-swatch-image",
            sectionId: "[data-section-id]",
            productInfo: "[data-product-information]",
            variant: "data-swatch-variant",
            variantName: "data-swatch-variant-name",
            variantTitle: "data-variant-title",
            button: "[data-swatch-button]",
            swatchLink: "[data-swatch-link]",
            wrapper: "[data-grid-swatches]",
            template: "[data-swatch-template]",
            handle: "data-swatch-handle",
            label: "data-swatch-label",
            input: "[data-swatch-input]",
            tooltip: "data-tooltip",
            swatchCount: "data-swatch-count",
            scrollbar: "data-scrollbar",
        },
        classes$A = { visible: "is-visible", stopEvents: "no-events" };
    let ColorMatch = class {
            getColor() {
                return this.match;
            }
            init() {
                return loadScript({ json: window.theme.assets.swatches })
                    .then((e) => this.matchColors(e, this.settings.color))
                    .catch((e) => {
                        console.log("failed to load swatch colors script"), console.log(e);
                    });
            }
            matchColors(e, t) {
                let s = "#E5E5E5",
                    i = null;
                const o = window.theme.assets.base || "/",
                    r = t.toLowerCase().replace(/\s/g, ""),
                    a = e.colors;
                if (a) {
                    let e = null;
                    if (
                        a.filter((t, s) => {
                            if (Object.keys(t).toString().toLowerCase().replace(/\s/g, "") === r) return (e = s), t;
                        }).length &&
                        null !== e
                    ) {
                        const t = Object.values(a[e])[0];
                        (s = t), (t.includes(".jpg") || t.includes(".jpeg") || t.includes(".png") || t.includes(".svg")) && ((i = `${o}${t}`), (s = "#888888"));
                    }
                }
                return { color: this.settings.color, path: i, hex: s };
            }
            constructor(e = {}) {
                (this.settings = { ...defaults, ...e }), (this.match = this.init());
            }
        },
        Swatch = class {
            init() {
                this.setStyles(), this.variant && this.handleEvents(), this.tooltip && new Tooltip(this.tooltip);
            }
            setStyles() {
                this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                    this.colorMatch.path &&
                        (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`),
                        this.element.style.setProperty("background-size", "cover"),
                        this.element.style.setProperty("background-position", "center center"));
            }
            handleEvents() {
                (this.outer = this.element.closest(selectors$E.outerGrid)),
                    this.outer &&
                        ((this.slide = this.outer.querySelector(selectors$E.slide)),
                        (this.button = this.element.closest(selectors$E.button)),
                        (this.imagesHidden = this.outer.querySelectorAll(`[${selectors$E.variantTitle}][style*="display: none;"]`)),
                        (this.outerHoverEvent = () => this.showHoverImages()),
                        (this.outerLeaveEvent = () => this.hideHoverImages()),
                        this.button.closest(selectors$E.gridSwatchForm) &&
                            this.button.addEventListener(
                                "mouseenter",
                                function () {
                                    this.changeImage();
                                }.bind(this)
                            ),
                        this.imagesHidden.length && (this.outer.addEventListener("mouseenter", this.outerHoverEvent), this.outer.addEventListener("mouseleave", this.outerLeaveEvent)));
            }
            showHoverImages() {
                this.imagesHidden.forEach((e) => {
                    e.style.removeProperty("display");
                }),
                    this.outer.removeEventListener("mouseenter", this.outerHoverEvent);
            }
            hideHoverImages() {
                var e;
                null === (e = this.slide.querySelectorAll(`.${classes$A.visible}`)) ||
                    void 0 === e ||
                    e.forEach((e) => {
                        e.classList.remove(classes$A.visible);
                    });
            }
            changeImage() {
                if (this.image) {
                    const e = this.variantName.replaceAll('"', "'"),
                        t = this.slide.querySelector(`[${selectors$E.variantTitle}="${e}"]`);
                    if (t) {
                        const e = this.slide.querySelector(`[${selectors$E.variantTitle}].${classes$A.visible}`);
                        e && e.classList.remove(classes$A.visible), t.classList.add(classes$A.visible);
                    }
                }
            }
            constructor(e) {
                (this.element = e),
                    (this.colorString = e.getAttribute(selectors$E.swatch)),
                    (this.image = e.getAttribute(selectors$E.image)),
                    (this.variant = e.getAttribute(selectors$E.variant)),
                    (this.variantName = e.getAttribute(selectors$E.variantName)),
                    (this.tooltip = this.element.closest(`[${selectors$E.tooltip}]`));
                new ColorMatch({ color: this.colorString }).getColor().then((e) => {
                    (this.colorMatch = e), this.init();
                });
            }
        },
        GridSwatch = class {
            init() {
                (this.wrap.innerHTML = ""),
                    (this.count = 0),
                    this.swatches.forEach((e) => {
                        let t = null,
                            s = !1,
                            i = "";
                        for (const s of this.product.variants) {
                            const o = s.options.includes(e);
                            if ((!t && o && (t = s), o && s.featured_media)) {
                                (i = s.featured_media.preview_image.src), (t = s);
                                break;
                            }
                        }
                        for (const t of this.product.variants) {
                            if (t.options.includes(e) && t.available) {
                                s = !0;
                                break;
                            }
                        }
                        if (t) {
                            const o = document.createElement("div");
                            o.innerHTML = this.template;
                            const r = o.querySelector(selectors$E.button),
                                a = o.querySelector(selectors$E.swatchLink),
                                n = t.title.replaceAll('"', "'");
                            (r.style = `--animation-delay: ${(100 * this.count) / 1e3}s`),
                                (r.dataset.tooltip = e),
                                (a.href = getUrlWithVariant(this.product.url, t.id)),
                                (a.innerText = e),
                                (a.dataset.swatch = e),
                                (a.dataset.swatchVariant = t.id),
                                (a.dataset.swatchVariantName = n),
                                (a.dataset.swatchImage = i),
                                (a.dataset.variant = t.id),
                                (a.disabled = !s),
                                (this.wrap.innerHTML += o.innerHTML),
                                this.count++;
                        }
                    }),
                    (this.swatchCount = this.productInfo.querySelector(`[${selectors$E.swatchCount}]`)),
                    (this.swatchElements = this.wrap.querySelectorAll(selectors$E.swatchLink)),
                    (this.swatchForm = this.productInfo.querySelector(selectors$E.gridSwatchForm)),
                    (this.hideSwatchesTimer = 0),
                    this.swatchCount.hasAttribute(selectors$E.swatchCount) &&
                        ((this.swatchCount.innerText = `${this.count} ${this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor}`),
                        this.swatchCount.addEventListener("mouseenter", () => {
                            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productInfo.classList.add(classes$A.stopEvents), this.swatchForm.classList.add(classes$A.visible);
                        }),
                        this.productInfo.addEventListener("mouseleave", () => {
                            this.hideSwatchesTimer = setTimeout(() => {
                                this.productInfo.classList.remove(classes$A.stopEvents), this.swatchForm.classList.remove(classes$A.visible);
                            }, 100);
                        })),
                    this.wrap.hasAttribute(selectors$E.scrollbar) && new NativeScrollbar(this.wrap),
                    this.swatchElements.forEach((e) => {
                        new Swatch(e);
                    });
            }
            constructor(e, t) {
                (this.container = t),
                    (this.wrap = e),
                    (this.outerGrid = e.closest(selectors$E.outerGrid)),
                    (this.productInfo = e.closest(selectors$E.productInfo)),
                    (this.template = document.querySelector(selectors$E.template).innerHTML),
                    (this.handle = e.getAttribute(selectors$E.handle)),
                    (this.sectionId = this.wrap.closest(selectors$E.sectionId).dataset.sectionId);
                const s = e.getAttribute(selectors$E.label).trim().toLowerCase();
                fetchProduct(this.handle).then((e) => {
                    (this.product = e),
                        (this.colorOption = e.options.find(function (e) {
                            return e.name.toLowerCase() === s || null;
                        })),
                        this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                });
            }
        };
    const makeGridSwatches = (e) => {
            e.container.querySelectorAll(selectors$E.wrapper).forEach((e) => {
                new GridSwatch(e, void 0);
            });
        },
        swatchSection = {
            onLoad() {
                this.swatches = [];
                this.container.querySelectorAll(`[${selectors$E.swatch}]`).forEach((e) => {
                    this.swatches.push(new Swatch(e));
                });
            },
        },
        swatchGridSection = {
            onLoad() {
                makeGridSwatches(this);
            },
        },
        selectors$D = {
            dataEnableSound: "data-enable-sound",
            dataEnableBackground: "data-enable-background",
            dataEnableAutoplay: "data-enable-autoplay",
            dataEnableLoop: "data-enable-loop",
            dataVideoId: "data-video-id",
            dataVideoType: "data-video-type",
            videoIframe: "[data-video-id]",
        },
        classes$z = { loaded: "loaded" };
    let LoadVideoVimeo = class {
        init() {
            this.loadVimeoPlayer();
        }
        loadVimeoPlayer() {
            const e = "https://vimeo.com/" + this.videoID;
            let t = "";
            const s = this.player,
                i = { url: e, background: this.enableBackground, muted: this.disableSound, autoplay: this.enableAutoplay, loop: this.enableLoop };
            for (let e in i) t += encodeURIComponent(e) + "=" + encodeURIComponent(i[e]) + "&";
            fetch(`https://vimeo.com/api/oembed.json?${t}`)
                .then((e) => e.json())
                .then(function (e) {
                    (s.innerHTML = e.html),
                        setTimeout(function () {
                            s.parentElement.classList.add(classes$z.loaded);
                        }, 1e3);
                })
                .catch(function (e) {
                    console.log(e);
                });
        }
        constructor(e) {
            (this.container = e),
                (this.player = this.container.querySelector(selectors$D.videoIframe)),
                this.player &&
                    ((this.videoID = this.player.getAttribute(selectors$D.dataVideoId)),
                    (this.videoType = this.player.getAttribute(selectors$D.dataVideoType)),
                    (this.enableBackground = "true" === this.player.getAttribute(selectors$D.dataEnableBackground)),
                    (this.disableSound = "false" === this.player.getAttribute(selectors$D.dataEnableSound)),
                    (this.enableAutoplay = "false" !== this.player.getAttribute(selectors$D.dataEnableAutoplay)),
                    (this.enableLoop = "false" !== this.player.getAttribute(selectors$D.dataEnableLoop)),
                    "vimeo" == this.videoType && this.init());
        }
    };
    const selectors$C = {
            dataSectionId: "data-section-id",
            dataEnableSound: "data-enable-sound",
            dataHideOptions: "data-hide-options",
            dataVideoId: "data-video-id",
            dataVideoType: "data-video-type",
            videoIframe: "[data-video-id]",
            videoWrapper: ".video-wrapper",
            youtubeWrapper: "[data-youtube-wrapper]",
        },
        classes$y = { loaded: "loaded" },
        players = [];
    let LoadVideoYT = class {
        init() {
            window.isYoutubeAPILoaded ? this.loadYoutubePlayer() : loadScript({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadYoutubePlayer());
        }
        loadYoutubePlayer() {
            const e = {
                ...{
                    height: "720",
                    width: "1280",
                    playerVars: this.videoOptionsVars,
                    events: {
                        onReady: (e) => {
                            const t = e.target.getIframe(),
                                s = t.id,
                                i = "true" === document.querySelector(`#${s}`).getAttribute(selectors$C.dataEnableSound);
                            t.setAttribute("tabindex", "-1"), i ? e.target.unMute() : e.target.mute(), e.target.playVideo();
                        },
                        onStateChange: (e) => {
                            0 == e.data && e.target.playVideo(), 1 == e.data && e.target.getIframe().parentElement.classList.add(classes$y.loaded);
                        },
                    },
                },
            };
            (e.videoId = this.videoID),
                this.videoID.length &&
                    YT.ready(() => {
                        players[this.playerID] = new YT.Player(this.playerID, e);
                    }),
                (window.isYoutubeAPILoaded = !0);
        }
        onUnload() {
            const e = "youtube-" + this.container.getAttribute(selectors$C.dataSectionId);
            players[e] && players[e].destroy();
        }
        constructor(e) {
            (this.container = e),
                (this.player = this.container.querySelector(selectors$C.videoIframe)),
                this.player &&
                    ((this.videoOptionsVars = {}),
                    (this.videoID = this.player.getAttribute(selectors$C.dataVideoId)),
                    (this.videoType = this.player.getAttribute(selectors$C.dataVideoType)),
                    "youtube" == this.videoType &&
                        ((this.playerID = this.player.querySelector(selectors$C.youtubeWrapper) ? this.player.querySelector(selectors$C.youtubeWrapper).id : this.player.id),
                        this.player.hasAttribute(selectors$C.dataHideOptions) &&
                            (this.videoOptionsVars = { cc_load_policy: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, autohide: 0, controls: 0, branding: 0, showinfo: 0, rel: 0, fs: 0, wmode: "opaque" }),
                        this.init(),
                        this.container.addEventListener(
                            "touchstart",
                            function (e) {
                                if (e.target.matches(selectors$C.videoWrapper) || e.target.closest(selectors$C.videoWrapper)) {
                                    const t = e.target.querySelector(selectors$C.videoIframe).id;
                                    players[t].playVideo();
                                }
                            },
                            { passive: !0 }
                        )));
        }
    };
    const selectors$B = {
            popupContainer: ".pswp",
            popupCloseBtn: ".pswp__custom-close",
            popupIframe: "iframe, video",
            popupCustomIframe: ".pswp__custom-iframe",
            popupThumbs: ".pswp__thumbs",
            popupButtons: ".pswp__button, .pswp__caption-close",
        },
        classes$x = { current: "is-current", customLoader: "pswp--custom-loader", customOpen: "pswp--custom-opening", loader: "pswp__loader", popupCloseButton: "pswp__button--close", isFocused: "is-focused" },
        attributes$e = { dataOptionClasses: "data-pswp-option-classes", dataVideoType: "data-video-type", ariaCurrent: "aria-current" },
        loaderHTML = `<div class="${classes$x.loader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    let LoadPhotoswipe = class {
        init() {
            this.pswpElement.classList.add(classes$x.customOpen),
                this.initLoader(),
                loadScript({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((e) => console.error(e));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(classes$x.customLoader) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(attributes$e.dataOptionClasses, this.options.mainClass);
                let e = document.createElement("div");
                (e.innerHTML = loaderHTML), (e = e.firstChild), this.pswpElement.appendChild(e);
            } else this.pswpElement.setAttribute(attributes$e.dataOptionClasses, "");
        }
        loadPopup() {
            const e = window.themePhotoswipe.PhotoSwipe.default,
                t = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(classes$x.customLoader) && this.pswpElement.classList.remove(classes$x.customLoader),
                this.pswpElement.classList.remove(classes$x.customOpen),
                (this.popup = new e(this.pswpElement, t, this.items, this.options)),
                this.popup.init(),
                this.initVideo(),
                this.thumbsActions(),
                this.isVideo && this.hideUnusedButtons(),
                setTimeout(() => {
                    this.a11y.trapFocus(this.pswpElement, { elementToFocus: this.closeBtn });
                }, 200),
                this.popup.listen("close", () => this.onClose()),
                this.options &&
                    this.options.closeElClasses &&
                    this.options.closeElClasses.length &&
                    this.options.closeElClasses.forEach((e) => {
                        const t = this.pswpElement.querySelector(`.pswp__${e}`);
                        t && t.addEventListener("keyup", this.keyupCloseEvent);
                    });
        }
        initVideo() {
            const e = this.pswpElement.querySelector(selectors$B.popupCustomIframe);
            if (e) {
                const t = e.getAttribute(attributes$e.dataVideoType);
                (this.isVideo = !0), "youtube" == t ? new LoadVideoYT(e.parentElement) : "vimeo" == t && new LoadVideoVimeo(e.parentElement);
            }
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.firstChild &&
                (this.popupThumbsContainer.addEventListener("wheel", (e) => this.stopDisabledScroll(e)),
                this.popupThumbsContainer.addEventListener("mousewheel", (e) => this.stopDisabledScroll(e)),
                this.popupThumbsContainer.addEventListener("DOMMouseScroll", (e) => this.stopDisabledScroll(e)),
                (this.popupThumbs = this.pswpElement.querySelectorAll(`${selectors$B.popupThumbs} > *`)),
                this.popupThumbs.forEach((e, t) => {
                    e.addEventListener("click", (s) => {
                        s.preventDefault();
                        const i = e.parentElement.querySelector(`.${classes$x.current}`);
                        i.classList.remove(classes$x.current), i.setAttribute(attributes$e.ariaCurrent, !1), e.classList.add(classes$x.current), e.setAttribute(attributes$e.ariaCurrent, !0), this.popup.goTo(t);
                    });
                }),
                this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
                this.popup.listen("beforeChange", () => this.setCurrentThumb()));
        }
        hideUnusedButtons() {
            const e = this.pswpElement.querySelectorAll(selectors$B.popupButtons);
            e.length &&
                e.forEach((e) => {
                    e.classList.contains(classes$x.popupCloseButton) || (e.style.display = "none");
                });
        }
        stopDisabledScroll(e) {
            e.stopPropagation();
        }
        keyupClose(e) {
            e.code === window.theme.keyboardKeys.ENTER && this.popup.close();
        }
        onClose() {
            const e = this.pswpElement.querySelector(selectors$B.popupIframe);
            if ((e && e.parentNode.removeChild(e), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                for (; this.popupThumbsContainer.firstChild; ) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(attributes$e.dataOptionClasses, "");
            const t = this.pswpElement.querySelector(`.${classes$x.loader}`);
            t && this.pswpElement.removeChild(t),
                this.options &&
                    this.options.closeElClasses &&
                    this.options.closeElClasses.length &&
                    this.options.closeElClasses.forEach((e) => {
                        const t = this.pswpElement.querySelector(`.pswp__${e}`);
                        t && t.removeEventListener("keyup", this.keyupCloseEvent);
                    }),
                this.a11y.removeTrapFocus(),
                window.accessibility.lastElement &&
                    document.body.classList.contains(classes$x.isFocused) &&
                    requestAnimationFrame(() => {
                        window.accessibility.lastElement.focus();
                    });
        }
        setCurrentThumb() {
            const e = this.pswpElement.querySelector(`${selectors$B.popupThumbs} > .${classes$x.current}`);
            if ((e && (e.classList.remove(classes$x.current), e.setAttribute(attributes$e.ariaCurrent, !1)), !this.popupThumbs)) return;
            const t = this.popupThumbs[this.popup.getCurrentIndex()];
            t.classList.add(classes$x.current), t.setAttribute(attributes$e.ariaCurrent, !0), this.scrollThumbs(t);
        }
        scrollThumbs(e) {
            const t = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                s = e.offsetLeft;
            if (t <= s + e.offsetWidth || t > s) {
                const t = parseInt(window.getComputedStyle(e).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: s - t, behavior: "smooth" });
            }
        }
        constructor(e, t = "") {
            (this.items = e),
                (this.pswpElement = document.querySelectorAll(selectors$B.popupContainer)[0]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.isVideo = !1),
                (this.popupThumbsContainer = this.pswpElement.querySelector(selectors$B.popupThumbs)),
                (this.closeBtn = this.pswpElement.querySelector(selectors$B.popupCloseBtn)),
                (this.keyupCloseEvent = (e) => this.keyupClose(e)),
                (this.a11y = a11y);
            (this.options = "" !== t ? t : { history: !1, focus: !1, mainClass: "" }), this.init();
        }
    };
    const selectors$A = {
            zoomWrapper: "[data-zoom-wrapper]",
            dataImageSrc: "data-image-src",
            dataImageWidth: "data-image-width",
            dataImageHeight: "data-image-height",
            dataImageAlt: "data-image-alt",
            dataImageZoomEnable: "data-image-zoom-enable",
            thumbs: ".pswp__thumbs",
            caption: "[data-zoom-caption]",
        },
        classes$w = {
            variantSoldOut: "variant--soldout",
            variantUnavailable: "variant--unavailable",
            popupThumb: "pswp__thumb",
            popupClass: "pswp-zoom-gallery",
            popupClassNoThumbs: "pswp-zoom-gallery--single",
            popupTitle: "product__title",
            popupTitleNew: "product__title pswp__title",
        };
    let Zoom = class {
        init() {
            this.zoomWrappers.length &&
                this.zoomWrappers.forEach((e, t) => {
                    e.addEventListener("click", (s) => {
                        s.preventDefault(), this.createZoom(t), (window.accessibility.lastElement = e);
                    }),
                        e.addEventListener("keyup", (s) => {
                            s.code === window.theme.keyboardKeys.ENTER && (s.preventDefault(), this.createZoom(t), (window.accessibility.lastElement = e));
                        });
                });
        }
        createZoom(e) {
            let t = [],
                s = 0,
                i = "";
            this.zoomWrappers.forEach((o) => {
                const r = o.getAttribute(selectors$A.dataImageSrc),
                    a = o.hasAttribute(selectors$A.dataImageAlt) ? o.getAttribute(selectors$A.dataImageAlt) : "";
                if (
                    ((s += 1),
                    t.push({ src: r, w: parseInt(o.getAttribute(selectors$A.dataImageWidth)), h: parseInt(o.getAttribute(selectors$A.dataImageHeight)), msrc: r }),
                    (i += `<a href="#" class="${classes$w.popupThumb}" style="background-image: url('${r}')" aria-label="${a}" aria-current="false"></a>`),
                    this.zoomWrappers.length === s)
                ) {
                    const o = {
                        history: !1,
                        focus: !1,
                        index: e,
                        mainClass: 1 === s ? `${classes$w.popupClass} ${classes$w.popupClassNoThumbs}` : `${classes$w.popupClass}`,
                        showHideOpacity: !0,
                        howAnimationDuration: 150,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !0,
                        closeEl: !0,
                        closeElClasses: ["caption-close", "title"],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                        addCaptionHTMLFn: (e, t, s) => {
                            this.zoomCaption(e, t, s);
                        },
                        getThumbBoundsFn: () => {
                            const t = this.zoomWrappers[e],
                                s = window.pageYOffset || document.documentElement.scrollTop,
                                i = t.getBoundingClientRect();
                            return { x: i.left, y: i.top + s, w: i.width };
                        },
                    };
                    new LoadPhotoswipe(t, o), this.thumbsContainer && "" !== i && (this.thumbsContainer.innerHTML = i);
                }
            });
        }
        zoomCaption(e, t) {
            let s = "";
            const i = t.children[0];
            return (
                this.zoomCaptionElem &&
                    ((s = this.zoomCaptionElem.innerHTML),
                    this.zoomCaptionElem.closest(`.${classes$w.variantSoldOut}`) ? i.classList.add(classes$w.variantSoldOut) : i.classList.remove(classes$w.variantSoldOut),
                    this.zoomCaptionElem.closest(`.${classes$w.variantUnavailable}`) ? i.classList.add(classes$w.variantUnavailable) : i.classList.remove(classes$w.variantUnavailable)),
                (s = s.replaceAll(classes$w.popupTitle, classes$w.popupTitleNew)),
                (i.innerHTML = s),
                !1
            );
        }
        constructor(e) {
            (this.container = e.container),
                (this.zoomWrappers = this.container.querySelectorAll(selectors$A.zoomWrapper)),
                (this.thumbsContainer = document.querySelector(selectors$A.thumbs)),
                (this.zoomCaptionElem = this.container.querySelector(selectors$A.caption)),
                (this.zoomEnable = "true" === this.container.getAttribute(selectors$A.dataImageZoomEnable)),
                this.zoomEnable && this.init();
        }
    };
    const hosts = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
        selectors$z = {
            deferredMedia: "[data-deferred-media]",
            deferredMediaButton: "[data-deferred-media-button]",
            productMediaWrapper: "[data-product-single-media-wrapper]",
            productMediaSlider: "[data-product-single-media-slider]",
            mediaContainer: "[data-video]",
            mediaId: "data-media-id",
            dataTallLayout: "data-tall-layout",
        },
        classes$v = { mediaHidden: "media--hidden" };
    theme.mediaInstances = {};
    let Video = class {
        init() {
            this.container.querySelectorAll(selectors$z.mediaContainer).forEach((e) => {
                const t = e.querySelector(selectors$z.deferredMediaButton);
                t && t.addEventListener("click", this.loadContent.bind(this, e));
            });
        }
        loadContent(e) {
            if (e.querySelector(selectors$z.deferredMedia).getAttribute("loaded")) return;
            const t = document.createElement("div");
            t.appendChild(e.querySelector("template").content.firstElementChild.cloneNode(!0));
            const s = e.dataset.mediaId,
                i = t.querySelector("video, iframe"),
                o = this.hostFromVideoElement(i),
                r = e.querySelector(selectors$z.deferredMedia);
            r.appendChild(i).focus(), r.setAttribute("loaded", !0), (this.players[s] = { mediaId: s, sectionId: this.id, container: e, element: i, host: o, ready: () => this.createPlayer(s) });
            const a = this.players[s];
            switch (a.host) {
                case hosts.html5:
                    this.loadVideo(a, hosts.html5);
                    break;
                case hosts.vimeo:
                    window.isVimeoAPILoaded ? this.loadVideo(a, hosts.vimeo) : loadScript({ url: "https://player.vimeo.com/api/player.js" }).then(() => this.loadVideo(a, hosts.vimeo));
                    break;
                case hosts.youtube:
                    window.isYoutubeAPILoaded ? this.loadVideo(a, hosts.youtube) : loadScript({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadVideo(a, hosts.youtube));
            }
        }
        hostFromVideoElement(e) {
            if ("VIDEO" === e.tagName) return hosts.html5;
            if ("IFRAME" === e.tagName) {
                if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e.src)) return hosts.youtube;
                if (e.src.includes("vimeo.com")) return hosts.vimeo;
            }
            return null;
        }
        loadVideo(e, t) {
            e.host === t && e.ready();
        }
        createPlayer(e) {
            const t = this.players[e];
            switch (t.host) {
                case hosts.html5:
                    t.element.play(),
                        t.element.addEventListener("play", () => this.pauseOtherMedia(e)),
                        t.element.play(),
                        t.container.addEventListener("theme:media:hidden", (e) => this.onHidden(e)),
                        t.container.addEventListener("xrLaunch", (e) => this.onHidden(e)),
                        t.container.addEventListener("theme:media:visible", (e) => this.onVisible(e)),
                        this.tallLayout && this.observeVideo(t, e);
                    break;
                case hosts.vimeo:
                    (this.players[e].player = new Vimeo.Player(t.element)),
                        this.players[e].player.play(),
                        (window.isVimeoAPILoaded = !0),
                        t.container.addEventListener("theme:media:hidden", (e) => this.onHidden(e)),
                        t.container.addEventListener("xrLaunch", (e) => this.onHidden(e)),
                        t.container.addEventListener("theme:media:visible", (e) => this.onVisible(e)),
                        this.tallLayout && this.observeVideo(t, e);
                    break;
                case hosts.youtube:
                    if (t.host == hosts.youtube && t.player) return;
                    YT.ready(() => {
                        const s = t.container.dataset.videoId;
                        (this.players[e].player = new YT.Player(t.element, { videoId: s, events: { onReady: (e) => e.target.playVideo() } })),
                            (window.isYoutubeAPILoaded = !0),
                            t.container.addEventListener("theme:media:hidden", (e) => this.onHidden(e)),
                            t.container.addEventListener("xrLaunch", (e) => this.onHidden(e)),
                            t.container.addEventListener("theme:media:visible", (e) => this.onVisible(e)),
                            this.tallLayout && this.observeVideo(t, e);
                    });
            }
        }
        observeVideo(e, t) {
            new IntersectionObserver(
                (s, i) => {
                    s.forEach((s) => {
                        1 != s.intersectionRatio ? this.pauseVideo(e) : (this.playVideo(e), this.pauseOtherMedia(t));
                    });
                },
                { threshold: 1 }
            ).observe(e.element);
        }
        playVideo(e) {
            e.player && e.player.playVideo ? e.player.playVideo() : e.element && e.element.play ? e.element.play() : e.player && e.player.play && e.player.play();
        }
        pauseVideo(e) {
            e.player && e.player.pauseVideo ? e.player.pauseVideo() : e.element && e.element.pause ? e.element.pause() : e.player && e.player.pause && e.player.pause();
        }
        onHidden(e) {
            void 0 !== e.target.dataset.mediaId && this.pauseVideo(this.players[e.target.dataset.mediaId]);
        }
        onVisible(e) {
            void 0 !== e.target.dataset.mediaId && this.playVideo(this.players[e.target.dataset.mediaId]);
        }
        pauseOtherMedia(e) {
            const t = `[${selectors$z.mediaId}="${e}"]`,
                s = document.querySelectorAll(`${selectors$z.productMediaWrapper}:not(${t})`);
            document.querySelector(`${selectors$z.productMediaWrapper}${t}`).classList.remove(classes$v.mediaHidden),
                s.length &&
                    s.forEach((e) => {
                        e.dispatchEvent(new CustomEvent("theme:media:hidden")), e.classList.add(classes$v.mediaHidden);
                    });
        }
        constructor(e) {
            (this.section = e), (this.container = e.container), (this.id = e.id), (this.tallLayout = "true" === this.container.getAttribute(selectors$z.dataTallLayout)), (this.players = {}), this.init();
        }
    };
    theme.mediaInstances = {};
    const selectors$y = { videoPlayer: "[data-video]", modelViewer: "[data-model]", sliderEnabled: "flickity-enabled" },
        classes$u = { mediaHidden: "media--hidden" };
    let Media = class {
        init() {
            this.detect3d(), this.launch3d(), new Video(this.section), new Zoom(this.section);
        }
        detect3d() {
            const e = this.container.querySelectorAll(selectors$y.modelViewer);
            e.length &&
                e.forEach((e) => {
                    theme.ProductModel.init(e, this.id);
                });
        }
        launch3d() {
            document.addEventListener("shopify_xr_launch", () => {
                this.container.querySelector(`${selectors$y.modelViewer}:not(.${classes$u.mediaHidden})`).dispatchEvent(new CustomEvent("xrLaunch"));
            });
        }
        constructor(e) {
            (this.section = e), (this.id = e.id), (this.container = e.container);
        }
    };
    const selectors$x = {
            productSlideshow: "[data-product-slideshow]",
            mobileSliderDisabled: "data-slideshow-disabled-mobile",
            productThumbs: "[data-product-thumbs]",
            sliderThumb: "[data-thumb-item]",
            dataTallLayout: "data-tall-layout",
            mediaType: "data-type",
            dataMediaId: "data-media-id",
            dataThumb: "data-thumb",
            dataThumbIndex: "data-thumb-index",
            deferredMediaButton: "[data-deferred-media-button]",
            ariaLabel: "aria-label",
            dataThumbnail: "[data-thumbnail]",
            productSlideThumb: ".js-product-slide-thumb",
            classSelected: ".is-active",
            thumbsSlider: "[data-thumbs-slider]",
            quickAddModal: "[data-quick-add-modal]",
            focusedElement: "[data-focus-element]",
            zoomElement: "[data-zoom-wrapper]",
        },
        classes$t = { active: "is-active", focused: "is-focused", dragging: "is-dragging", selected: "is-selected", sliderEnabled: "flickity-enabled", mediaHidden: "media--hidden" },
        attributes$d = { ariaCurrent: "aria-current", sliderOptions: "data-options" },
        thumbIcons = {
            model:
                '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
            video:
                '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
        };
    let sections$m = {},
        InitSlider = class {
            init() {
                this.slideshow &&
                    (this.tallLayout
                        ? this.mobileSliderDisabled || (this.initSliderMobile(), document.addEventListener("theme:resize:width", this.initSliderMobileEvent))
                        : this.mobileSliderDisabled
                        ? (this.initSliderDesktop(), document.addEventListener("theme:resize:width", this.initSliderDesktopEvent))
                        : this.createSlider());
            }
            initSliderMobile() {
                isMobile() ? this.createSlider() : this.destroySlider();
            }
            initSliderDesktop() {
                isMobile() ? this.destroySlider() : this.createSlider();
            }
            destroySlider() {
                this.slideshow.classList.contains(classes$t.sliderEnabled) && this.flkty.destroy(), this.thumbs && (this.thumbs.innerHTML = "");
            }
            createSlider() {
                if (!this.slideshow || (this.mobileSliderDisabled && isMobile())) return;
                const e = { autoPlay: !1, pageDots: !1, wrapAround: !0, ...this.customOptions },
                    t = this,
                    s = this.slideshow.querySelectorAll(`[${selectors$x.mediaType}]`)[0];
                let i = {
                    ...e,
                    on: {
                        ready: function () {
                            const e = this.element;
                            e.addEventListener("keyup", (t) => {
                                if (t.code === window.theme.keyboardKeys.ENTER) {
                                    const t = e.querySelector(`.${classes$t.selected} ${selectors$x.zoomElement}`);
                                    t && (t.dispatchEvent(new Event("click", { bubbles: !1 })), (window.accessibility.lastElement = e));
                                }
                            }),
                                t.sliderThumbs(this),
                                t.accessibilityActions(this);
                        },
                    },
                };
                if (((this.flkty = new FlickityFade(this.slideshow, i)), this.flkty.resize(), s)) {
                    const e = s.getAttribute(selectors$x.mediaType);
                    ("model" !== e && "video" !== e && "external_video" !== e) || ((this.flkty.options.draggable = !1), this.flkty.updateDraggable());
                }
                this.flkty.on("change", function (e) {
                    let s = e;
                    if (t.thumbs) {
                        const i = t.thumbs.querySelector(selectors$x.classSelected),
                            o = t.thumbs.querySelector(`${selectors$x.sliderThumb} [${selectors$x.dataThumbIndex}="${e}"]`);
                        if (i) {
                            const e = i.querySelector(`[${selectors$x.dataThumbIndex}]`);
                            (s = Array.from(i.parentElement.children).indexOf(i)), i.classList.remove(classes$t.active), e && e.setAttribute(attributes$d.ariaCurrent, !1);
                        }
                        o && (o.parentElement.classList.add(classes$t.active), o.setAttribute(attributes$d.ariaCurrent, !0)), t.scrollToThumb();
                    }
                    const i = this.cells[s].element,
                        o = this.selectedElement;
                    i.dispatchEvent(new CustomEvent("theme:media:hidden")), o.classList.remove(classes$t.mediaHidden);
                }),
                    this.flkty.on("settle", function () {
                        const e = this.selectedElement,
                            s = Array.prototype.filter.call(e.parentNode.children, function (t) {
                                return t !== e;
                            }),
                            i = e.getAttribute(selectors$x.mediaType),
                            o = document.body.classList.contains(classes$t.focused);
                        "model" === i || "video" === i || "external_video" === i ? ((t.flkty.options.draggable = !1), t.flkty.updateDraggable()) : ((t.flkty.options.draggable = !0), t.flkty.updateDraggable()),
                            o && e.dispatchEvent(new Event("focus")),
                            s.length &&
                                s.forEach((e) => {
                                    e.classList.add(classes$t.mediaHidden);
                                }),
                            e.dispatchEvent(new CustomEvent("theme:media:visible"));
                        const r = e.querySelector("deferred-media");
                        r && !0 !== r.getAttribute("loaded") && e.querySelector(selectors$x.deferredMediaButton).dispatchEvent(new Event("click", { bubbles: !1 })), t.accessibilityActions(this);
                    }),
                    this.flkty.on("dragStart", (e, t) => {
                        e.target.classList.add(classes$t.dragging);
                    }),
                    this.flkty.on("dragEnd", (e, t) => {
                        const s = this.flkty.element.querySelector(`.${classes$t.dragging}`);
                        s && s.classList.remove(classes$t.dragging);
                    }),
                    this.container.addEventListener("click", (e) => {
                        const t = e.target;
                        if (t.matches(selectors$x.productSlideThumb) || t.closest(selectors$x.productSlideThumb)) {
                            e.preventDefault();
                            const s = t.matches(selectors$x.productSlideThumb) ? t : t.closest(selectors$x.productSlideThumb),
                                i = s.hasAttribute(selectors$x.dataThumbIndex) ? parseInt(s.getAttribute(selectors$x.dataThumbIndex)) : 0;
                            this.flkty.select(i);
                        }
                    });
            }
            accessibilityActions(e) {
                const t = e.slides;
                t.length &&
                    t.forEach((e) => {
                        const t = e.cells[0].element,
                            s = t.querySelectorAll(`model-viewer, video, iframe, button, [href], input, ${selectors$x.focusedElement}`);
                        t.classList.contains(classes$t.selected) ? t.removeAttribute("tabindex") : t.setAttribute("tabindex", "-1"),
                            s.length &&
                                s.forEach((e) => {
                                    t.classList.contains(classes$t.selected) ? e.removeAttribute("tabindex") : e.setAttribute("tabindex", "-1");
                                });
                    });
            }
            scrollToThumb() {
                const e = this.container.querySelector(selectors$x.thumbsSlider);
                if (e) {
                    const t = e.querySelector(selectors$x.classSelected);
                    if (!t) return;
                    const s = e.scrollTop,
                        i = e.scrollLeft,
                        o = e.offsetWidth,
                        r = e.offsetHeight,
                        a = s + r,
                        n = i + o,
                        l = t.offsetTop,
                        c = t.offsetLeft,
                        d = t.offsetWidth,
                        h = t.offsetHeight,
                        u = s > l,
                        p = i > c,
                        m = c + d > n,
                        g = l + h > a || u,
                        y = m || p,
                        b = isMobile();
                    if (g || y) {
                        let t = l - r + h,
                            s = c - o + d;
                        u && (t = l), m && b && (s += parseInt(window.getComputedStyle(e).paddingRight)), p && ((s = c), b && (s -= parseInt(window.getComputedStyle(e).paddingLeft))), e.scrollTo({ top: t, left: s, behavior: "smooth" });
                    }
                }
            }
            sliderThumbs(e) {
                const t = e.slides;
                if (this.thumbs && t.length) {
                    let e = "";
                    t.forEach((t, s) => {
                        const i = t.cells[0].element,
                            o = i.getAttribute(selectors$x.mediaType),
                            r = i.getAttribute(selectors$x.dataMediaId),
                            a = i.getAttribute(selectors$x.dataThumb);
                        let n = "";
                        const l = thumbIcons[o] ? thumbIcons[o] : "";
                        let c = "",
                            d = !1;
                        i.querySelector(`[${selectors$x.ariaLabel}]`) && (n = i.querySelector(`[${selectors$x.ariaLabel}]`).getAttribute(selectors$x.ariaLabel)),
                            "" === n && i.hasAttribute(selectors$x.ariaLabel) && (n = i.getAttribute(selectors$x.ariaLabel)),
                            (i.classList.contains(classes$t.active) || 0 === s) && ((c = classes$t.active), (d = !0)),
                            (e += `<div class="product__thumb ${c}" data-thumb-item><a href="${a}" class="product__thumb__link product__thumb__link--${o} js-product-slide-thumb" data-thumb-index="${s}" data-thumbnail data-media-id="${r}" aria-label="${n}" aria-current="${d}"><img class="product__thumb__link__image" loading="lazy" is="lazy-img" src="${a}" sizes="75px" alt="${n}">${l}</a></div>`);
                    }),
                        "" !== e && ((e = `<div class="product__thumbs__holder" data-thumbs-slider>${e}</div>`), (this.thumbs.innerHTML = e));
                }
                const s = this.container.querySelectorAll(selectors$x.dataThumbnail);
                s.length &&
                    s.forEach((t) => {
                        t.addEventListener("click", function (e) {
                            e.preventDefault();
                        }),
                            t.addEventListener("keyup", function (t) {
                                if (t.code === window.theme.keyboardKeys.ENTER) {
                                    const t = this.getAttribute(selectors$x.dataMediaId),
                                        s = e.element.querySelector(`[${selectors$x.dataMediaId}="${t}"]`).querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
                                    s && (s.dispatchEvent(new Event("focus")), s.dispatchEvent(new Event("select")));
                                }
                            });
                    });
            }
            onUnload() {
                this.tallLayout
                    ? this.mobileSliderDisabled || document.removeEventListener("theme:resize:width", this.initSliderMobileEvent)
                    : this.mobileSliderDisabled && document.removeEventListener("theme:resize:width", this.initSliderDesktopEvent);
            }
            constructor(e, t = null) {
                (this.container = t || e.container),
                    (this.tallLayout = "true" === this.container.getAttribute(selectors$x.dataTallLayout)),
                    (this.slideshow = this.container.querySelector(selectors$x.productSlideshow)),
                    (this.thumbs = this.container.querySelector(selectors$x.productThumbs)),
                    (this.mobileSliderDisabled = "true" === this.container.getAttribute(selectors$x.mobileSliderDisabled)),
                    (this.initSliderMobileEvent = () => this.initSliderMobile()),
                    (this.initSliderDesktopEvent = () => this.initSliderDesktop()),
                    this.slideshow && this.slideshow.hasAttribute(attributes$d.sliderOptions) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(attributes$d.sliderOptions)))),
                    (this.flkty = null),
                    this.init();
            }
        };
    const initSlider = {
            onLoad() {
                sections$m[this.id] = new InitSlider(this);
            },
            onUnload(e) {
                sections$m[this.id].onUnload(e);
            },
        },
        selectors$w = {
            optionPosition: "data-option-position",
            optionInput: '[name^="options"], [data-popout-option]',
            optionInputCurrent: '[name^="options"]:checked, [name^="options"][type="hidden"]',
            selectOptionValue: "data-value",
            popout: "[data-popout]",
        },
        classes$s = { soldOut: "sold-out", unavailable: "unavailable", sale: "sale" };
    let SelloutVariants = class {
        init() {
            this.update();
        }
        update() {
            this.getCurrentState(),
                this.optionElements.forEach((e) => {
                    const t = e.closest(`[${selectors$w.optionPosition}]`);
                    if (!t) return;
                    const s = e.value || e.getAttribute(selectors$w.selectOptionValue),
                        i = t.getAttribute(selectors$w.optionPosition),
                        o = parseInt(i, 10) - 1,
                        r = e.closest(selectors$w.popout);
                    let a = [...this.selections];
                    a[o] = s;
                    const n = this.productJSON.variants.find((e) => {
                        let t = !0;
                        for (let s = 0; s < a.length; s++) e.options[s] !== a[s] && (t = !1);
                        return t;
                    });
                    e.classList.remove(classes$s.soldOut, classes$s.unavailable),
                        e.parentNode.classList.remove(classes$s.sale),
                        r && r.classList.remove(classes$s.soldOut, classes$s.unavailable, classes$s.sale),
                        void 0 === n ? (e.classList.add(classes$s.unavailable), r && r.classList.add(classes$s.unavailable)) : n && !1 === n.available && (e.classList.add(classes$s.soldOut), r && r.classList.add(classes$s.soldOut)),
                        n && n.compare_at_price > n.price && theme.settings.variantOnSale && e.parentNode.classList.add(classes$s.sale);
                });
        }
        getCurrentState() {
            this.selections = [];
            const e = this.container.querySelectorAll(selectors$w.optionInputCurrent);
            e.length &&
                e.forEach((e) => {
                    const t = e.value;
                    t && "" !== t && this.selections.push(t);
                });
        }
        constructor(e, t) {
            (this.container = e), (this.productJSON = t), (this.optionElements = this.container.querySelectorAll(selectors$w.optionInput)), this.productJSON && this.optionElements.length && this.init();
        }
    };
    const selectors$v = {
            product: "[data-product]",
            productForm: "[data-product-form]",
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
            comparePrice: "[data-compare-price]",
            comparePriceText: "[data-compare-text]",
            formWrapper: "[data-form-wrapper]",
            originalSelectorId: "[data-product-select]",
            priceWrapper: "[data-price-wrapper]",
            productSlideshow: "[data-product-slideshow]",
            productImage: "[data-product-image]",
            productJson: "[data-product-json]",
            productPrice: "[data-product-price]",
            unitPrice: "[data-product-unit-price]",
            unitBase: "[data-product-base]",
            unitWrapper: "[data-product-unit]",
            isPreOrder: "[data-product-preorder]",
            sliderEnabled: "flickity-enabled",
            productSlide: ".product__slide",
            subPrices: "[data-subscription-watch-price]",
            subSelectors: "[data-subscription-selectors]",
            subsToggle: "[data-toggles-group]",
            subsChild: "data-group-toggle",
            subDescription: "[data-plan-description]",
            priceOffWrap: "[data-price-off]",
            priceOffType: "[data-price-off-type]",
            priceOffAmount: "[data-price-off-amount]",
            remainingCount: "[data-remaining-count]",
            remainingMax: "[data-remaining-max]",
            remainingWrapper: "[data-remaining-wrapper]",
            remainingJSON: "[data-product-remaining-json]",
            optionValue: "[data-option-value]",
            optionPosition: "[data-option-position]",
            installment: "product-form-installment",
            inputId: 'input[name="id"]',
        },
        classes$r = {
            hidden: "hidden",
            variantSoldOut: "variant--soldout",
            variantUnavailable: "variant--unavailable",
            productPriceSale: "product__price--sale",
            remainingLow: "count-is-low",
            remainingIn: "count-is-in",
            remainingOut: "count-is-out",
            remainingUnavailable: "count-is-unavailable",
        },
        attributes$c = { dataTallLayout: "data-tall-layout", remainingMaxAttr: "data-remaining-max", dataEnableHistoryState: "data-enable-history-state", optionPosition: "data-option-position", dataImageId: "data-image-id" };
    let ProductAddForm = class {
        init() {
            let e = null;
            const t = this.container.querySelector(selectors$v.productJson);
            t && (e = t.innerHTML), e ? ((this.productJSON = JSON.parse(e)), this.linkForm(), (this.sellout = new SelloutVariants(this.container, this.productJSON))) : console.error("Missing product JSON");
        }
        destroy() {
            this.productForm.destroy();
        }
        linkForm() {
            (this.productForm = new ProductForm(this.container, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this) })),
                this.pushState(this.productForm.getFormState()),
                this.subsToggleListeners();
        }
        onOptionChange(e) {
            this.pushState(e.dataset), this.updateProductImage(e);
        }
        onPlanChange(e) {
            this.subPrices && this.pushState(e.dataset);
        }
        pushState(e) {
            var t;
            (this.productState = this.setProductState(e)),
                this.updateAddToCartState(e),
                this.updateProductPrices(e),
                this.updateSaleText(e),
                this.updateSubscriptionText(e),
                this.updateRemaining(e),
                this.updateLegend(e),
                this.fireHookEvent(e),
                null === (t = this.sellout) || void 0 === t || t.update(e),
                this.enableHistoryState && this.updateHistoryState(e);
        }
        updateAddToCartState(e) {
            const t = e.variant;
            let s = theme.strings.addToCart;
            const i = this.container.querySelectorAll(selectors$v.priceWrapper),
                o = this.container.querySelectorAll(selectors$v.addToCart),
                r = this.container.querySelectorAll(selectors$v.addToCartText),
                a = this.container.querySelectorAll(selectors$v.formWrapper);
            if (this.installmentForm && t) {
                const e = this.installmentForm.querySelector(selectors$v.inputId);
                (e.value = t.id), e.dispatchEvent(new Event("change", { bubbles: !0 }));
            }
            this.isPreOrder && (s = theme.strings.preOrder),
                i.length &&
                    t &&
                    i.forEach((e) => {
                        e.classList.remove(classes$r.hidden);
                    }),
                o.length &&
                    o.forEach((e) => {
                        t && t.available ? (e.disabled = !1) : (e.disabled = !0);
                    }),
                r.length &&
                    r.forEach((e) => {
                        t ? (t.available ? (e.innerHTML = s) : (e.innerHTML = theme.strings.soldOut)) : (e.innerHTML = theme.strings.unavailable);
                    }),
                a.length &&
                    a.forEach((e) => {
                        if (t) {
                            t.available ? e.classList.remove(classes$r.variantSoldOut, classes$r.variantUnavailable) : (e.classList.add(classes$r.variantSoldOut), e.classList.remove(classes$r.variantUnavailable));
                            const s = e.querySelector(selectors$v.originalSelectorId);
                            s && (s.value = t.id);
                        } else e.classList.add(classes$r.variantUnavailable), e.classList.remove(classes$r.variantSoldOut);
                    });
        }
        updateHistoryState(e) {
            const t = e.variant,
                s = e.plan,
                i = window.location.href;
            if (t && i.includes("/product")) {
                const e = new window.URL(i),
                    o = e.searchParams;
                o.set("variant", t.id), s && s.detail && s.detail.id && this.productState.hasPlan ? o.set("selling_plan", s.detail.id) : o.delete("selling_plan"), (e.search = o.toString());
                const r = e.toString();
                window.history.replaceState({ path: r }, "", r);
            }
        }
        updateRemaining(e) {
            var t;
            const s = e.variant;
            if (
                (null === (t = this.remainingWrapper) || void 0 === t || t.classList.remove(classes$r.remainingIn, classes$r.remainingOut, classes$r.remainingUnavailable, classes$r.remainingLow),
                s && this.remainingWrapper && this.remainingJSON)
            ) {
                const e = this.remainingJSON[s.id];
                ("out" === e || e < 1) && this.remainingWrapper.classList.add(classes$r.remainingOut),
                    ("in" === e || e >= this.remainingMaxInt) && this.remainingWrapper.classList.add(classes$r.remainingIn),
                    ("low" === e || (e > 0 && e < this.remainingMaxInt)) && (this.remainingWrapper.classList.add(classes$r.remainingLow), this.remainingCount && (this.remainingCount.innerHTML = e));
            } else !s && this.remainingWrapper && this.remainingWrapper.classList.add(classes$r.remainingUnavailable);
        }
        getBaseUnit(e) {
            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
        }
        subsToggleListeners() {
            this.container.querySelectorAll(selectors$v.subsToggle).forEach((e) => {
                e.addEventListener(
                    "change",
                    function (e) {
                        const t = e.target.value.toString(),
                            s = this.container.querySelector(`[${selectors$v.subsChild}="${t}"]`),
                            i = this.container.querySelectorAll(`[${selectors$v.subsChild}]`);
                        if (s) {
                            s.classList.remove(classes$r.hidden);
                            const e = s.querySelector('[name="selling_plan"]');
                            (e.checked = !0), e.dispatchEvent(new Event("change"));
                        }
                        i.forEach((e) => {
                            if (e !== s) {
                                e.classList.add(classes$r.hidden);
                                e.querySelectorAll('[name="selling_plan"]').forEach((e) => {
                                    (e.checked = !1), e.dispatchEvent(new Event("change"));
                                });
                            }
                        });
                    }.bind(this)
                );
            });
        }
        updateSaleText(e) {
            this.productState.planSale ? this.updateSaleTextSubscription(e) : this.productState.onSale ? this.updateSaleTextStandard(e) : this.priceOffWrap && this.priceOffWrap.classList.add(classes$r.hidden);
        }
        updateSaleTextStandard(e) {
            if ((this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"), this.priceOffAmount && this.priceOffWrap)) {
                const t = e.variant,
                    s = (t.compare_at_price - t.price) / t.compare_at_price,
                    i = Math.floor(100 * s);
                (this.priceOffAmount.innerHTML = `${i}%`), this.priceOffWrap.classList.remove(classes$r.hidden);
            }
        }
        updateSubscriptionText(e) {
            e.plan && this.planDescription
                ? ((this.planDescription.innerHTML = e.plan.detail.description), this.planDescription.classList.remove(classes$r.hidden))
                : this.planDescription && this.planDescription.classList.add(classes$r.hidden);
        }
        updateSaleTextSubscription(e) {
            if ((this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), this.priceOffAmount && this.priceOffWrap)) {
                const t = e.plan.detail.price_adjustments[0],
                    s = t.value;
                t && "percentage" === t.value_type ? (this.priceOffAmount.innerHTML = `${s}%`) : (this.priceOffAmount.innerHTML = themeCurrency.formatMoney(s, theme.moneyFormat)), this.priceOffWrap.classList.remove(classes$r.hidden);
            }
        }
        updateProductPrices(e) {
            if ( typeof BSS_B2B !== "undefined") {
                const isApplyCP = BSS_B2B.shopModules.filter(v => v.code === 'cp' && v.status === 1);
                if (isApplyCP.length > 0) {
                   $('[bss-b2b-product-id]').css("visibility", "hidden");
                }
                // const originPriceElement = $('.bss-b2b-customized-compare-at-price');
                // if (originPriceElement) {
                //   $('[data-price-wrapper]').before(originPriceElement);
                // }
              
            }
            const t = e.variant,
                s = e.plan;
            this.container.querySelectorAll(selectors$v.priceWrapper).forEach((e) => {
                const i = e.querySelector(selectors$v.comparePrice),
                    o = e.querySelector(selectors$v.productPrice),
                    r = e.querySelector(selectors$v.comparePriceText);
                let a = "",
                    n = "";
                this.productState.available && ((a = t.compare_at_price), (n = t.price)),
                    this.productState.hasPlan && (n = s.allocation.price),
                    this.productState.planSale && ((a = s.allocation.compare_at_price), (n = s.allocation.price)),
                    i &&
                        (this.productState.onSale || this.productState.planSale
                            ? (i.classList.remove(classes$r.hidden), r.classList.remove(classes$r.hidden), o.classList.add(classes$r.productPriceSale))
                            : (i.classList.add(classes$r.hidden), r.classList.add(classes$r.hidden), o.classList.remove(classes$r.productPriceSale)),
                        (i.innerHTML = themeCurrency.formatMoney(a, theme.moneyFormat))),
                    (o.innerHTML = 0 === n ? window.theme.strings.free : themeCurrency.formatMoney(n, theme.moneyFormat));
            }),
                this.hasUnitPricing && this.updateProductUnits(e);
        }
        updateProductUnits(e) {
            const t = e.variant,
                s = e.plan;
            let i = null;
            if ((t && t.unit_price && (i = t.unit_price), s && s.allocation && s.allocation.unit_price && (i = s.allocation.unit_price), i)) {
                const e = this.getBaseUnit(t),
                    s = themeCurrency.formatMoney(i, theme.moneyFormat);
                (this.container.querySelector(selectors$v.unitPrice).innerHTML = s), (this.container.querySelector(selectors$v.unitBase).innerHTML = e), showElement(this.container.querySelector(selectors$v.unitWrapper));
            } else hideElement(this.container.querySelector(selectors$v.unitWrapper));
        }
        fireHookEvent(e) {
            const t = e.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: t }, bubbles: !0 }));
        }
        setProductState(e) {
            const t = e.variant,
                s = e.plan,
                i = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
            return (
                !t || (t.requires_selling_plan && !s)
                    ? (i.available = !1)
                    : (t.available || (i.soldOut = !0),
                      t.compare_at_price > t.price && (i.onSale = !0),
                      t.unit_price && (i.showUnitPrice = !0),
                      this.product && this.product.requires_selling_plan && (i.requiresPlan = !0),
                      s && this.subPrices && ((i.hasPlan = !0), s.allocation.per_delivery_price !== s.allocation.price && (i.planPerDelivery = !0), t.price > s.allocation.price && (i.planSale = !0))),
                i
            );
        }
        updateProductImage(e) {
            const t = e.dataset.variant;
            if (t && t.featured_media) {
                const e = this.container.querySelector(`[${attributes$c.dataImageId}="${t.featured_media.id}"]`),
                    s = null == e ? void 0 : e.closest(selectors$v.productSlide);
                if (s) {
                    const t = Array.from(s.parentElement.children).indexOf(s),
                        i = this.container.querySelector(selectors$v.productSlideshow),
                        o = isDesktop();
                    if ((i && i.classList.contains(selectors$v.sliderEnabled) ? FlickityFade.data(i).select(t) : i && !o && i.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" }), o && this.tallLayout)) {
                        const s = e.getBoundingClientRect().top;
                        if (0 === t && s + window.scrollY > window.pageYOffset) return;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } })), scrollTo(s);
                    }
                }
            }
        }
        updateLegend(e) {
            const t = e.variant;
            if (t) {
                const e = this.container.querySelectorAll(selectors$v.optionValue);
                e.length &&
                    e.forEach((e) => {
                        const s = e.closest(selectors$v.optionPosition);
                        if (s) {
                            const i = s.getAttribute(attributes$c.optionPosition),
                                o = parseInt(i, 10) - 1,
                                r = t.options[o];
                            e.innerHTML = r;
                        }
                    });
            }
        }
        constructor(e, t = null) {
            if (
                ((this.section = e),
                (this.sectionId = (null == e ? void 0 : e.id) || (null == t ? void 0 : t.id)),
                (this.container = t || e.container),
                (this.tallLayout = "true" === this.container.getAttribute(attributes$c.dataTallLayout)),
                (this.product = this.container.querySelector(selectors$v.product)),
                (this.productForm = this.container.querySelector(selectors$v.productForm)),
                (this.installmentForm = this.container.querySelector(`#${selectors$v.installment}-${this.sectionId}`)),
                (this.sellout = null),
                (this.priceOffWrap = this.container.querySelector(selectors$v.priceOffWrap)),
                (this.priceOffAmount = this.container.querySelector(selectors$v.priceOffAmount)),
                (this.priceOffType = this.container.querySelector(selectors$v.priceOffType)),
                (this.planDescription = this.container.querySelector(selectors$v.subDescription)),
                (this.remainingWrapper = this.container.querySelector(selectors$v.remainingWrapper)),
                this.remainingWrapper)
            ) {
                const e = this.container.querySelector(selectors$v.remainingMax);
                e &&
                    ((this.remainingMaxInt = parseInt(e.getAttribute(attributes$c.remainingMaxAttr), 10)),
                    (this.remainingCount = this.container.querySelector(selectors$v.remainingCount)),
                    (this.remainingJSONWrapper = this.container.querySelector(selectors$v.remainingJSON)),
                    (this.remainingJSON = null),
                    this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML)) : console.warn("Missing product quantity JSON"));
            }
            (this.enableHistoryState = "true" === this.container.getAttribute(attributes$c.dataEnableHistoryState)),
                (this.hasUnitPricing = this.container.querySelector(selectors$v.unitWrapper)),
                (this.subSelectors = this.container.querySelector(selectors$v.subSelectors)),
                (this.subPrices = this.container.querySelector(selectors$v.subPrices)),
                (this.isPreOrder = this.container.querySelector(selectors$v.isPreOrder));
            new QuantityCounter(this.container).init(), this.init();
        }
    };
    const productFormSection = {
            onLoad() {
                this.section = new ProductAddForm(this);
            },
        },
        classes$q = {
            added: "is-added",
            animated: "is-animated",
            disabled: "is-disabled",
            error: "has-error",
            hide: "is-hidden",
            hiding: "is-hiding",
            loading: "is-loading",
            open: "is-open",
            overlayText: "product-item--overlay-text",
            visible: "is-visible",
            siblingLinkCurrent: "sibling__link--current",
            focused: "is-focused",
        },
        settings$1 = { errorDelay: 3e3, animationDelay: 500 },
        selectors$u = {
            addButtonWrapper: "[data-add-action-wrapper]",
            animation: "[data-animation]",
            apiContent: "[data-api-content]",
            buttonQuickAdd: "[data-quick-add-btn]",
            buttonQuickAddText: "[data-quick-add-btn-text]",
            buttonQuickAddMobile: "[data-quick-add-btn-mobile]",
            cartDrawer: "[data-cart-drawer]",
            cartLineItems: "[data-line-items]",
            focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
            media: "[data-media-slide]",
            messageError: "[data-message-error]",
            modalContainer: "[data-product-upsell-container]",
            modalContent: "[data-product-upsell-ajax]",
            productGridItem: "data-product-grid-item",
            productInformationHolder: "[data-product-information]",
            popoutWrapper: "[data-popout]",
            quickAddHolder: "data-quick-add-holder",
            quickAddModal: "[data-quick-add-modal]",
            quickAddModalTemplate: "[data-quick-add-modal-template]",
            quickAddVariant: "data-quick-add-variant",
            quickAddProp: "data-quick-add-props",
            siblingSwapper: "data-sibling-swapper",
            swatch: "[data-swatch]",
            tooltip: "[data-tooltip]",
        };
    let QuickAddProduct = class extends HTMLElement {
        init() {
            if (
                (this.modalButton &&
                    this.modalTemplate &&
                    this.modalButton.addEventListener("click", (e) => {
                        e.preventDefault();
                        const t = this.modalButton.hasAttribute(selectors$u.siblingSwapper),
                            s = this.modalButton.classList.contains(classes$q.siblingLinkCurrent);
                        s ||
                            (this.modalButton.classList.add(classes$q.loading),
                            (this.modalButton.disabled = !0),
                            this.closeTooltip(),
                            t && !s && ((this.modalContainer = document.querySelector(selectors$u.modalContainer)), this.modalContainer.classList.add(classes$q.loading), this.hideAnimatedItems()),
                            this.modal && ((this.oldModalID = this.modal.id), this.modalID && (this.modal.id = this.modalID)),
                            this.getProductHTML());
                    }),
                this.buttonQuickAdd)
            ) {
                const e = this.buttonQuickAdd.querySelector(selectors$u.buttonQuickAddText);
                e && 0 === parseInt(getComputedStyle(this.buttonQuickAdd).getPropertyValue("--btn-text-width")) && this.buttonQuickAdd.style.setProperty("--btn-text-width", `${e.clientWidth}px`),
                    this.buttonQuickAdd.hasAttribute(selectors$u.quickAddVariant) &&
                        (this.buttonQuickAdd.addEventListener("click", (e) => {
                            e.preventDefault();
                            const t = this.buttonQuickAdd.getAttribute(selectors$u.quickAddVariant);
                            if (t) {
                                const e = this.buttonQuickAdd.hasAttribute(selectors$u.quickAddProp) ? JSON.parse(this.buttonQuickAdd.getAttribute(selectors$u.quickAddProp).replaceAll("'", '"')) : null;
                                this.addToCart(t, e);
                            }
                        }),
                        theme.settings.enableQuickAdd && this.buttonQuickAdd.closest(`[${selectors$u.quickAddHolder}]`) && this.errorHandler());
            }
            this.buttonQuickAddMobile &&
                this.buttonQuickAddMobile.addEventListener("click", () => {
                    this.buttonQuickAddMobile.classList.add(classes$q.loading), this.button.dispatchEvent(new Event("click"));
                }),
                this.quickAddHolder &&
                    this.quickAddHolder.addEventListener("animationend", () => {
                        this.quickAddHolder.classList.contains(classes$q.disabled) && this.quickAddHolder.classList.remove(classes$q.disabled);
                    }),
                document.addEventListener("theme:product:added", () => {
                    this.resetQuickAddButtons(), this.modal && this.modal.classList.contains(classes$q.open) && MicroModal.close(this.modalID);
                });
        }
        addToCart(e, t = null) {
            const s = this.buttonQuickAdd.closest(selectors$u.quickAddHolder) ? this.buttonQuickAdd : null;
            let i = { id: e, quantity: 1 };
            if (t) {
                const e = { properties: t };
                i = { ...i, ...e };
            }
            document.dispatchEvent(new CustomEvent("theme:cart:add", { bubbles: !0, detail: { element: this.quickAddHolder, label: s, button: this.buttonQuickAdd, data: i } }));
        }
        errorHandler() {
            this.quickAddHolder.addEventListener("theme:cart:error", (e) => {
                const t = e.detail.holder,
                    s = t.closest(`[${selectors$u.productGridItem}]`);
                if (!s) return;
                const i = t.querySelector(selectors$u.messageError),
                    o = s.classList.contains(classes$q.overlayText),
                    r = s.querySelector(selectors$u.productInformationHolder),
                    a = t.querySelector(selectors$u.buttonQuickAdd),
                    n = t.querySelector(selectors$u.buttonQuickAddMobile);
                a && (a.classList.remove(classes$q.added, classes$q.loading), a.classList.add(classes$q.error)),
                    n && (n.classList.remove(classes$q.added, classes$q.loading), n.classList.add(classes$q.error)),
                    i && (i.innerText = e.detail.description),
                    o && r.classList.add(classes$q.hidden),
                    setTimeout(() => {
                        this.resetQuickAddButtons(), o && r.classList.remove(classes$q.hidden);
                    }, settings$1.errorDelay);
            });
        }
        resetQuickAddButtons() {
            this.quickAddHolder && this.quickAddHolder.classList.remove(classes$q.visible),
                this.button && (this.buttonQuickAdd.classList.remove(classes$q.added, classes$q.error), (this.buttonQuickAdd.disabled = !1)),
                this.buttonQuickAddMobile && (this.buttonQuickAddMobile.classList.remove(classes$q.added, classes$q.error), (this.buttonQuickAddMobile.disabled = !1));
        }
        getProductHTML() {
            this.modalContent && this.oldModalID === this.modalID
                ? this.modalCreate()
                : window
                      .fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`)
                      .then(this.upsellErrorsHandler)
                      .then((e) => e.text())
                      .then((e) => {
                          const t = document.createElement("div");
                          (t.innerHTML = e),
                              (this.modalContent = document.querySelector(selectors$u.modalContent)),
                              (this.modalContent.innerHTML = t.querySelector(selectors$u.apiContent).innerHTML),
                              this.initFormFunctionalities(),
                              this.modalCreate();
                      });
        }
        initFormFunctionalities() {
            new ProductAddForm(null, this.modal), new InitSlider(null, this.modal);
            const e = this.modalContent.querySelectorAll(selectors$u.swatch);
            e.length &&
                e.forEach((e) => {
                    new Swatch(e);
                });
            const t = this.modalContent.querySelectorAll(selectors$u.popoutWrapper);
            t.length &&
                t.forEach((e) => {
                    new Popout(e);
                });
            const s = this.modalContent.querySelectorAll(selectors$u.tooltip);
            s.length &&
                s.forEach((e) => {
                    new Tooltip(e);
                }),
                wrapElements(this.modalContent);
        }
        modalCreate() {
            (this.modalContainer = document.querySelector(selectors$u.modalContainer)),
                MicroModal.show(this.modalID, {
                    onShow: (e, t, s) => {
                        const i = e.querySelector(selectors$u.focusable),
                            o = { container: e, id: this.modalID };
                        (theme.mediaInstances[this.id] = new Media(o)),
                            theme.mediaInstances[this.id].init(),
                            this.quickAddHolder.classList.add(classes$q.disabled),
                            this.modalButton && (this.modalButton.classList.remove(classes$q.loading), (this.modalButton.disabled = !1)),
                            this.buttonQuickAddMobile && (this.buttonQuickAddMobile.classList.remove(classes$q.loading), (this.buttonQuickAddMobile.disabled = !1)),
                            requestAnimationFrame(() => {
                                this.modalContainer.querySelectorAll(selectors$u.animation).forEach((e) => {
                                    e.classList.add(classes$q.animated);
                                }),
                                    setTimeout(() => {
                                        this.modalContainer.classList.remove(classes$q.loading);
                                    }, settings$1.animationDelay);
                            }),
                            setTimeout(() => {
                                trapFocus(e, { elementToFocus: i });
                            }, settings$1.animationDelay),
                            document.dispatchEvent(new CustomEvent("theme:quick-add:open", { bubbles: !0 })),
                            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.modalContainer })),
                            this.modalContainer.addEventListener("scroll", this.closeTooltipEvent);
                    },
                    onClose: (e, t, s) => {
                        s && s.preventDefault();
                        e.querySelectorAll(selectors$u.media).forEach((e) => {
                            e.dispatchEvent(new CustomEvent("pause"));
                        }),
                            this.modalButton && (this.modalButton.disabled = !1),
                            this.buttonQuickAddMobile && (this.buttonQuickAddMobile.disabled = !1),
                            this.quickAddHolder && this.quickAddHolder.classList.contains(classes$q.disabled) && this.quickAddHolder.classList.remove(classes$q.disabled),
                            removeTrapFocus(),
                            document.body.classList.contains(classes$q.focused) &&
                                this.buttonQuickAdd &&
                                (this.buttonQuickAdd.classList.add(classes$q.visible),
                                setTimeout(() => {
                                    this.buttonQuickAdd.focus(), this.buttonQuickAdd.classList.remove(classes$q.visible);
                                }, 50)),
                            this.resetAnimatedItems(),
                            (this.cartDrawer && this.cartDrawer.classList.contains(classes$q.open)) || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                            this.modalContainer.removeEventListener("scroll", this.closeTooltipEvent);
                    },
                });
        }
        closeTooltip() {
            document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !0 } }));
        }
        upsellErrorsHandler(e) {
            return e.ok
                ? e
                : e.json().then(function (t) {
                      throw new FetchError({ status: e.statusText, headers: e.headers, json: t });
                  });
        }
        hideAnimatedItems() {
            this.modalContainer &&
                this.modalContainer.querySelectorAll(selectors$u.animation).forEach((e) => {
                    e.classList.add(classes$q.hiding);
                });
        }
        resetAnimatedItems() {
            this.modalContainer &&
                this.modalContainer.querySelectorAll(selectors$u.animation).forEach((e) => {
                    e.classList.remove(classes$q.animated);
                });
        }
        constructor() {
            if ((super(), (this.container = this), (this.quickAddHolder = this.container.querySelector(`[${selectors$u.quickAddHolder}]`)), this.quickAddHolder)) {
                if (
                    ((this.html = document.documentElement),
                    (this.isCartItem = Boolean(this.quickAddHolder.closest(selectors$u.cartLineItems))),
                    (this.modalTemplate = this.quickAddHolder.querySelector(selectors$u.quickAddModalTemplate)),
                    (this.modal = document.querySelector(selectors$u.quickAddModal)),
                    (this.modalID = this.quickAddHolder.getAttribute(selectors$u.quickAddHolder)),
                    (this.modalButton = this.quickAddHolder.querySelector(`[data-popup-${this.modalID}]`)),
                    (this.handle = this.modalButton ? this.modalButton.getAttribute(`data-popup-${this.modalID}`) : null),
                    (this.cartDrawer = document.querySelector(selectors$u.cartDrawer)),
                    (this.buttonQuickAdd = this.quickAddHolder.querySelector(selectors$u.buttonQuickAdd)),
                    (this.button = this.modalButton || this.buttonQuickAdd),
                    (this.buttonQuickAddMobile = this.quickAddHolder.querySelector(selectors$u.buttonQuickAddMobile)),
                    (this.closeTooltipEvent = () => throttle(this.closeTooltip(), 50)),
                    (this.oldModalID = null),
                    (this.modalContainer = null),
                    (this.modalContent = null),
                    !this.modal && this.modalTemplate)
                ) {
                    const e = this.modalTemplate.innerHTML,
                        t = document.createElement("div");
                    t.innerHTML = e;
                    const s = t.querySelector(selectors$u.quickAddModal);
                    document.body.appendChild(s), (this.modal = document.querySelector(selectors$u.quickAddModal));
                }
                this.init();
            }
        }
    };
    const selectors$t = {
            productCutline: "[data-product-cutline]",
            productLink: "[data-product-link]",
            productGridItem: "[data-product-grid-item]",
            productInfo: "[data-product-information]",
            productImage: "[data-product-image-default]",
            productImageSibling: "[data-product-image-sibling]",
            productPrice: "[data-product-price]",
            siblingsInnerHolder: "[data-sibling-inner]",
            siblingCount: "[data-sibling-count]",
            siblingHolder: "[data-sibling-holder]",
            siblingFieldset: "[data-sibling-fieldset]",
            siblingLink: "[data-sibling-link]",
        },
        classes$p = { visible: "is-visible", fade: "is-fade", stopEvents: "no-events", active: "is-active" },
        attributes$b = {
            siblingAddedImage: "data-sibling-added-image",
            siblingCutline: "data-sibling-cutline",
            siblingImage: "data-sibling-image",
            siblingLink: "data-sibling-link",
            siblingPrice: "data-sibling-price",
            productLink: "data-product-link",
        };
    let SiblingSwatches = class {
            init() {
                this.cacheDefaultValues(),
                    this.product.addEventListener("mouseleave", () => this.resetProductValues()),
                    this.swatches.forEach((e) => {
                        e.addEventListener("mouseenter", (e) => this.showSibling(e));
                    }),
                    this.productLinks.length &&
                        this.swatches.forEach((e) => {
                            e.addEventListener("click", () => {
                                this.productLinks[0].click();
                            });
                        });
            }
            cacheDefaultValues() {
                (this.productLinkValue = this.productLinks[0].hasAttribute(attributes$b.productLink) ? this.productLinks[0].getAttribute(attributes$b.productLink) : ""),
                    (this.productPriceValue = this.productPrice.innerHTML),
                    this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML);
            }
            resetProductValues() {
                this.product.classList.remove(classes$p.active),
                    this.productLinkValue &&
                        this.productLinks.forEach((e) => {
                            e.href = this.productLinkValue;
                        }),
                    this.productPrice && (this.productPrice.innerHTML = this.productPriceValue),
                    this.productCutline && this.productCutline && (this.productCutline.innerHTML = this.productCutlineValue),
                    this.hideSiblingImage();
            }
            showSibling(e) {
                const t = e.target,
                    s = t.hasAttribute(attributes$b.siblingLink) ? t.getAttribute(attributes$b.siblingLink) : "",
                    i = t.hasAttribute(attributes$b.siblingPrice) ? t.getAttribute(attributes$b.siblingPrice) : "",
                    o = t.hasAttribute(attributes$b.siblingCutline) ? t.getAttribute(attributes$b.siblingCutline) : "",
                    r = t.hasAttribute(attributes$b.siblingImage) ? t.getAttribute(attributes$b.siblingImage) : "";
                s &&
                    this.productLinks.forEach((e) => {
                        e.href = s;
                    }),
                    i && (this.productPrice.innerHTML = i),
                    (this.productCutline.innerHTML = o || ""),
                    r && this.showSiblingImage(r);
            }
            showSiblingImage(e) {
                if (!this.productImageSibling) return;
                const t = window.devicePixelRatio || 1,
                    s = this.productImage.offsetWidth * t,
                    i = 180 * Math.ceil(s / 180),
                    o = themeImages.getSizedImageUrl(e, `${i}x`),
                    r = this.productImageSibling.querySelector(`[src="${o}"]`),
                    a = () => {
                        this.productImageSibling.classList.add(classes$p.visible), this.productImageSibling.querySelector(`[src="${o}"]`).classList.add(classes$p.fade);
                    },
                    n = () => {
                        this.productImageSibling.querySelectorAll("img").forEach((e) => {
                            e.classList.remove(classes$p.fade);
                        }),
                            requestAnimationFrame(a);
                    };
                if (r) n();
                else {
                    const e = document.createElement("img");
                    (e.src = o),
                        this.productCutline && (e.alt = this.productCutline.innerText),
                        e.addEventListener("load", () => {
                            this.productImageSibling.append(e), n();
                        });
                }
            }
            hideSiblingImage() {
                this.productImageSibling &&
                    (this.productImageSibling.classList.remove(classes$p.visible),
                    this.productImageSibling.querySelectorAll("img").forEach((e) => {
                        e.classList.remove(classes$p.fade);
                    }));
            }
            constructor(e, t) {
                (this.swatches = e),
                    (this.product = t),
                    (this.productLinks = this.product.querySelectorAll(selectors$t.productLink)),
                    (this.productCutline = this.product.querySelector(selectors$t.productCutline)),
                    (this.productPrice = this.product.querySelector(selectors$t.productPrice)),
                    (this.productImage = this.product.querySelector(selectors$t.productImage)),
                    (this.productImageSibling = this.product.querySelector(selectors$t.productImageSibling)),
                    this.init();
            }
        },
        Sibling = class {
            init() {
                this.initScrollbar(),
                    this.siblingCount && this.siblingFieldset && this.productInfo && (this.siblingCount.addEventListener("mouseenter", () => this.showSiblings()), this.productInfo.addEventListener("mouseleave", () => this.hideSiblings())),
                    this.siblingLinks.length && new SiblingSwatches(this.siblingLinks, this.product);
            }
            showSiblings() {
                this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productLink && this.productLink.classList.add(classes$p.stopEvents), this.siblingFieldset.classList.add(classes$p.visible);
            }
            hideSiblings() {
                this.hideSwatchesTimer = setTimeout(() => {
                    this.productLink && this.productLink.classList.remove(classes$p.stopEvents), this.siblingFieldset.classList.remove(classes$p.visible);
                }, 100);
            }
            initScrollbar() {
                this.siblingScrollbar && new NativeScrollbar(this.siblingScrollbar);
            }
            constructor(e, t) {
                (this.holder = e),
                    (this.product = t),
                    (this.siblingScrollbar = this.holder.querySelector(selectors$t.siblingsInnerHolder)),
                    (this.siblingCount = this.holder.querySelector(selectors$t.siblingCount)),
                    (this.siblingFieldset = this.holder.querySelector(selectors$t.siblingFieldset)),
                    (this.siblingLinks = this.holder.querySelectorAll(selectors$t.siblingLink)),
                    (this.productInfo = this.holder.closest(selectors$t.productInfo)),
                    (this.productLink = this.holder.closest(selectors$t.link)),
                    (this.hideSwatchesTimer = 0),
                    this.init();
            }
        },
        Siblings = class {
            constructor(e) {
                (this.container = e.container),
                    (this.siblingHolders = this.container.querySelectorAll(`${selectors$t.productGridItem} ${selectors$t.siblingHolder}`)),
                    this.siblingHolders.length &&
                        this.siblingHolders.forEach((e) => {
                            new Sibling(e, e.closest(selectors$t.productGridItem));
                        });
            }
        };
    const siblings = {
            onLoad() {
                new Siblings(this);
            },
        },
        selectors$s = {
            rangeSlider: "[data-range-slider]",
            rangeDotLeft: "[data-range-left]",
            rangeDotRight: "[data-range-right]",
            rangeLine: "[data-range-line]",
            rangeHolder: "[data-range-holder]",
            dataMin: "data-se-min",
            dataMax: "data-se-max",
            dataMinValue: "data-se-min-value",
            dataMaxValue: "data-se-max-value",
            dataStep: "data-se-step",
            dataFilterUpdate: "data-range-filter-update",
            priceMin: "[data-field-price-min]",
            priceMax: "[data-field-price-max]",
        },
        classes$o = { initialized: "is-initialized" };
    let RangeSlider = class {
        init() {
            let e = this.min;
            this.slider.hasAttribute(selectors$s.dataMinValue) && (e = parseFloat(this.slider.getAttribute(selectors$s.dataMinValue)));
            let t = this.max;
            this.slider.hasAttribute(selectors$s.dataMaxValue) && (t = parseFloat(this.slider.getAttribute(selectors$s.dataMaxValue))),
                e < this.min && (e = this.min),
                t > this.max && (t = this.max),
                e > t && (e = t),
                this.slider.getAttribute(selectors$s.dataStep) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(selectors$s.dataStep)))),
                this.reset(),
                document.addEventListener("theme:resize", this.resizeFilters),
                (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                (this.selectedTouch = null),
                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                this.setMinValue(e),
                this.setMaxValue(t),
                this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                this.touchRight.addEventListener("mousedown", this.onStartEvent),
                this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                this.slider.classList.add(classes$o.initialized);
        }
        reset() {
            (this.touchLeft.style.left = "0px"),
                (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.lineSpan.style.marginLeft = "0px"),
                (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.startX = 0),
                (this.x = 0);
        }
        setMinValue(e) {
            const t = (e - this.min) / (this.max - this.min);
            (this.touchLeft.style.left = Math.ceil(t * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(selectors$s.dataMinValue, e);
        }
        setMaxValue(e) {
            const t = (e - this.min) / (this.max - this.min);
            (this.touchRight.style.left = Math.ceil(t * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(selectors$s.dataMaxValue, e);
        }
        onStart(e) {
            let t = e;
            e.touches && (t = e.touches[0]),
                e.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : e.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                (this.startX = t.pageX - this.x),
                (this.selectedTouch = e.currentTarget),
                document.addEventListener("mousemove", this.onMoveEvent),
                document.addEventListener("mouseup", this.onStopEvent),
                document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                document.addEventListener("touchend", this.onStopEvent, { passive: !0 });
        }
        onMove(e) {
            let t = e;
            if (
                (e.touches && (t = e.touches[0]),
                (this.x = t.pageX - this.startX),
                this.selectedTouch === this.touchLeft
                    ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                      (this.selectedTouch.style.left = this.x + "px"))
                    : this.selectedTouch === this.touchRight &&
                      (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                      (this.selectedTouch.style.left = this.x + "px")),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.calculateValue(),
                this.slider.getAttribute("on-change"))
            ) {
                new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(selectors$s.dataMinValue), this.slider.getAttribute(selectors$s.dataMaxValue));
            }
            this.onChange(this.slider.getAttribute(selectors$s.dataMinValue), this.slider.getAttribute(selectors$s.dataMaxValue));
        }
        onStop() {
            document.removeEventListener("mousemove", this.onMoveEvent),
                document.removeEventListener("mouseup", this.onStopEvent),
                document.removeEventListener("touchmove", this.onMoveEvent),
                document.removeEventListener("touchend", this.onStopEvent),
                (this.selectedTouch = null),
                this.calculateValue(),
                this.onChanged(this.slider.getAttribute(selectors$s.dataMinValue), this.slider.getAttribute(selectors$s.dataMaxValue));
        }
        onChange(e, t) {
            const s = this.slider.closest(selectors$s.rangeHolder);
            if (s) {
                const i = s.querySelector(selectors$s.priceMin),
                    o = s.querySelector(selectors$s.priceMax);
                i && o && ((i.value = e), (o.value = t));
            }
        }
        onChanged(e, t) {
            this.slider.hasAttribute(selectors$s.dataFilterUpdate) && this.slider.dispatchEvent(new CustomEvent("theme:range:update", { bubbles: !0 }));
        }
        calculateValue() {
            const e = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let t = this.lineSpan.offsetLeft / this.initialValue,
                s = t + e;
            if (((t = t * (this.max - this.min) + this.min), (s = s * (this.max - this.min) + this.min), 0 !== this.step)) {
                let e = Math.floor(t / this.step);
                (t = this.step * e), (e = Math.floor(s / this.step)), (s = this.step * e);
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(selectors$s.dataMinValue, t), this.selectedTouch === this.touchRight && this.slider.setAttribute(selectors$s.dataMaxValue, s);
        }
        onUnload() {
            this.resizeFilters && document.removeEventListener("theme:resize", this.resizeFilters);
        }
        constructor(e) {
            (this.container = e.container),
                (this.slider = e.querySelector(selectors$s.rangeSlider)),
                (this.resizeFilters = () => this.init()),
                this.slider &&
                    ((this.onMoveEvent = (e) => this.onMove(e)),
                    (this.onStopEvent = (e) => this.onStop(e)),
                    (this.onStartEvent = (e) => this.onStart(e)),
                    (this.startX = 0),
                    (this.x = 0),
                    (this.touchLeft = this.slider.querySelector(selectors$s.rangeDotLeft)),
                    (this.touchRight = this.slider.querySelector(selectors$s.rangeDotRight)),
                    (this.lineSpan = this.slider.querySelector(selectors$s.rangeLine)),
                    (this.min = parseFloat(this.slider.getAttribute(selectors$s.dataMin))),
                    (this.max = parseFloat(this.slider.getAttribute(selectors$s.dataMax))),
                    (this.step = 0),
                    (this.normalizeFact = 26),
                    this.init());
        }
    };
    const selectors$r = {
            collectionSidebar: "[data-collection-sidebar]",
            form: "[data-collection-filters-form]",
            input: "input",
            select: "select",
            label: "label",
            textarea: "textarea",
            priceMin: "[data-field-price-min]",
            priceMax: "[data-field-price-max]",
            priceMinValue: "data-field-price-min",
            priceMaxValue: "data-field-price-max",
            rangeMin: "[data-se-min-value]",
            rangeMax: "[data-se-max-value]",
            rangeMinValue: "data-se-min-value",
            rangeMaxValue: "data-se-max-value",
            rangeMinDefault: "data-se-min",
            rangeMaxDefault: "data-se-max",
            productsContainer: "[data-products-grid]",
            product: "[data-product-grid-item]",
            filterUpdateUrlButton: "[data-filter-update-url]",
            activeFilters: "[data-active-filters]",
            activeFiltersCount: "data-active-filters-count",
            sort: "data-sort-enabled",
            collectionNav: "[data-collection-nav]",
        },
        classes$n = { hidden: "hidden", loading: "is-loading" };
    let sections$l = {},
        FiltersForm = class {
            init() {
                this.form &&
                    (this.initRangeSlider(),
                    this.sidebar.addEventListener(
                        "input",
                        debounce((e) => {
                            const t = e.type,
                                s = e.target;
                            if ((t === selectors$r.input || t === selectors$r.select || t === selectors$r.label || t === selectors$r.textarea) && this.form && "function" == typeof this.form.submit) {
                                const t = this.form.querySelector(selectors$r.priceMin),
                                    i = this.form.querySelector(selectors$r.priceMax);
                                t && i && (s.hasAttribute(selectors$r.priceMinValue) && !i.value ? (i.value = i.placeholder) : s.hasAttribute(selectors$r.priceMaxValue) && !t.value && (t.value = t.placeholder)), this.submitForm(e);
                            }
                        }, 500)
                    ),
                    this.sidebar.addEventListener("theme:range:update", (e) => this.updateRange(e))),
                    this.sidebar && this.sidebar.addEventListener("click", (e) => this.filterUpdateFromUrl(e)),
                    this.productsContainer && this.productsContainer.addEventListener("click", (e) => this.filterUpdateFromUrl(e)),
                    this.sort && this.container.addEventListener("theme:filter:update", (e) => this.submitForm(e)),
                    (this.sidebar || this.sort) && window.addEventListener("popstate", (e) => this.submitForm(e));
            }
            initRangeSlider() {
                new RangeSlider(this.form);
            }
            filterUpdateFromUrl(e) {
                const t = e.target;
                if (t.matches(selectors$r.filterUpdateUrlButton) || (t.closest(selectors$r.filterUpdateUrlButton) && t)) {
                    e.preventDefault();
                    const s = t.matches(selectors$r.filterUpdateUrlButton) ? t : t.closest(selectors$r.filterUpdateUrlButton);
                    this.submitForm(e, s.getAttribute("href"));
                }
            }
            submitForm(e, t = "") {
                this.sort = this.container.querySelector(`[${selectors$r.sort}]`);
                const s = this.sort ? this.sort.getAttribute(selectors$r.sort) : "";
                if (!e || (e && "popstate" !== e.type))
                    if ("" === t) {
                        let t = new window.URL(window.location.href).searchParams;
                        const i = t,
                            o = Object.fromEntries(i),
                            r = t.toString();
                        if (r.includes("filter.") || r.includes("page=")) for (const e in o) (e.includes("filter.") || "page" === e) && t.delete(e);
                        if (this.form) {
                            const e = new FormData(this.form),
                                s = new URLSearchParams(e),
                                i = this.form.querySelector(selectors$r.rangeMin),
                                o = this.form.querySelector(selectors$r.rangeMax),
                                r = i && i.hasAttribute(selectors$r.rangeMinDefault) ? i.getAttribute(selectors$r.rangeMinDefault) : "",
                                a = o && o.hasAttribute(selectors$r.rangeMaxDefault) ? o.getAttribute(selectors$r.rangeMaxDefault) : "";
                            let n = 0;
                            for (let [e, i] of s.entries()) e.includes("filter.") && i && (t.append(e, i), ((i === r && "filter.v.price.gte" === e) || (i === a && "filter.v.price.lte" === e)) && (n += 1));
                            2 === n && (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"));
                        }
                        if (s || (e && e.detail && e.detail.href)) {
                            const i = s || e.detail.href;
                            t.set("sort_by", i);
                        }
                        const a = t.toString(),
                            n = a ? `?${a}` : location.pathname;
                        window.history.pushState(null, "", n);
                    } else window.history.pushState(null, "", t);
                else this.sort && this.sort.dispatchEvent(new CustomEvent("theme:filter:sort", { bubbles: !1 }));
                this.productsContainer &&
                    (this.productsContainer.classList.add(classes$n.loading),
                    fetch(`${window.location.pathname}${window.location.search}`)
                        .then((e) => e.text())
                        .then((e) => {
                            if (((this.productsContainer.innerHTML = new DOMParser().parseFromString(e, "text/html").querySelector(selectors$r.productsContainer).innerHTML), this.sidebar)) {
                                this.sidebar.innerHTML = new DOMParser().parseFromString(e, "text/html").querySelector(selectors$r.collectionSidebar).innerHTML;
                                const t = this.sidebar.querySelector(`[${selectors$r.activeFiltersCount}]`),
                                    s = this.container.querySelectorAll(selectors$r.activeFilters);
                                if (t && s.length) {
                                    const e = parseInt(t.getAttribute(selectors$r.activeFiltersCount));
                                    s.forEach((t) => {
                                        (t.textContent = e), t.classList.toggle(classes$n.hidden, e < 1);
                                    });
                                }
                            }
                            this.form && ((this.form = this.container.querySelector(selectors$r.form)), this.initRangeSlider());
                            new Collection(this.section).onUnload(!1),
                                makeGridSwatches(this.section),
                                new Siblings(this.section),
                                document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } })),
                                this.collectionNav && scrollTo(this.productsContainer.getBoundingClientRect().top - this.collectionNav.offsetHeight),
                                setTimeout(() => {
                                    this.productsContainer.classList.remove(classes$n.loading);
                                }, 500);
                        })
                        .catch((e) => {
                            console.log(e);
                        }));
            }
            updateRange(e) {
                if (this.form && "function" == typeof this.form.submit) {
                    const t = this.form.querySelector(selectors$r.rangeMin),
                        s = this.form.querySelector(selectors$r.rangeMax),
                        i = this.form.querySelector(selectors$r.priceMin),
                        o = this.form.querySelector(selectors$r.priceMax);
                    if (t && s && i && o && t.hasAttribute(selectors$r.rangeMinValue) && s.hasAttribute(selectors$r.rangeMaxValue)) {
                        const r = parseInt(i.placeholder),
                            a = parseInt(o.placeholder),
                            n = parseInt(t.getAttribute(selectors$r.rangeMinValue)),
                            l = parseInt(s.getAttribute(selectors$r.rangeMaxValue));
                        (r === n && a === l) || ((i.value = n), (o.value = l), this.submitForm(e));
                    }
                }
            }
            constructor(e) {
                (this.section = e),
                    (this.container = this.section.container),
                    (this.sidebar = this.container.querySelector(selectors$r.collectionSidebar)),
                    (this.form = this.container.querySelector(selectors$r.form)),
                    (this.sort = this.container.querySelector(`[${selectors$r.sort}]`)),
                    (this.productsContainer = this.container.querySelector(selectors$r.productsContainer)),
                    (this.collectionNav = this.container.querySelector(selectors$r.collectionNav)),
                    this.init();
            }
        };
    const collectionFiltersForm = {
            onLoad() {
                sections$l[this.id] = new FiltersForm(this);
            },
        },
        selectors$q = {
            dataSort: "data-sort-enabled",
            sortLinks: "[data-sort-link]",
            sortValue: "data-value",
            sortButton: "[data-popout-toggle]",
            sortButtonText: "[data-sort-button-text]",
            collectionSidebarHeading: "[data-collection-sidebar-heading]",
            collectionSidebar: "[data-collection-sidebar]",
            collectionSidebarSlider: "[data-collection-sidebar-slider]",
            collectionSidebarSlideOut: "[data-collection-sidebar-slide-out]",
            collectionSidebarCloseButton: "[data-collection-sidebar-close]",
            showMoreOptions: "[data-show-more]",
            groupTagsButton: "[data-aria-toggle]",
            collectionNav: "[data-collection-nav]",
            linkHidden: "[data-link-hidden]",
            underlay: "[data-drawer-underlay]",
            swatch: "data-swatch",
            animation: "[data-animation]",
        },
        classes$m = { animated: "drawer--animated", hiding: "is-hiding", expanded: "expanded", noMobileAnimation: "no-mobile-animation", hidden: "is-hidden", active: "is-active", focused: "is-focused" };
    let sections$k = {},
        Collection = class {
            init() {
                if ((this.sort && this.initSort(), null !== this.groupTagsButton)) {
                    document.addEventListener("theme:resize", this.sidebarResizeEvent),
                        this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent),
                        this.collectionSidebar &&
                            setTimeout(() => {
                                this.collectionSidebar.classList.remove(classes$m.noMobileAnimation);
                            }, 1e3);
                    new MutationObserver((e) => {
                        for (const t of e)
                            if ("attributes" === t.type) {
                                "true" == t.target.ariaExpanded && this.showSidebarCallback();
                            }
                    }).observe(this.groupTagsButton, { attributes: !0, childList: !1, subtree: !1 });
                }
                this.collectionSidebarCloseButtons.length &&
                    this.collectionSidebarCloseButtons.forEach((e) => {
                        e.addEventListener("click", this.collectionSidebarCloseEvent);
                    }),
                    this.container.addEventListener(
                        "keyup",
                        function (e) {
                            e.code === window.theme.keyboardKeys.ESCAPE && this.hideSidebar();
                        }.bind(this)
                    ),
                    this.underlay && this.underlay.addEventListener("click", this.collectionSidebarCloseEvent),
                    this.showMoreOptions &&
                        this.showMoreOptions.forEach((e) => {
                            e.addEventListener("click", (t) => {
                                t.preventDefault(),
                                    e.parentElement.classList.add(classes$m.hidden),
                                    e.parentElement.previousElementSibling.querySelectorAll(selectors$q.linkHidden).forEach((e, t) => {
                                        e.classList.remove(classes$m.hidden), 0 === t && (window.accessibility.lastFocused = e);
                                    });
                                this.container.querySelector(selectors$q.collectionSidebarSlideOut) &&
                                    (this.accessibility.removeTrapFocus(), this.accessibility.trapFocus(this.collectionSidebar, { elementToFocus: window.accessibility.lastFocused }));
                            });
                        }),
                    this.collectionSidebarHeading &&
                        this.collectionSidebarHeading.forEach((e) => {
                            e.addEventListener("click", (e) => this.collectionAccordion(e)),
                                e.addEventListener("keyup", (e) => {
                                    (e.code !== window.theme.keyboardKeys.SPACE && e.code !== window.theme.keyboardKeys.ENTER) ||
                                        !document.body.classList.contains(classes$m.focused) ||
                                        ((window.accessibility.lastFocused = e.currentTarget), this.collectionAccordion(e));
                                });
                        }),
                    this.swatches &&
                        this.swatches.forEach((e) => {
                            new Swatch(e);
                        }),
                    this.collectionSidebar &&
                        (this.collectionSidebar.addEventListener("transitionend", () => {
                            this.collectionSidebar.classList.contains(classes$m.expanded) || this.collectionSidebar.classList.remove(classes$m.animated);
                        }),
                        this.toggleSidebarSlider());
            }
            collectionAccordion(e) {
                e.preventDefault();
                const t = e.currentTarget;
                t.classList.toggle(classes$m.active), slideToggle(t.nextElementSibling, 500), t.nextElementSibling.nextElementSibling && slideToggle(t.nextElementSibling.nextElementSibling, 500);
                const s = this.container.querySelector(selectors$q.collectionSidebarSlideOut);
                if (s) {
                    const e = () => {
                        this.accessibility.removeTrapFocus(),
                            this.accessibility.trapFocus(this.collectionSidebar),
                            this.accessibility.trapFocus(this.collectionSidebar, { elementToFocus: window.accessibility.lastFocused }),
                            s.removeEventListener("transitionend", e);
                    };
                    s.addEventListener("transitionend", e);
                }
            }
            collectionSidebarScroll() {
                document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } }));
            }
            sortActions(e, t = !0) {
                const s = e ? e.getAttribute(selectors$q.sortValue) : "";
                this.sort.setAttribute(selectors$q.dataSort, s);
                const i = this.sort.querySelector(selectors$q.sortButtonText),
                    o = this.sort.querySelector(`.${classes$m.active}`);
                if (i) {
                    const t = e ? e.textContent.trim() : "";
                    i.textContent = t;
                }
                o && o.classList.remove(classes$m.active),
                    this.sort.classList.toggle(classes$m.active, e),
                    e && (e.parentElement.classList.add(classes$m.active), t && e.dispatchEvent(new CustomEvent("theme:filter:update", { bubbles: !0, detail: { href: s } })));
            }
            onSortButtonClick(e) {
                e.preventDefault(), this.sortButton && this.sortButton.dispatchEvent(new Event("click")), this.sortActions(e.currentTarget);
            }
            onSortCheck(e) {
                let t = null;
                if (window.location.search.includes("sort_by")) {
                    const e = new window.URL(window.location.href).searchParams;
                    for (const [s, i] of e.entries()) {
                        const e = this.sort.querySelector(`[${selectors$q.sortValue}="${i}"]`);
                        if (s.includes("sort_by") && e) {
                            t = e;
                            break;
                        }
                    }
                }
                this.sortActions(t, !1);
            }
            initSort() {
                this.sortLinks.forEach((e) => {
                    e.addEventListener("click", this.onSortButtonClickEvent);
                }),
                    this.sort.addEventListener("theme:filter:sort", this.onSortCheckEvent),
                    this.sortButton &&
                        this.sortButton.addEventListener("click", () => {
                            const e = this.collectionSidebar.classList.contains(classes$m.expanded);
                            isMobile() && e && this.hideSidebar();
                        });
            }
            showSidebarCallback() {
                const e = this.container.querySelector(selectors$q.collectionSidebarSlider),
                    t = this.container.querySelector(selectors$q.collectionSidebarSlideOut),
                    s = e || t,
                    i = document.documentElement.hasAttribute("data-scroll-locked"),
                    o = isMobile();
                this.collectionSidebar.classList.add(classes$m.animated),
                    null === t && !o && i && (this.accessibility.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }))),
                    (o || null !== t) &&
                        (t && this.accessibility.trapFocus(this.collectionSidebar, { elementToFocus: this.collectionSidebar.querySelector(selectors$q.collectionSidebarCloseButton) }),
                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: s }))),
                    s && s.addEventListener("scroll", this.collectionSidebarScrollEvent);
            }
            hideSidebar() {
                const e = this.container.querySelector(selectors$q.collectionSidebarSlider),
                    t = this.container.querySelector(selectors$q.collectionSidebarSlideOut),
                    s = e || t,
                    i = document.documentElement.hasAttribute("data-scroll-locked");
                this.groupTagsButton.setAttribute("aria-expanded", "false"),
                    this.collectionSidebar.classList.remove(classes$m.expanded),
                    s && s.removeEventListener("scroll", this.collectionSidebarScrollEvent),
                    t && this.accessibility.removeTrapFocus(),
                    i && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
            }
            toggleSidebarSlider() {
                isMobile() ? this.hideSidebar() : this.collectionSidebar.classList.contains(classes$m.expanded) && this.showSidebarCallback();
            }
            collectionSidebarClose(e) {
                e.preventDefault(), this.hideSidebar(), document.body.classList.contains(classes$m.focused) && this.groupTagsButton && this.groupTagsButton.focus();
            }
            groupTagsButtonClick() {
                document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
            }
            onUnload(e = !0) {
                null !== this.groupTagsButton && (document.removeEventListener("theme:resize", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)),
                    this.collectionSidebarCloseButtons.length &&
                        e &&
                        this.collectionSidebarCloseButtons.forEach((e) => {
                            e.removeEventListener("click", this.collectionSidebarCloseEvent);
                        }),
                    this.collectionSidebarScrollable & e && this.collectionSidebarScrollable.removeEventListener("scroll", this.collectionSidebarScrollEvent),
                    this.underlay && this.underlay.removeEventListener("click", this.collectionSidebarCloseEvent),
                    this.sort &&
                        (this.sortLinks.forEach((e) => {
                            e.removeEventListener("click", this.onClickEvent);
                        }),
                        this.sort.removeEventListener("theme:filter:sort", this.onSortCheckEvent));
            }
            constructor(e) {
                (this.container = e.container),
                    (this.sort = this.container.querySelector(`[${selectors$q.dataSort}]`)),
                    (this.sortButton = this.container.querySelector(selectors$q.sortButton)),
                    (this.sortLinks = this.container.querySelectorAll(selectors$q.sortLinks)),
                    (this.collectionSidebar = this.container.querySelector(selectors$q.collectionSidebar)),
                    (this.collectionSidebarCloseButtons = this.container.querySelectorAll(selectors$q.collectionSidebarCloseButton)),
                    (this.groupTagsButton = this.container.querySelector(selectors$q.groupTagsButton)),
                    (this.collectionNav = this.container.querySelector(selectors$q.collectionNav)),
                    (this.showMoreOptions = this.container.querySelectorAll(selectors$q.showMoreOptions)),
                    (this.collectionSidebarHeading = this.container.querySelectorAll(selectors$q.collectionSidebarHeading)),
                    (this.underlay = this.container.querySelector(selectors$q.underlay)),
                    (this.swatches = this.container.querySelectorAll(`[${selectors$q.swatch}]`)),
                    (this.accessibility = a11y),
                    (this.groupTagsButtonClickEvent = (e) => this.groupTagsButtonClick(e)),
                    (this.collectionSidebarCloseEvent = (e) => this.collectionSidebarClose(e)),
                    (this.collectionSidebarScrollEvent = () => this.collectionSidebarScroll()),
                    (this.onSortButtonClickEvent = (e) => this.onSortButtonClick(e)),
                    (this.onSortCheckEvent = (e) => this.onSortCheck(e)),
                    (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
                    this.init();
            }
        };
    const collectionSection = {
        onLoad() {
            sections$k[this.id] = new Collection(this);
        },
        onUnload() {
            sections$k[this.id].onUnload();
        },
    };
    register("collection", [slider, parallaxHero, collectionSection, popoutSection, swatchGridSection, collectionFiltersForm, tooltipSection, siblings]),
        customElements.get("quick-add-product") || customElements.define("quick-add-product", QuickAddProduct);
    const selectors$p = { frame: "[data-ticker-frame]", scale: "[data-ticker-scale]", text: "[data-ticker-text]", clone: "data-clone" },
        attributes$a = { speed: "data-marquee-speed" },
        classes$l = { animation: "ticker--animated", unloaded: "ticker--unloaded", comparitor: "ticker__comparitor" },
        settings = { textAnimationTime: 1.63, space: 100 };
    let Ticker = class {
        unload() {
            document.removeEventListener("theme:resize", this.resizeEvent);
        }
        listen() {
            document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth();
        }
        checkWidth() {
            const e = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", ""),
                t = this.frame.getAttribute(attributes$a.speed) ? this.frame.getAttribute(attributes$a.speed) : settings.textAnimationTime;
            if (this.frame.clientWidth - e < this.comparitor.clientWidth || this.stopClone) {
                if ((this.text.classList.add(classes$l.animation), 1 === this.scale.childElementCount)) {
                    if (((this.clone = this.text.cloneNode(!0)), this.clone.setAttribute(selectors$p.clone, ""), this.scale.appendChild(this.clone), this.stopClone))
                        for (let e = 0; e < 10; e++) {
                            const e = this.text.cloneNode(!0);
                            e.setAttribute(selectors$p.clone, ""), this.scale.appendChild(e);
                        }
                    const e = ((this.text.clientWidth / settings.space) * Number(t)).toFixed(2);
                    this.scale.style.setProperty("--animation-time", `${e}s`);
                }
            } else {
                this.text.classList.add(classes$l.animation);
                let e = this.scale.querySelector(`[${selectors$p.clone}]`);
                e && this.scale.removeChild(e), this.text.classList.remove(classes$l.animation);
            }
        }
        constructor(e, t = !1) {
            (this.frame = e),
                (this.stopClone = t),
                (this.scale = this.frame.querySelector(selectors$p.scale)),
                (this.text = this.frame.querySelector(selectors$p.text)),
                (this.comparitor = this.text.cloneNode(!0)),
                this.comparitor.classList.add(classes$l.comparitor),
                this.frame.appendChild(this.comparitor),
                this.scale.classList.remove(classes$l.unloaded),
                (this.resizeEvent = debounce(() => this.checkWidth(), 100)),
                this.listen();
        }
    };
    const selectors$o = {
            bar: "[data-bar]",
            barSlide: "[data-slide]",
            frame: "[data-ticker-frame]",
            header: "[data-header-wrapper]",
            slider: "[data-slider]",
            marquee: "[data-marquee]",
            tickerScale: "[data-ticker-scale]",
            tickerText: "[data-ticker-text]",
        },
        classes$k = { tickerAnimated: "ticker--animated" },
        attributes$9 = { slide: "data-slide", stop: "data-stop", style: "style", targetReferrer: "data-target-referrer" },
        sections$j = {};
    let Bar = class {
        init() {
            this.removeAnnouncement(), this.slider && this.initSliders(), this.marquee && this.initTickers(!0), document.dispatchEvent(new CustomEvent("theme:announcement:init", { bubbles: !0 }));
        }
        removeAnnouncement() {
            for (let e = 0; e < this.slides.length; e++) {
                const t = this.slides[e];
                t.hasAttribute(attributes$9.targetReferrer) && (-1 !== this.locationPath.indexOf(t.getAttribute(attributes$9.targetReferrer)) || window.Shopify.designMode || t.parentNode.removeChild(t));
            }
        }
        initSliders() {
            (this.slider = new Slider(this.barHolder)),
                this.slider.flkty
                    ? (this.slider.flkty.reposition(),
                      this.barHolder.addEventListener("theme:slider:loaded", () => {
                          this.initTickers();
                      }))
                    : this.initTickers();
        }
        initTickers(e = !1) {
            this.barHolder.querySelectorAll(selectors$o.frame).forEach((t) => {
                new Ticker(t, e);
            });
        }
        toggleTicker(e, t) {
            const s = document.querySelector(selectors$o.tickerScale),
                i = document.querySelector(`[${attributes$9.slide}="${e.detail.blockId}"]`);
            t &&
                i &&
                (s.setAttribute(attributes$9.stop, ""),
                s.querySelectorAll(selectors$o.tickerText).forEach((e) => {
                    e.classList.remove(classes$k.tickerAnimated), (e.style.transform = `translate3d(${-(i.offsetLeft - i.clientWidth)}px, 0, 0)`);
                })),
                !t &&
                    i &&
                    (s.querySelectorAll(selectors$o.tickerText).forEach((e) => {
                        e.classList.add(classes$k.tickerAnimated), e.removeAttribute(attributes$9.style);
                    }),
                    s.removeAttribute(attributes$9.stop));
        }
        onBlockSelect(e) {
            this.slider ? this.slider.onBlockSelect(e) : this.toggleTicker(e, !0);
        }
        onBlockDeselect(e) {
            this.slider ? this.slider.onBlockDeselect(e) : this.toggleTicker(e, !1);
        }
        constructor(e) {
            (this.barHolder = e),
                (this.locationPath = location.href),
                (this.slides = this.barHolder.querySelectorAll(selectors$o.barSlide)),
                (this.slider = this.barHolder.querySelector(selectors$o.slider)),
                (this.marquee = this.barHolder.querySelector(selectors$o.marquee)),
                this.init();
        }
    };
    const bar = {
        onLoad() {
            sections$j[this.id] = [];
            const e = this.container.querySelector(selectors$o.bar);
            e && sections$j[this.id].push(new Bar(e));
        },
        onBlockSelect(e) {
            sections$j[this.id].length &&
                sections$j[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
        },
        onBlockDeselect(e) {
            sections$j[this.id].length &&
                sections$j[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
                });
        },
    };
    register("announcement", [bar]);
    const selectors$n = {
            body: "body",
            drawerWrappper: "[data-drawer]",
            drawerInner: "[data-drawer-inner]",
            underlay: "[data-drawer-underlay]",
            stagger: "[data-stagger-animation]",
            wrapper: "[data-header-transparent]",
            drawerToggle: "data-drawer-toggle",
            scrollableElements: "[data-sliderule-pane], [data-sliderule]",
            focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        },
        classes$j = { animated: "drawer--animated", open: "is-open", isFocused: "is-focused", headerStuck: "js__header__stuck" };
    let sections$i = {},
        Drawer = class {
            connectToggle() {
                this.buttons.forEach((e) => {
                    e.addEventListener("click", () => {
                        this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1 }));
                    });
                });
            }
            connectDrawer() {
                this.drawer.addEventListener("theme:drawer:toggle", () => {
                    this.drawer.classList.contains(classes$j.open) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !0 })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !0 }));
                }),
                    this.drawerInner &&
                        this.drawerInner.addEventListener("transitionend", (e) => {
                            e.target == this.drawerInner &&
                                (this.drawer.classList.contains(classes$j.open) || (this.drawer.classList.remove(classes$j.animated), document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 }))));
                        }),
                    document.addEventListener("theme:cart:open", this.hideDrawer),
                    document.addEventListener("theme:drawer:close", this.hideDrawer),
                    document.addEventListener("theme:drawer:open", this.showDrawer);
            }
            watchFocus(e) {
                !this.wrapper.contains(e.target) && this.body.classList.contains(classes$j.isFocused) && this.hideDrawer();
            }
            closers() {
                this.wrapper.addEventListener(
                    "keyup",
                    function (e) {
                        e.code === window.theme.keyboardKeys.ESCAPE && (this.hideDrawer(), this.buttons[0].focus());
                    }.bind(this)
                ),
                    this.underlay.addEventListener("click", () => {
                        this.hideDrawer();
                    });
            }
            showDrawer() {
                this.drawerInner &&
                    this.drawerInner.querySelector(this.btnSelector) &&
                    (this.accessibility.removeTrapFocus(),
                    this.drawerInner.addEventListener("transitionend", (e) => {
                        e.target == this.drawerInner && this.drawer.classList.contains(classes$j.open) && this.accessibility.trapFocus(this.drawerInner, { elementToFocus: this.drawerInner.querySelector(this.btnSelector) });
                    })),
                    this.buttons.forEach((e) => {
                        e.setAttribute("aria-expanded", !0);
                    }),
                    this.drawer.classList.add(classes$j.open),
                    this.drawer.classList.add(classes$j.animated),
                    this.drawer.querySelector(selectors$n.focusable).focus(),
                    document.addEventListener("focusin", this.initWatchFocus),
                    this.scrollableElements.length &&
                        this.scrollableElements.forEach((e) => {
                            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: e }));
                        });
            }
            hideDrawer() {
                this.drawer.classList.contains(classes$j.open) &&
                    (this.accessibility.removeTrapFocus(),
                    this.body.classList.contains(classes$j.isFocused) && this.buttons.length && this.buttons[0].focus(),
                    this.buttons.forEach((e) => {
                        e.setAttribute("aria-expanded", !1);
                    }),
                    this.drawer.classList.remove(classes$j.open),
                    document.removeEventListener("focusin", this.initWatchFocus),
                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
            }
            onUnload() {
                document.removeEventListener("theme:cart:open", this.hideDrawer), document.removeEventListener("theme:drawer:close", this.hideDrawer), document.removeEventListener("theme:drawer:open", this.showDrawer);
            }
            constructor(e) {
                (this.drawer = e),
                    (this.drawerWrapper = this.drawer.closest(selectors$n.drawerWrappper)),
                    (this.drawerInner = this.drawer.querySelector(selectors$n.drawerInner)),
                    (this.scrollableElements = this.drawer.querySelectorAll(selectors$n.scrollableElements)),
                    (this.underlay = this.drawer.querySelector(selectors$n.underlay)),
                    (this.wrapper = this.drawer.closest(selectors$n.wrapper)),
                    (this.key = this.drawer.dataset.drawer),
                    (this.btnSelector = `[${selectors$n.drawerToggle}='${this.key}']`),
                    (this.buttons = document.querySelectorAll(this.btnSelector)),
                    (this.staggers = this.drawer.querySelectorAll(selectors$n.stagger)),
                    (this.body = document.querySelector(selectors$n.body)),
                    (this.accessibility = a11y),
                    (this.initWatchFocus = (e) => this.watchFocus(e)),
                    (this.showDrawer = this.showDrawer.bind(this)),
                    (this.hideDrawer = this.hideDrawer.bind(this)),
                    this.connectToggle(),
                    this.connectDrawer(),
                    this.closers();
            }
        };
    const drawer = {
            onLoad() {
                sections$i[this.id] = [];
                this.container.querySelectorAll(selectors$n.drawerWrappper).forEach((e) => {
                    sections$i[this.id].push(new Drawer(e));
                });
            },
            onUnload() {
                sections$i[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload();
                });
            },
        },
        selectors$m = { headerWrapper: "[data-header-wrapper]", header: "[data-header-wrapper] header", pageHeader: ".page-header" },
        classes$i = {
            stuck: "js__header__stuck",
            stuckAnimated: "js__header__stuck--animated",
            triggerAnimation: "js__header__stuck--trigger-animation",
            stuckBackdrop: "js__header__stuck__backdrop",
            headerIsNotVisible: "is-not-visible",
            hasStickyHeader: "has-sticky-header",
            headerGroup: "shopify-section-group-header-group",
        },
        attributes$8 = { transparent: "data-header-transparent", stickyHeader: "data-header-sticky", scrollLock: "data-scroll-locked" };
    let sections$h = {},
        Sticky = class {
            unload() {
                (this.sticks || this.animated) && document.removeEventListener("theme:scroll", this.scrollEventListen),
                    this.animated && (document.removeEventListener("theme:scroll:up", this.scrollEventUpListen), document.removeEventListener("theme:scroll:down", this.scrollEventDownListen)),
                    this.static && document.removeEventListener("theme:scroll", this.scrollEventStatic),
                    document.removeEventListener("shopify:section:load", this.updateHeaderOffset),
                    document.removeEventListener("shopify:section:unload", this.updateHeaderOffset);
            }
            listen() {
                (this.sticks || this.animated) && document.addEventListener("theme:scroll", this.scrollEventListen),
                    this.animated && (document.addEventListener("theme:scroll:up", this.scrollEventUpListen), document.addEventListener("theme:scroll:down", this.scrollEventDownListen)),
                    document.addEventListener("shopify:section:load", this.updateHeaderOffset),
                    document.addEventListener("shopify:section:unload", this.updateHeaderOffset);
            }
            listenScroll(e) {
                e.detail.down
                    ? (!this.currentlyStuck && e.detail.position > this.headerOffset && this.stickSimple(), !this.currentlyBlurred && e.detail.position > this.headerOffset && this.addBlur())
                    : (e.detail.position <= this.headerOffset && this.unstickSimple(), e.detail.position <= this.headerOffset && this.removeBlur());
            }
            updateHeaderOffset(e) {
                e.target.classList.contains(classes$i.headerGroup) &&
                    setTimeout(() => {
                        var e;
                        this.headerOffset = null === (e = document.querySelector(selectors$m.pageHeader)) || void 0 === e ? void 0 : e.offsetTop;
                    });
            }
            stickSimple() {
                this.animated && this.cls.add(classes$i.stuckAnimated), this.cls.add(classes$i.stuck), this.wrapper.setAttribute(attributes$8.transparent, !1), (this.currentlyStuck = !0);
            }
            unstickSimple() {
                document.documentElement.hasAttribute(attributes$8.scrollLock) ||
                    (this.cls.remove(classes$i.stuck), this.wrapper.setAttribute(attributes$8.transparent, theme.settings.transparentHeader), this.animated && this.cls.remove(classes$i.stuckAnimated), (this.currentlyStuck = !1));
            }
            scrollDownInit() {
                window.scrollY > this.headerOffset && this.stickSimple(), window.scrollY > this.headerOffset && this.addBlur();
            }
            stickDirectional() {
                this.cls.add(classes$i.triggerAnimation);
            }
            unstickDirectional() {
                this.cls.remove(classes$i.triggerAnimation);
            }
            scrollDownDirectional() {
                this.unstickDirectional();
            }
            scrollUpDirectional() {
                window.scrollY <= this.headerOffset ? this.unstickDirectional() : this.stickDirectional();
            }
            addBlur() {
                this.cls.add(classes$i.stuckBackdrop), (this.currentlyBlurred = !0);
            }
            removeBlur() {
                this.cls.remove(classes$i.stuckBackdrop), (this.currentlyBlurred = !1);
            }
            checkIsVisible() {
                const e = document.querySelector(selectors$m.headerWrapper),
                    t = e.getAttribute(attributes$8.stickyHeader),
                    s = this.win.pageYOffset;
                t || e.classList.toggle(classes$i.headerIsNotVisible, s >= this.headerHeight);
            }
            constructor(e) {
                var t;
                (this.wrapper = e),
                    (this.type = this.wrapper.dataset.headerSticky),
                    (this.sticks = !1),
                    (this.static = !0),
                    this.wrapper.hasAttribute(attributes$8.stickyHeader) && ((this.sticks = !0), (this.static = !1)),
                    (this.win = window),
                    (this.animated = "directional" === this.type),
                    (this.currentlyStuck = !1),
                    (this.cls = this.wrapper.classList),
                    (this.headerOffset = null === (t = document.querySelector(selectors$m.pageHeader)) || void 0 === t ? void 0 : t.offsetTop),
                    (this.headerHeight = document.querySelector(selectors$m.header).clientHeight),
                    (this.scrollEventStatic = () => this.checkIsVisible()),
                    (this.scrollEventListen = (e) => this.listenScroll(e)),
                    (this.scrollEventUpListen = () => this.scrollUpDirectional()),
                    (this.scrollEventDownListen = () => this.scrollDownDirectional()),
                    (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                    this.sticks && (this.scrollDownInit(), document.body.classList.add(classes$i.hasStickyHeader)),
                    this.static && document.addEventListener("theme:scroll", this.scrollEventStatic),
                    this.listen();
            }
        };
    const stickyHeader = {
            onLoad() {
                sections$h = new Sticky(this.container);
            },
            onUnload: function () {
                "function" == typeof sections$h.unload && sections$h.unload();
            },
        },
        selectors$l = {
            disclosureToggle: "data-hover-disclosure-toggle",
            disclosureWrappper: "[data-hover-disclosure]",
            link: "[data-top-link]",
            wrapper: "[data-header-wrapper]",
            stagger: "[data-stagger]",
            staggerPair: "[data-stagger-first]",
            staggerAfter: "[data-stagger-second]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        },
        classes$h = { isVisible: "is-visible", meganavVisible: "meganav--visible", meganavIsTransitioning: "meganav--is-transitioning" };
    let sections$g = {},
        disclosures = {},
        HoverDisclosure = class {
            onBlockSelect(e) {
                this.disclosure.contains(e.target) && this.showDisclosure(e);
            }
            onBlockDeselect(e) {
                this.disclosure.contains(e.target) && this.hideDisclosure();
            }
            showDisclosure(e) {
                e && e.type && "mouseenter" === e.type && this.wrapper.classList.add(classes$h.meganavIsTransitioning),
                    this.grandparent ? this.wrapper.classList.add(classes$h.meganavVisible) : this.wrapper.classList.remove(classes$h.meganavVisible),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(classes$h.isVisible),
                    this.disclosure.classList.add(classes$h.isVisible),
                    this.transitionTimeout && clearTimeout(this.transitionTimeout),
                    (this.transitionTimeout = setTimeout(() => {
                        this.wrapper.classList.remove(classes$h.meganavIsTransitioning);
                    }, 200));
            }
            hideDisclosure() {
                this.disclosure.classList.remove(classes$h.isVisible),
                    this.trigger.classList.remove(classes$h.isVisible),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(classes$h.meganavVisible, classes$h.meganavIsTransitioning);
            }
            staggerChildAnimations() {
                this.disclosure.querySelectorAll(selectors$l.stagger).forEach((e, t) => {
                    e.style.transitionDelay = 50 * t + 10 + "ms";
                });
                this.disclosure.querySelectorAll(selectors$l.staggerPair).forEach((e, t) => {
                    const s = 100 * t;
                    (e.style.transitionDelay = `${s}ms`),
                        e.parentElement.querySelectorAll(selectors$l.staggerAfter).forEach((e, t) => {
                            const i = 20 * (t + 1);
                            e.style.transitionDelay = `${s + i}ms`;
                        });
                });
            }
            handleTablets() {
                this.trigger.addEventListener(
                    "touchstart",
                    function (e) {
                        this.disclosure.classList.contains(classes$h.isVisible) || (e.preventDefault(), this.showDisclosure(e));
                    }.bind(this),
                    { passive: !0 }
                );
            }
            connectHoverToggle() {
                this.trigger.addEventListener("mouseenter", (e) => this.showDisclosure(e)),
                    this.link.addEventListener("focus", (e) => this.showDisclosure(e)),
                    this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                    this.trigger.addEventListener("focusout", (e) => {
                        this.trigger.contains(e.relatedTarget) || this.hideDisclosure();
                    }),
                    this.disclosure.addEventListener("keyup", (e) => {
                        e.code === window.theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                    });
            }
            constructor(e) {
                (this.disclosure = e),
                    (this.wrapper = e.closest(selectors$l.wrapper)),
                    (this.key = this.disclosure.id),
                    (this.trigger = document.querySelector(`[${selectors$l.disclosureToggle}='${this.key}']`)),
                    (this.link = this.trigger.querySelector(selectors$l.link)),
                    (this.grandparent = this.trigger.classList.contains("grandparent")),
                    (this.transitionTimeout = 0),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
            }
        };
    const hoverDisclosure = {
            onLoad() {
                (sections$g[this.id] = []),
                    (disclosures = this.container.querySelectorAll(selectors$l.disclosureWrappper)),
                    disclosures.forEach((e) => {
                        sections$g[this.id].push(new HoverDisclosure(e));
                    });
            },
            onBlockSelect(e) {
                sections$g[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
            onBlockDeselect(e) {
                sections$g[this.id].forEach((t) => {
                    "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                });
            },
        },
        selectors$k = { count: "data-cart-count" };
    let Totals = class {
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (e) {
                    (this.cart = e.detail.cart), this.update();
                }.bind(this)
            );
        }
        update() {
            this.cart &&
                this.counts.forEach((e) => {
                    e.setAttribute(selectors$k.count, this.cart.item_count), (e.innerHTML = this.cart.item_count < 10 ? `${this.cart.item_count}` : "9+");
                });
        }
        constructor(e) {
            (this.section = e), (this.counts = this.section.querySelectorAll(`[${selectors$k.count}]`)), (this.cart = null), this.listen();
        }
    };
    const headerTotals = {
            onLoad() {
                new Totals(this.container);
            },
        },
        selectors$j = {
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            drawerContent: "[data-drawer-content]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            dataAnimates: "data-animates",
            children: ":scope > [data-animates], \n             :scope > * > [data-animates], \n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
        },
        classes$g = { isVisible: "is-visible", isHiding: "is-hiding", isHidden: "is-hidden", focused: "is-focused", scrolling: "is-scrolling" };
    let sections$f = {},
        HeaderMobileSliderule = class {
            clickEvents() {
                this.trigger.addEventListener("click", () => {
                    (this.cachedButton = this.trigger), this.showSliderule();
                }),
                    this.exit.forEach((e) => {
                        e.addEventListener("click", () => {
                            this.hideSliderule();
                        });
                    });
            }
            keyboardEvents() {
                this.sliderule.addEventListener("keyup", (e) => {
                    e.stopPropagation(), e.code === window.theme.keyboardKeys.ESCAPE && this.hideSliderule();
                });
            }
            trapFocusSliderule(e = !0) {
                const t = e ? this.sliderule.querySelector(this.exitSelector) : this.cachedButton;
                this.accessibility.removeTrapFocus(), t && this.drawerContent && this.accessibility.trapFocus(this.drawerContent, { elementToFocus: document.body.classList.contains(classes$g.focused) ? t : null });
            }
            hideSliderule(e = !1) {
                const t = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                this.pane.setAttribute(selectors$j.sliderulePane, t), this.pane.classList.add(classes$g.isHiding), this.sliderule.classList.add(classes$g.isHiding);
                const s = e ? `[${selectors$j.dataAnimates}].${classes$g.isHidden}` : `[${selectors$j.dataAnimates}="${t}"]`,
                    i = this.pane.querySelectorAll(s);
                i.length &&
                    i.forEach((e) => {
                        e.classList.remove(classes$g.isHidden);
                    });
                const o = e ? this.pane.querySelectorAll(`.${classes$g.isVisible}, .${classes$g.isHiding}`) : this.children;
                o.forEach((s, i) => {
                    const r = o.length - 1 == i;
                    s.classList.remove(classes$g.isVisible), e && (s.classList.remove(classes$g.isHiding), this.pane.classList.remove(classes$g.isHiding));
                    const a = () => {
                        parseInt(this.pane.getAttribute(selectors$j.sliderulePane)) === t && this.sliderule.classList.remove(classes$g.isVisible),
                            this.sliderule.classList.remove(classes$g.isHiding),
                            this.pane.classList.remove(classes$g.isHiding),
                            r && (this.accessibility.removeTrapFocus(), e || this.trapFocusSliderule(!1)),
                            s.removeEventListener("animationend", a);
                    };
                    window.theme.settings.enableAnimations ? s.addEventListener("animationend", a) : a();
                });
            }
            showSliderule() {
                let e = null;
                const t = this.sliderule.closest(`.${classes$g.isVisible}`);
                let s = this.pane;
                t && (s = t), s.scrollTo({ top: 0, left: 0, behavior: "smooth" }), s.classList.add(classes$g.scrolling);
                const i = () => {
                    s.scrollTop <= 0 ? (s.classList.remove(classes$g.scrolling), e && cancelAnimationFrame(e)) : (e = requestAnimationFrame(i));
                };
                (e = requestAnimationFrame(i)), this.sliderule.classList.add(classes$g.isVisible);
                const o = parseInt(this.pane.dataset.sliderulePane, 10),
                    r = o + 1;
                this.pane.setAttribute(selectors$j.sliderulePane, r);
                const a = this.pane.querySelectorAll(`[${selectors$j.dataAnimates}="${o}"]`);
                a.length &&
                    a.forEach((e, t) => {
                        const s = a.length - 1 == t;
                        e.classList.add(classes$g.isHiding);
                        const i = () => {
                            e.classList.remove(classes$g.isHiding),
                                parseInt(this.pane.getAttribute(selectors$j.sliderulePane)) !== o && e.classList.add(classes$g.isHidden),
                                s && this.trapFocusSliderule(),
                                e.removeEventListener("animationend", i);
                        };
                        window.theme.settings.enableAnimations ? e.addEventListener("animationend", i) : i();
                    });
            }
            closeSliderule() {
                this.pane &&
                    this.pane.hasAttribute(selectors$j.sliderulePane) &&
                    parseInt(this.pane.getAttribute(selectors$j.sliderulePane)) > 0 &&
                    (this.hideSliderule(!0), parseInt(this.pane.getAttribute(selectors$j.sliderulePane)) > 0 && this.pane.setAttribute(selectors$j.sliderulePane, 0));
            }
            onUnload() {
                document.removeEventListener("theme:sliderule:close", this.closeSliderule);
            }
            constructor(e) {
                (this.sliderule = e), (this.key = this.sliderule.id);
                const t = `[${selectors$j.slideruleOpen}='${this.key}']`;
                (this.exitSelector = `[${selectors$j.slideruleClose}='${this.key}']`),
                    (this.trigger = document.querySelector(t)),
                    (this.exit = document.querySelectorAll(this.exitSelector)),
                    (this.pane = document.querySelector(`[${selectors$j.sliderulePane}]`)),
                    (this.children = this.sliderule.querySelectorAll(selectors$j.children)),
                    (this.drawerContent = document.querySelector(selectors$j.drawerContent)),
                    (this.cachedButton = null),
                    (this.accessibility = a11y),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    (this.closeSliderule = this.closeSliderule.bind(this)),
                    this.clickEvents(),
                    this.keyboardEvents(),
                    document.addEventListener("theme:sliderule:close", this.closeSliderule);
            }
        };
    const headerMobileSliderule = {
            onLoad() {
                sections$f[this.id] = [];
                this.container.querySelectorAll(selectors$j.slideruleWrappper).forEach((e) => {
                    sections$f[this.id].push(new HeaderMobileSliderule(e));
                });
            },
            onUnload() {
                sections$f[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload();
                });
            },
        },
        selectors$i = {
            wrapper: "[data-header-wrapper]",
            html: "html",
            style: "data-header-style",
            widthContentWrapper: "[data-takes-space-wrapper]",
            widthContent: "[data-child-takes-space]",
            desktop: "[data-header-desktop]",
            cloneClass: "js__header__clone",
            showMobileClass: "js__show__mobile",
            backfill: "[data-header-backfill]",
            transparent: "data-header-transparent",
            firstSectionHasImage: ".main-content > .shopify-section:first-child [data-overlay-header]",
            preventTransparentHeader: ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
            deadLink: '.navlink[href="#"]',
        },
        classes$f = { hasTransparentHeader: "has-transparent-header" };
    let sections$e = {},
        Header = class {
            checkForImage() {
                this.overlayedImages = document.querySelectorAll(selectors$i.firstSectionHasImage);
                let e = document.querySelectorAll(selectors$i.preventTransparentHeader).length;
                this.overlayedImages.length && !e && this.isTransparentHeader
                    ? (this.listenOverlay(),
                      this.wrapper.setAttribute(selectors$i.transparent, !0),
                      (document.querySelector(selectors$i.backfill).style.display = "none"),
                      (theme.settings.transparentHeader = !0),
                      document.body.classList.add(classes$f.hasTransparentHeader))
                    : (this.wrapper.setAttribute(selectors$i.transparent, !1),
                      (document.querySelector(selectors$i.backfill).style.display = "block"),
                      (theme.settings.transparentHeader = !1),
                      document.body.classList.remove(classes$f.hasTransparentHeader)),
                    this.subtractAnnouncementHeight();
            }
            listenOverlay() {
                document.addEventListener("theme:resize", this.resizeEventOverlay), this.subtractAnnouncementHeight();
            }
            listenWidth() {
                document.addEventListener("theme:resize", this.resizeEventWidth), this.checkWidth();
            }
            listenSectionEvents() {
                document.addEventListener("shopify:section:load", this.headerUpdateEvent),
                    document.addEventListener("shopify:section:unload", this.headerUpdateEvent),
                    document.addEventListener("shopify:section:reorder", this.headerUpdateEvent);
            }
            killDeadLinks() {
                this.deadLinks.forEach((e) => {
                    e.onclick = (e) => {
                        e.preventDefault();
                    };
                });
            }
            subtractAnnouncementHeight() {
                const e = getScreenOrientation(),
                    { announcementHeight: t, headerHeight: s } = readHeights();
                let { windowHeight: i } = readHeights();
                this.screenOrientation === e && isMobile() ? (i = window.initialWindowHeight) : (window.initialWindowHeight = i),
                    this.overlayedImages.forEach((e) => {
                        theme.settings.transparentHeader ? e.style.setProperty("--full-screen", i - t + "px") : e.style.setProperty("--full-screen", i - s + "px"), e.classList.add("has-overlay");
                    }),
                    this.screenOrientation !== e && (this.screenOrientation = e);
            }
            checkWidth() {
                document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(selectors$i.showMobileClass) : this.wrapper.classList.remove(selectors$i.showMobileClass);
            }
            getMinWidth() {
                const e = this.wrapper.cloneNode(!0);
                e.classList.add(selectors$i.cloneClass), document.body.appendChild(e);
                const t = e.querySelectorAll(selectors$i.widthContentWrapper);
                let s = 0,
                    i = 0;
                return (
                    t.forEach((e) => {
                        const t = e.querySelectorAll(selectors$i.widthContent);
                        let o = 0;
                        (o = 3 === t.length ? _sumSplitWidths(t) : _sumWidths(t)), o > s && ((s = o), (i = 20 * t.length));
                    }),
                    document.body.removeChild(e),
                    s + i
                );
            }
            unload() {
                document.removeEventListener("theme:resize", this.resizeEventWidth),
                    document.removeEventListener("theme:resize", this.resizeEventOverlay),
                    document.removeEventListener("shopify:section:load", this.headerUpdateEvent),
                    document.removeEventListener("shopify:section:unload", this.headerUpdateEvent),
                    document.removeEventListener("shopify:section:reorder", this.headerUpdateEvent);
            }
            constructor(e) {
                (this.wrapper = e),
                    (this.html = document.querySelector(selectors$i.html)),
                    (this.style = this.wrapper.dataset.style),
                    (this.desktop = this.wrapper.querySelector(selectors$i.desktop)),
                    (this.isTransparentHeader = "false" !== this.wrapper.getAttribute(selectors$i.transparent)),
                    (this.overlayedImages = document.querySelectorAll(selectors$i.firstSectionHasImage)),
                    (this.deadLinks = document.querySelectorAll(selectors$i.deadLink)),
                    (this.headerUpdateEvent = debounce(() => this.checkForImage(), 500)),
                    (this.resizeEventWidth = () => this.checkWidth()),
                    (this.resizeEventOverlay = () => this.subtractAnnouncementHeight()),
                    this.killDeadLinks(),
                    "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                    this.checkForImage(),
                    this.listenSectionEvents(),
                    (this.screenOrientation = getScreenOrientation());
            }
        };
    function _sumSplitWidths(e) {
        let t = [];
        e.forEach((e) => {
            e.firstElementChild && t.push(e.firstElementChild.clientWidth);
        }),
            t[0] > t[2] ? (t[2] = t[0]) : (t[0] = t[2]);
        return t.reduce((e, t) => e + t);
    }
    function _sumWidths(e) {
        let t = 0;
        return (
            e.forEach((e) => {
                t += e.clientWidth;
            }),
            t
        );
    }
    const header = {
        onLoad() {
            (sections$e = new Header(this.container)), setVarsOnResize();
        },
        onUnload() {
            "function" == typeof sections$e.unload && sections$e.unload();
        },
    };
    register("header", [header, drawer, popoutSection, headerMobileSliderule, stickyHeader, hoverDisclosure, headerTotals]);
    const selectors$h = { scrollElement: "[data-block-scroll]", flickityEnabled: "flickity-enabled" },
        sections$d = {};
    let BlockScroll = class {
        onBlockSelect(e) {
            const t = this.container.querySelector(selectors$h.scrollElement);
            if (t && !t.classList.contains(selectors$h.flickityEnabled)) {
                const s = e.srcElement;
                s && t.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" });
            }
        }
        constructor(e) {
            this.container = e.container;
        }
    };
    const blockScroll = {
            onLoad() {
                sections$d[this.id] = new BlockScroll(this);
            },
            onBlockSelect(e) {
                sections$d[this.id].onBlockSelect(e);
            },
        },
        selectors$g = {
            slider: "[data-slider-mobile]",
            slide: "[data-slide]",
            thumb: "[data-slider-thumb]",
            sliderContainer: "[data-slider-container]",
            popupContainer: "[data-popup-container]",
            popupContent: "[data-popup-content]",
            popupClose: "[data-popup-close]",
            headerSticky: "[data-header-sticky]",
            headerHeight: "[data-header-height]",
        },
        classes$e = { isAnimating: "is-animating", isSelected: "is-selected", isOpen: "is-open" },
        attributes$7 = { thumbValue: "data-slider-thumb" },
        sections$c = {};
    let Look = class {
        init() {
            this.slider &&
                this.slides.length &&
                this.thumbs.length &&
                (this.popupContainer.addEventListener("transitionend", () => {
                    this.popupContainer.classList.remove(classes$e.isAnimating);
                }),
                this.popupContainer.addEventListener("transitionstart", () => {
                    this.popupContainer.classList.add(classes$e.isAnimating);
                }),
                this.popupClose.forEach((e) => {
                    e.addEventListener("click", () => {
                        this.popupContainer.classList.remove(classes$e.isOpen), this.scrollUnlock();
                    });
                }),
                this.thumbs.forEach((e, t) => {
                    e.addEventListener("click", (s) => {
                        s.preventDefault();
                        const i = e.hasAttribute(attributes$7.thumbValue) && "" !== e.getAttribute(attributes$7.thumbValue) ? parseInt(e.getAttribute(attributes$7.thumbValue)) : t,
                            o = this.slides[i];
                        if (isMobile()) {
                            const e = parseInt(window.getComputedStyle(this.slider).paddingLeft),
                                t = o.offsetLeft;
                            this.slider.scrollTo({ top: 0, left: t - e, behavior: "auto" }), this.scrollLock(), this.popupContainer.classList.add(classes$e.isAnimating, classes$e.isOpen);
                        } else {
                            const e = document.querySelector(selectors$g.headerSticky) && document.querySelector(selectors$g.headerHeight) ? document.querySelector(selectors$g.headerHeight).getBoundingClientRect().height : 0,
                                t = o.getBoundingClientRect().top,
                                s = o.offsetHeight / 2,
                                i = window.innerHeight,
                                r = i / 2,
                                a = this.container.querySelector(selectors$g.sliderContainer);
                            let n = t + s - r + window.scrollY;
                            if (a) {
                                const t = a.getBoundingClientRect().top + window.scrollY,
                                    s = t + a.offsetHeight;
                                n < t ? (n = t - e) : n + i > s && (n = s - i);
                            }
                            window.scrollTo({ top: n, left: 0, behavior: "smooth" });
                        }
                    });
                }));
        }
        scrollLock() {
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.slider })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupContent }));
        }
        scrollUnlock() {
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        constructor(e) {
            (this.container = e.container),
                (this.slider = this.container.querySelector(selectors$g.slider)),
                (this.slides = this.container.querySelectorAll(selectors$g.slide)),
                (this.thumbs = this.container.querySelectorAll(selectors$g.thumb)),
                (this.popupContainer = this.container.querySelector(selectors$g.popupContainer)),
                (this.popupContent = this.container.querySelector(selectors$g.popupContent)),
                (this.popupClose = this.container.querySelectorAll(selectors$g.popupClose)),
                this.init();
        }
    };
    const lookSection = {
        onLoad() {
            sections$c[this.id] = new Look(this);
        },
    };
    register("look", [lookSection, swatchGridSection, siblings, blockScroll]), customElements.get("quick-add-product") || customElements.define("quick-add-product", QuickAddProduct);
    const selectors$f = {
            body: "body",
            dataRelatedSectionElem: "[data-related-section]",
            dataTabsHolder: "[data-tabs-holder]",
            dataTab: "data-tab",
            dataTabIndex: "data-tab-index",
            dataTabStartIndex: "data-start-index",
            dataTabStartIndexMobile: "data-start-index-mobile",
            dataAos: "[data-aos]",
            blockId: "data-block-id",
            tabsLi: "[data-tab]",
            tabLink: ".tab-link",
            tabLinkRecent: ".tab-link__recent",
            tabContent: ".tab-content",
            scrollbarHolder: "[data-scrollbar]",
            productModal: "[data-product-modal]",
        },
        classes$d = { current: "current", hidden: "hidden", alt: "alt", aosAnimate: "aos-animate", aosNoTransition: "aos-no-transition", focused: "is-focused" },
        sections$b = {};
    let GlobalTabs = class {
        init() {
            const e = this.container,
                t = e.querySelectorAll(selectors$f.tabsLi),
                s = e.hasAttribute(selectors$f.dataTabStartIndex) ? e.getAttribute(selectors$f.dataTabStartIndex) : 0;
            let i = e.querySelector(`${selectors$f.tabLink}-${s}`),
                o = e.querySelector(`${selectors$f.tabContent}-${s}`);
            if (isMobile()) {
                const t = e.hasAttribute(selectors$f.dataTabStartIndexMobile) ? e.getAttribute(selectors$f.dataTabStartIndexMobile) : s;
                (i = e.querySelector(`${selectors$f.tabLink}-${t}`)), (o = e.querySelector(`${selectors$f.tabContent}-${t}`));
            }
            o && o.classList.add(classes$d.current),
                i && i.classList.add(classes$d.current),
                this.checkVisibleTabLinks(),
                this.container.addEventListener("theme:tab:check", () => this.checkRecentTab()),
                this.container.addEventListener("theme:tab:hide", () => this.hideRelatedTab()),
                t.length &&
                    t.forEach((t) => {
                        const s = parseInt(t.getAttribute(selectors$f.dataTab)),
                            i = e.querySelector(`${selectors$f.tabContent}-${s}`);
                        t.addEventListener("click", () => {
                            this.tabChange(t, i);
                        }),
                            t.addEventListener("keyup", (e) => {
                                (e.code !== window.theme.keyboardKeys.SPACE && e.code !== window.theme.keyboardKeys.ENTER) || !this.body.classList.contains(classes$d.focused) || this.tabChange(t, i);
                            });
                    });
        }
        tabChange(e, t) {
            if (e.classList.contains(classes$d.current)) return;
            this.container.querySelector(`${selectors$f.tabsLi}.${classes$d.current}`).classList.remove(classes$d.current);
            this.container.querySelector(`${selectors$f.tabContent}.${classes$d.current}`).classList.remove(classes$d.current),
                e.classList.add(classes$d.current),
                t.classList.add(classes$d.current),
                e.classList.contains(classes$d.hidden) && t.classList.add(classes$d.hidden),
                this.checkVisibleTabLinks(),
                this.accessibility.a11y.removeTrapFocus(),
                this.container.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !0 })),
                e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "tab" } })),
                this.animateItems(t);
        }
        animateItems(e, t = !0) {
            const s = e.querySelectorAll(selectors$f.dataAos);
            s.length &&
                s.forEach((e) => {
                    e.classList.remove(classes$d.aosAnimate),
                        t &&
                            (e.classList.add(classes$d.aosNoTransition),
                            setTimeout(() => {
                                e.classList.remove(classes$d.aosNoTransition), e.classList.add(classes$d.aosAnimate);
                            }));
                });
        }
        initNativeScrollbar() {
            this.scrollbarHolder.length &&
                this.scrollbarHolder.forEach((e) => {
                    new NativeScrollbar(e);
                });
        }
        checkVisibleTabLinks() {
            const e = this.container.querySelectorAll(selectors$f.tabsLi),
                t = this.container.querySelectorAll(`${selectors$f.tabLink}.${classes$d.hidden}`);
            e.length - t.length < 2 ? this.container.classList.add(classes$d.alt) : this.container.classList.remove(classes$d.alt);
        }
        checkRecentTab() {
            const e = this.container.querySelector(selectors$f.tabLinkRecent);
            if (e) {
                e.classList.remove(classes$d.hidden);
                const t = parseInt(e.getAttribute(selectors$f.dataTab)),
                    s = this.container.querySelector(`${selectors$f.tabContent}[${selectors$f.dataTabIndex}="${t}"]`);
                s && (s.classList.remove(classes$d.hidden), this.animateItems(s, !1)), this.checkVisibleTabLinks(), this.initNativeScrollbar();
            }
        }
        hideRelatedTab() {
            const e = this.container.querySelector(selectors$f.dataRelatedSectionElem);
            if (!e) return;
            const t = e.closest(`${selectors$f.tabContent}.${classes$d.current}`);
            if (!t) return;
            const s = parseInt(t.getAttribute(selectors$f.dataTabIndex)),
                i = this.container.querySelectorAll(selectors$f.tabsLi);
            if (i.length > s) {
                const e = i[s].nextSibling;
                e && (i[s].classList.add(classes$d.hidden), e.dispatchEvent(new Event("click")), this.initNativeScrollbar());
            }
        }
        onBlockSelect(e) {
            const t = this.container.querySelector(`${selectors$f.tabLink}[${selectors$f.blockId}="${e.detail.blockId}"]`);
            t && (t.dispatchEvent(new Event("click")), t.parentNode.scrollTo({ top: 0, left: t.offsetLeft - t.clientWidth, behavior: "smooth" }));
        }
        constructor(e) {
            (this.container = e),
                (this.body = document.querySelector(selectors$f.body)),
                (this.accessibility = window.accessibility),
                this.container && ((this.scrollbarHolder = this.container.querySelectorAll(selectors$f.scrollbarHolder)), this.init(), this.initNativeScrollbar());
        }
    };
    const tabs = {
        onLoad() {
            sections$b[this.id] = [];
            this.container.querySelectorAll(selectors$f.dataTabsHolder).forEach((e) => {
                sections$b[this.id].push(new GlobalTabs(e));
            });
        },
        onBlockSelect(e) {
            sections$b[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
    };
    register("product-grid", [slider, swatchGridSection, tabs, siblings]), customElements.get("quick-add-product") || customElements.define("quick-add-product", QuickAddProduct);
    const tokensReducer = (e, t) => {
            const { el: s, elStyle: i, elHeight: o, rowsLimit: r, rowsWrapped: a, options: n } = e;
            let l = e.buffer,
                c = l;
            if (a === r + 1) return { ...e };
            const d = l;
            let h = a,
                u = o;
            return (
                (s.innerHTML = c = l.length ? `${l}${n.delimiter}${t}${n.replaceStr}` : `${t}${n.replaceStr}`),
                parseFloat(i.height) > parseFloat(o) && (h++, (u = i.height), h === r + 1)
                    ? ((s.innerHTML = c = "." === d[d.length - 1] && "..." === n.replaceStr ? `${d}..` : `${d}${n.replaceStr}`), { ...e, elHeight: u, rowsWrapped: h })
                    : ((s.innerHTML = c = d.length ? `${d}${n.delimiter}${t}` : `${t}`), { ...e, buffer: c, elHeight: u, rowsWrapped: h })
            );
        },
        ellipsis = (e = "", t = 1, s = {}) => {
            const i = { replaceStr: "...", debounceDelay: 250, delimiter: " ", ...s },
                o = e && (e instanceof NodeList ? e : 1 === e.nodeType ? [e] : document.querySelectorAll(e));
            for (let e = 0; e < o.length; e++) {
                const s = o[e],
                    r = /<!--[\s\S]*?-->/g,
                    a = s.innerHTML.replace(r, "").split(i.delimiter);
                s.innerHTML = "";
                const n = window.getComputedStyle(s);
                a.reduce(tokensReducer, { el: s, buffer: s.innerHTML, elStyle: n, elHeight: 0, rowsLimit: t, rowsWrapped: 0, options: i });
            }
        },
        fadeOut = (e, t = null) => {
            (e.style.opacity = 1),
                (function s() {
                    (e.style.opacity -= 0.1) < 0 ? (e.style.display = "none") : requestAnimationFrame(s), 0 === parseFloat(e.style.opacity) && "function" == typeof t && t();
                })();
        },
        selectors$e = {
            pickupContainer: "data-store-availability-container",
            shopifySection: ".shopify-section",
            drawer: "[data-pickup-drawer]",
            drawerBody: "[data-pickup-drawer-body]",
            drawerOpen: "[data-pickup-drawer-open]",
            drawerClose: "[data-pickup-drawer-close]",
            drawerUnderlay: "[data-drawer-underlay]",
            body: "body",
        },
        classes$c = { isOpen: "is-open", isHidden: "hidden", isFocused: "is-focused" };
    let sections$a = {},
        PickupAvailability = class {
            fetchPickupAvailability(e) {
                const t = this.container.querySelector(`[${selectors$e.pickupContainer}]`);
                if (!t) return;
                if ((e && !e.detail.variant) || (e && e.detail.variant && !e.detail.variant.available)) return void t.classList.add(classes$c.isHidden);
                const s = e && e.detail.variant ? e.detail.variant.id : t.getAttribute(selectors$e.pickupContainer);
                (this.drawer = this.body.querySelector(selectors$e.drawer)),
                    this.drawer && this.body.removeChild(this.drawer),
                    s &&
                        fetch(`${window.theme.routes.root}variants/${s}/?section_id=api-pickup-availability`)
                            .then(this.handleErrors)
                            .then((e) => e.text())
                            .then((e) => {
                                const s = new DOMParser().parseFromString(e, "text/html").querySelector(selectors$e.shopifySection).innerHTML;
                                (t.innerHTML = s),
                                    (this.drawer = this.container.querySelector(selectors$e.drawer)),
                                    this.drawer
                                        ? ((this.clone = this.drawer.cloneNode(!0)),
                                          this.body.appendChild(this.clone),
                                          t.classList.remove(classes$c.isHidden),
                                          t.removeChild(this.drawer),
                                          (this.drawer = this.body.querySelector(selectors$e.drawer)),
                                          (this.drawerBody = this.body.querySelector(selectors$e.drawerBody)),
                                          (this.buttonDrawerOpen = this.body.querySelector(selectors$e.drawerOpen)),
                                          (this.buttonDrawerClose = this.body.querySelectorAll(selectors$e.drawerClose)),
                                          this.buttonDrawerOpen &&
                                              this.buttonDrawerOpen.addEventListener("click", () => {
                                                  this.openDrawer(), (window.accessibility.lastElement = this.buttonDrawerOpen);
                                              }),
                                          this.buttonDrawerClose.length &&
                                              this.buttonDrawerClose.forEach((e) => {
                                                  e.addEventListener("click", () => this.closeDrawer());
                                              }),
                                          this.drawer.addEventListener("keyup", (e) => {
                                              e.code === window.theme.keyboardKeys.ESCAPE && this.closeDrawer();
                                          }))
                                        : t.classList.add(classes$c.isHidden);
                            })
                            .catch((e) => {
                                console.error(e);
                            });
            }
            openDrawer() {
                this.drawer &&
                    (this.drawer.classList.add(classes$c.isOpen),
                    this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.drawerBody })),
                    setTimeout(() => {
                        const e = this.drawer.querySelector(selectors$e.drawerClose);
                        this.a11y.removeTrapFocus(), this.a11y.trapFocus(this.drawer, { elementToFocus: e });
                    }, 200));
            }
            closeDrawer() {
                this.drawer &&
                    (this.drawer.classList.remove(classes$c.isOpen),
                    this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: this.drawerBody })),
                    this.a11y.removeTrapFocus(),
                    window.accessibility.lastElement &&
                        this.body.classList.contains(classes$c.isFocused) &&
                        requestAnimationFrame(() => {
                            window.accessibility.lastElement.focus();
                        }));
            }
            closeEvent() {
                document.addEventListener("click", (e) => {
                    var t;
                    const s = e.target,
                        i = !(s.matches(selectors$e.drawerUnderlay) || s.closest(selectors$e.drawerUnderlay));
                    (!(s.matches(selectors$e.drawerOpen) || s.closest(selectors$e.drawer)) || !i) && (null === (t = this.drawer) || void 0 === t ? void 0 : t.classList.contains(classes$c.isOpen)) && this.closeDrawer();
                });
            }
            handleErrors(e) {
                return e.ok
                    ? e
                    : e.json().then(function (t) {
                          throw new FetchError({ status: e.statusText, headers: e.headers, json: t });
                      });
            }
            constructor(e) {
                (this.container = e.container),
                    (this.drawer = null),
                    (this.drawerBody = null),
                    (this.buttonDrawerOpen = null),
                    (this.buttonDrawerClose = null),
                    (this.body = document.querySelector(selectors$e.body)),
                    (this.a11y = a11y),
                    this.container.addEventListener("theme:variant:change", (e) => this.fetchPickupAvailability(e)),
                    this.closeEvent();
            }
        };
    const pickupAvailability = {
            onLoad() {
                sections$a[this.id] = new PickupAvailability(this);
            },
        },
        selectors$d = { complementaryProducts: "complementary-products", quickAddProduct: "quick-add-product" },
        classes$b = { loaded: "is-loaded" },
        attributes$6 = { url: "data-url" };
    let ComplementaryProducts = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(
                ((e, t) => {
                    e[0].isIntersecting &&
                        (t.unobserve(this),
                        this.hasAttribute(attributes$6.url) &&
                            "" !== this.getAttribute(attributes$6.url) &&
                            fetch(this.getAttribute(attributes$6.url))
                                .then((e) => e.text())
                                .then((e) => {
                                    const t = document.createElement("div");
                                    t.innerHTML = e;
                                    const s = t.querySelector(selectors$d.complementaryProducts);
                                    s && s.innerHTML.trim().length && (this.innerHTML = s.innerHTML), t.querySelector(`${selectors$d.complementaryProducts} ${selectors$d.quickAddProduct}`) && this.classList.add(classes$b.loaded);
                                })
                                .catch((e) => {
                                    console.error(e);
                                }));
                }).bind(this),
                { rootMargin: "0px 0px 400px 0px" }
            ).observe(this);
        }
        constructor() {
            super();
        }
    };
    const selectors$c = {
            slideshow: "[data-product-slideshow]",
            dataStickyEnabled: "data-sticky-enabled",
            productPage: ".product__page",
            formWrapper: "[data-form-wrapper]",
            headerSticky: "[data-header-sticky]",
            headerHeight: "[data-header-height]",
        },
        classes$a = { sticky: "is-sticky" };
    window.theme.variables = { productPageSticky: !1 };
    const sections$9 = {};
    let ProductSticky = class {
        init() {
            this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky();
        }
        initSticky() {
            theme.variables.productPageSticky &&
                ((this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())),
                this.formWrapper.addEventListener("theme:form:sticky", (e) => {
                    this.removeAnimationFrame(), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(e)));
                }),
                document.addEventListener("theme:scroll", this.scrollEvent));
        }
        scrollEvents(e) {
            (this.scrollTop = e.detail.position), (this.scrollDirectionDown = e.detail.down), this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()));
        }
        resizeEvents(e) {
            this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.initSticky();
        }
        stickyScrollCheck() {
            const e = this.container.querySelector(`${selectors$c.productPage} ${selectors$c.formWrapper}`);
            if (e)
                if (isDesktop()) {
                    const t = this.container.querySelector(selectors$c.formWrapper),
                        s = this.container.querySelector(selectors$c.slideshow);
                    if (!t || !s) return;
                    t.offsetHeight < s.offsetHeight ? ((theme.variables.productPageSticky = !0), e.classList.add(classes$a.sticky)) : ((theme.variables.productPageSticky = !1), e.classList.remove(classes$a.sticky));
                } else (theme.variables.productPageSticky = !1), e.classList.remove(classes$a.sticky);
        }
        calculateStickyPosition(e = null) {
            if (document.documentElement.hasAttribute("data-scroll-locked")) return void this.removeAnimationFrame();
            const t = Boolean(e && e.detail),
                s = Boolean(t && e.detail.element && "accordion" === e.detail.element),
                i = this.formWrapper.offsetHeight,
                o = window.innerHeight - i - this.defaultTopBottomSpacings,
                r = Math.abs(this.scrollTop - this.scrollLastPosition);
            this.scrollDirectionDown ? (this.stickyScrollTop -= r) : (this.stickyScrollTop += r),
                this.stickyFormLoad &&
                    (document.querySelector(selectors$c.headerSticky) && document.querySelector(selectors$c.headerHeight)
                        ? (this.stickyDefaultTop = parseInt(document.querySelector(selectors$c.headerHeight).getBoundingClientRect().height))
                        : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                    (this.stickyScrollTop = this.stickyDefaultTop)),
                (this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop));
            const a = this.stickyScrollTop - this.currentPoint;
            (this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * a),
                this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`),
                (this.scrollLastPosition = this.scrollTop),
                (this.stickyFormLoad = !1),
                (s && this.onChangeCounter <= 10) || (s && this.stickyFormLastHeight !== i) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                    ? (s && (this.onChangeCounter += 1), s && this.stickyFormLastHeight !== i && (this.onChangeCounter = 11), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(e))))
                    : this.requestAnimationSticky && this.removeAnimationFrame(),
                (this.stickyFormLastHeight = i);
        }
        removeAnimationFrame() {
            this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null), (this.onChangeCounter = 0));
        }
        onUnload() {
            this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent);
        }
        constructor(e) {
            (this.section = e),
                (this.container = e.container),
                (this.stickyEnabled = "true" === this.container.getAttribute(selectors$c.dataStickyEnabled)),
                (this.formWrapper = this.container.querySelector(selectors$c.formWrapper)),
                (this.stickyScrollTop = 0),
                (this.scrollLastPosition = 0),
                (this.stickyDefaultTop = 0),
                (this.currentPoint = 0),
                (this.defaultTopBottomSpacings = 30),
                (this.scrollTop = window.scrollY),
                (this.scrollDirectionDown = !0),
                (this.requestAnimationSticky = null),
                (this.stickyFormLoad = !0),
                (this.stickyFormLastHeight = null),
                (this.onChangeCounter = 0),
                (this.scrollEvent = (e) => this.scrollEvents(e)),
                (this.resizeEvent = (e) => this.resizeEvents(e)),
                setTimeout(() => {
                    this.init();
                }, 50);
        }
    };
    const productStickySection = {
            onLoad() {
                sections$9[this.id] = new ProductSticky(this);
            },
            onUnload() {
                sections$9[this.id].onUnload();
            },
        },
        selectors$b = { section: "data-section-type", shareButton: "[data-share-button]", shareMessage: "[data-share-message]" },
        classes$9 = { visible: "is-visible" };
    let ShareButton = class extends HTMLElement {
        init() {
            navigator.share
                ? this.shareButton.addEventListener("click", () => {
                      navigator.share({ url: this.urlToShare, title: document.title });
                  })
                : this.shareButton.addEventListener("click", this.copyToClipboard.bind(this));
        }
        updateShareLink() {
            "product" == this.container.getAttribute(selectors$b.section) &&
                this.container.addEventListener("theme:variant:change", (e) => {
                    e.detail.variant && (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${e.detail.variant.id}`);
                });
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlToShare).then(() => {
                this.shareMessage.classList.add(classes$9.visible);
                const e = () => {
                    this.shareMessage.classList.remove(classes$9.visible), this.shareMessage.removeEventListener("animationend", e);
                };
                this.shareMessage.addEventListener("animationend", e);
            });
        }
        constructor() {
            super(),
                (this.container = this.closest(`[${selectors$b.section}]`)),
                (this.shareButton = this.querySelector(selectors$b.shareButton)),
                (this.shareMessage = this.querySelector(selectors$b.shareMessage)),
                (this.urlToShare = this.shareButton.dataset.shareUrl ? this.shareButton.dataset.shareUrl : document.location.href),
                this.init(),
                this.updateShareLink();
        }
    };
    const selectors$a = {
            addToCart: "[data-add-to-cart]",
            priceWrapper: "[data-price-wrapper]",
            productImage: "[data-product-image]",
            productJson: "[data-product-json]",
            form: "[data-product-form]",
            thumbs: "[data-product-thumbs]",
            dataSectionId: "data-section-id",
            dataCartBar: "data-cart-bar",
            cartBar: "#cart-bar",
            cartBarAdd: "data-add-to-cart-bar",
            cartBarScroll: "data-cart-bar-scroll",
            productSubmitAdd: ".product__submit__add",
            siteFooterWrapper: ".site-footer-wrapper",
            toggleTruncateHolder: "[data-truncated-holder]",
            toggleTruncateButton: "[data-truncated-button]",
            toggleTruncateContent: "[data-truncated-content]",
            toggleTruncateContentAttr: "data-truncated-content",
            productPopupButton: "data-product-popup",
            modalScrollContainer: "[data-tabs-holder]",
            formWrapper: "[data-form-wrapper]",
            slider: "[data-slider]",
            sliderIndex: "data-slider-index",
        },
        classes$8 = { expanded: "is-expanded", visible: "is-visible", loading: "is-loading", added: "is-added", siteFooterPush: "site-footer--push", hasPopup: "has-popup" },
        sections$8 = {};
    let Product = class {
        init() {
            (theme.mediaInstances[this.id] = new Media(this.section)), theme.mediaInstances[this.id].init();
        }
        scrollEvents(e) {
            this.cartBarExist && this.cartBarScroll();
        }
        resizeEvents(e) {
            this.truncateText();
        }
        productPopup() {
            this.productPopupButton.forEach((e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault();
                    const s = document.querySelector(`#${e.getAttribute(selectors$a.productPopupButton)}`),
                        i = s.querySelector(selectors$a.modalScrollContainer);
                    "none" !== window.getComputedStyle(s).display &&
                        (fadeOut(s),
                        this.formWrapper.classList.remove(classes$8.hasPopup),
                        this.accessibility.removeTrapFocus(),
                        this.unlockTimer && clearTimeout(this.unlockTimer),
                        (this.unlockTimer = setTimeout(() => {
                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }, 300))),
                        "none" === window.getComputedStyle(s).display &&
                            (fadeIn(s), this.formWrapper.classList.add(classes$8.hasPopup), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: i })), this.accessibility.trapFocus(s));
                });
            });
        }
        truncateText() {
            if (this.truncateElementHolder.classList.contains(classes$8.visible)) return;
            const e = this.truncateElement.querySelectorAll("style");
            e.length &&
                e.forEach((e) => {
                    this.truncateElementHolder.prepend(e);
                });
            const t = this.truncateElement.cloneNode(!0),
                s = this.truncateElement.getAttribute(selectors$a.toggleTruncateContentAttr),
                i = this.truncateElement.nextElementSibling;
            i && i.remove(), this.truncateElement.parentElement.append(t);
            const o = this.truncateElement.nextElementSibling;
            o.classList.add(s),
                o.removeAttribute(selectors$a.toggleTruncateContentAttr),
                showElement(o),
                ellipsis(o, 5, { replaceStr: "", delimiter: " " }),
                hideElement(o),
                this.truncateElement.innerHTML !== o.innerHTML ? this.truncateElementHolder.classList.add(classes$8.expanded) : (o.remove(), this.truncateElementHolder.classList.remove(classes$8.expanded)),
                this.toggleTruncatedContent(this.truncateElementHolder);
        }
        toggleTruncatedContent(e) {
            const t = e.querySelector(selectors$a.toggleTruncateButton);
            t &&
                t.addEventListener("click", (t) => {
                    t.preventDefault(), e.classList.remove(classes$8.expanded), e.classList.add(classes$8.visible);
                });
        }
        initCartBar() {
            (this.cartBarBtn = this.cartBar.querySelector(selectors$a.productSubmitAdd)),
                this.cartBarBtn &&
                    (this.cartBarBtn.addEventListener("click", (e) => {
                        e.preventDefault(),
                            e.currentTarget.hasAttribute(selectors$a.cartBarAdd)
                                ? (theme.settings.cartDrawerEnabled && (e.currentTarget.classList.add(classes$8.loading), e.currentTarget.setAttribute("disabled", "disabled")),
                                  this.form.querySelector(selectors$a.addToCart).dispatchEvent(new Event("click", { bubbles: !0 })))
                                : e.currentTarget.hasAttribute(selectors$a.cartBarScroll) && this.scrollToTop();
                    }),
                    this.cartBarBtn.hasAttribute(selectors$a.cartBarAdd) && document.addEventListener("theme:product:add-error", this.scrollToTop));
        }
        scrollToTop() {
            const e = isDesktop() ? this.container : this.form;
            scrollTo(e.getBoundingClientRect().top);
        }
        cartBarScroll() {
            const e = window.pageYOffset,
                t = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
            if (t && this.cartBar) {
                const s = document.querySelector(selectors$a.siteFooterWrapper),
                    i = e > t.offsetTop + t.offsetHeight;
                this.cartBar.classList.toggle(classes$8.visible, i), s && (s.classList.toggle(classes$8.siteFooterPush, i), (s.style.marginBottom = s.classList.contains(classes$8.siteFooterPush) ? `${this.cartBar.offsetHeight}px` : "0"));
            }
        }
        onUnload() {
            document.removeEventListener("theme:product:add-error", this.scrollToTop),
                this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEvent),
                this.cartBarExist && document.removeEventListener("theme:scroll", this.scrollEvent);
        }
        onBlockSelect(e) {
            const t = e.srcElement.closest(selectors$a.slider);
            if (t && this.slider.length) {
                const s = t.hasAttribute(selectors$a.sliderIndex) ? t.getAttribute(selectors$a.sliderIndex) : 0;
                if (!this.slider[s]) return;
                this.slider[s].onBlockSelect(e);
            }
        }
        onBlockDeselect(e) {
            const t = e.srcElement.closest(selectors$a.slider);
            if (t && this.slider.length) {
                const s = t.hasAttribute(selectors$a.sliderIndex) ? t.getAttribute(selectors$a.sliderIndex) : 0;
                if (!this.slider[s]) return;
                this.slider[s].onBlockDeselect(e);
            }
        }
        constructor(e) {
            (this.section = e),
                (this.container = e.container),
                (this.id = this.container.getAttribute(selectors$a.dataSectionId)),
                (this.sliders = this.container.querySelectorAll(selectors$a.slider)),
                (this.slider = []),
                (this.truncateElementHolder = this.container.querySelector(selectors$a.toggleTruncateHolder)),
                (this.truncateElement = this.container.querySelector(selectors$a.toggleTruncateContent)),
                (this.productPopupButton = this.container.querySelectorAll(`[${selectors$a.productPopupButton}]`)),
                (this.formWrapper = this.container.querySelector(selectors$a.formWrapper)),
                (this.cartBarExist = "true" === this.container.getAttribute(selectors$a.dataCartBar)),
                (this.cartBar = this.container.querySelector(selectors$a.cartBar)),
                (this.scrollToTop = this.scrollToTop.bind(this)),
                (this.scrollEvent = (e) => this.scrollEvents(e)),
                (this.resizeEvent = (e) => this.resizeEvents(e)),
                (this.unlockTimer = 0),
                (this.accessibility = a11y),
                this.truncateElementHolder && this.truncateElement && (setTimeout(() => this.truncateText(), 50), document.addEventListener("theme:resize", this.resizeEvent));
            const t = this.container.querySelector(selectors$a.productJson);
            if ((t && !t.innerHTML) || !t) {
                return void new QuantityCounter(this.container).init();
            }
            const s = JSON.parse(t.innerHTML).handle;
            let i = {};
            s && (i = { handle: s }),
                Shopify.Products.recordRecentlyViewed(i),
                (this.form = this.container.querySelector(selectors$a.form)),
                this.init(),
                this.sliders.length &&
                    this.sliders.forEach((e, t) => {
                        e.setAttribute(selectors$a.sliderIndex, t), this.slider.push(new Slider(this.container, e));
                    }),
                this.cartBarExist && (this.initCartBar(), document.addEventListener("theme:scroll", this.scrollEvent)),
                this.productPopupButton.length > 0 && this.productPopup();
        }
    };
    const productSection = {
        onLoad() {
            sections$8[this.id] = new Product(this);
        },
        onUnload(e) {
            sections$8[this.id].onUnload(e);
        },
        onBlockSelect(e) {
            sections$8[this.id].onBlockSelect(e);
        },
        onBlockDeselect(e) {
            sections$8[this.id].onBlockDeselect(e);
        },
    };
    register("product", [productSection, pickupAvailability, productFormSection, swatchSection, tooltipSection, popoutSection, tabs, accordions, productStickySection, initSlider]),
        customElements.get("quick-add-product") || customElements.define("quick-add-product", QuickAddProduct),
        customElements.get("complementary-products") || customElements.define("complementary-products", ComplementaryProducts),
        customElements.get("share-button") || customElements.define("share-button", ShareButton);
    const selectors$9 = {
            apiRelatedProductsTemplate: "[data-api-related-template]",
            relatedSection: "[data-related-section]",
            relatedProduct: "[data-product-grid-item]",
            recentlyViewed: "[data-recent-wrapper]",
            recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
            productItem: ".product-item",
            slider: "[data-slider]",
        },
        attributes$5 = { limit: "data-limit", minimum: "data-minimum", productId: "data-product-id" },
        classes$7 = { isHidden: "is-hidden" },
        sections$7 = {};
    let Related = class {
        related() {
            const e = this.container.querySelector(selectors$9.relatedSection);
            if (!e) return;
            const t = e.querySelectorAll(selectors$9.relatedProduct),
                s = e.getAttribute(attributes$5.productId),
                i = e.getAttribute(attributes$5.limit),
                o = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${i}&product_id=${s}&intent=related`;
            fetch(o)
                .then((e) => e.text())
                .then((s) => {
                    const i = document.createElement("div");
                    i.innerHTML = new DOMParser().parseFromString(s, "text/html").querySelector(selectors$9.apiRelatedProductsTemplate).innerHTML;
                    i.querySelector(selectors$9.relatedProduct)
                        ? ((e.innerHTML = i.innerHTML), makeGridSwatches(this.section), new Siblings(this.section), t.length > 4 && e.querySelector(selectors$9.slider) && new Slider(e))
                        : e.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
                })
                .catch(function () {
                    e.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
                });
        }
        recent() {
            const e = this.container.querySelector(selectors$9.recentlyViewed),
                t = e ? parseInt(e.getAttribute(attributes$5.limit)) : 4;
            Shopify.Products.showRecentlyViewed({
                howManyToShow: t,
                wrapperId: `recently-viewed-products-${this.sectionId}`,
                section: this.section,
                onComplete: (e, t) => {
                    const s = t.container,
                        i = s.querySelector(selectors$9.recentlyViewed),
                        o = s.querySelector(selectors$9.recentlyViewedWrapper),
                        r = e.querySelectorAll(selectors$9.productItem),
                        a = i.hasAttribute(attributes$5.minimum) ? parseInt(i.getAttribute(attributes$5.minimum)) : 4,
                        n = !o && r.length > 0,
                        l = o && r.length >= a;
                    (n || l) &&
                        (l && o.classList.remove(classes$7.isHidden),
                        fadeIn(i),
                        i.dispatchEvent(new CustomEvent("theme:tab:check", { bubbles: !0 })),
                        makeGridSwatches(t),
                        new Siblings(t),
                        r.length > 4 && i.querySelector(selectors$9.slider) && new Slider(i));
                },
            });
        }
        constructor(e) {
            (this.section = e), (this.sectionId = e.id), (this.container = e.container), this.related(), this.recent();
        }
    };
    const relatedSection = {
        onLoad() {
            sections$7[this.id] = new Related(this);
        },
    };
    register("related", [relatedSection, popoutSection, tabs]), customElements.get("quick-add-product") || customElements.define("quick-add-product", QuickAddProduct), register("reviews", [accordions, slider, blockScroll]);
    const sections$6 = {},
        selectors$8 = { sliderLogos: "[data-slider-logos]", sliderText: "[data-slider-text]", slide: "[data-slide]", slideIndex: "[data-slide-index]" },
        classes$6 = { isSelected: "is-selected", flickityEnabled: "flickity-enabled" },
        attributes$4 = { slideData: "data-slide", slideIndex: "data-slide-index" };
    let LogoList = class {
        initSlideshowText() {
            if (!this.slideshowText) return;
            this.flkty = new FlickityFade(this.slideshowText, {
                fade: !0,
                autoPlay: !1,
                prevNextButtons: !1,
                cellAlign: "left",
                contain: !0,
                pageDots: !1,
                wrapAround: !1,
                selectedAttraction: 0.2,
                friction: 0.6,
                draggable: !1,
                accessibility: !1,
                on: { ready: () => this.sliderAccessibility(), change: () => this.sliderAccessibility() },
            });
            const e = this.slideshowText.querySelectorAll(selectors$8.slide);
            if (e.length) {
                let t = -1;
                e.forEach((e) => {
                    const s = parseFloat(getComputedStyle(e, null).height.replace("px", ""));
                    s > t && (t = s);
                }),
                    e.forEach((e) => {
                        const s = parseFloat(getComputedStyle(e, null).height.replace("px", ""));
                        if (s < t) {
                            const i = Math.ceil((t - s) / 2);
                            e.style.margin = `${i}px 0`;
                        }
                    });
            }
        }
        sliderAccessibility() {
            const e = this.slideshowText.querySelectorAll(`${selectors$8.slide} a, ${selectors$8.slide} button`);
            e.length &&
                e.forEach((e) => {
                    const t = e.closest(selectors$8.slide);
                    if (t) {
                        const s = t.classList.contains(classes$6.isSelected) ? 0 : -1;
                        e.setAttribute("tabindex", s);
                    }
                });
        }
        initSlideshowNav() {
            this.slideshowNav &&
                ((this.logoSlides = this.slideshowNav.querySelectorAll(selectors$8.slideIndex)),
                this.logoSlides.length &&
                    this.logoSlides.forEach((e) => {
                        e.addEventListener("click", (t) => {
                            t.preventDefault();
                            const s = parseInt(e.getAttribute(attributes$4.slideIndex)),
                                i = this.slideshowNav.classList.contains(classes$6.flickityEnabled);
                            if ((this.flkty && this.flkty.select(s), i)) this.flktyNav.select(s), this.slideshowNav.classList.contains(classes$6.isSelected) || this.flktyNav.playPlayer();
                            else {
                                const t = this.slideshowNav.querySelector(`.${classes$6.isSelected}`);
                                t && t.classList.remove(classes$6.isSelected), e.classList.add(classes$6.isSelected);
                            }
                        });
                    }),
                this.setSlideshowNavState(),
                document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize));
        }
        setSlideshowNavState() {
            const e = this.slideshowNav.querySelectorAll(selectors$8.slide),
                t = 200 * e.length,
                s = this.slideshowNav.classList.contains(classes$6.flickityEnabled);
            if (t > getWindowWidth()) {
                if (!s) {
                    const t = this.slideshowNav.querySelector(`.${classes$6.isSelected}`);
                    t && t.classList.remove(classes$6.isSelected),
                        e[0].classList.add(classes$6.isSelected),
                        (this.flktyNav = new Flickity(this.slideshowNav, { autoPlay: 4e3, prevNextButtons: !1, contain: !1, pageDots: !1, wrapAround: !0, watchCSS: !0, selectedAttraction: 0.05, friction: 0.8, initialIndex: 0 })),
                        this.flkty && (this.flkty.select(0), this.flktyNav.on("change", (e) => this.flkty.select(e)));
                }
            } else s && (this.flktyNav.destroy(), e[0].classList.add(classes$6.isSelected), this.flkty && this.flkty.select(0));
        }
        onBlockSelect(e) {
            if (!this.slideshowNav) return;
            const t = this.slideshowNav.querySelector(`[${attributes$4.slideData}="${e.detail.blockId}"]`),
                s = parseInt(t.getAttribute(attributes$4.slideIndex));
            this.slideshowNav.classList.contains(classes$6.flickityEnabled) ? (this.flktyNav.select(s), this.flktyNav.stopPlayer(), this.slideshowNav.classList.add(classes$6.isSelected)) : t.dispatchEvent(new Event("click"));
        }
        onBlockDeselect() {
            this.slideshowNav && this.slideshowNav.classList.contains(classes$6.flickityEnabled) && (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(classes$6.isSelected));
        }
        onUnload() {
            if (!this.slideshowNav) return;
            this.slideshowNav.classList.contains(classes$6.flickityEnabled) && this.flktyNav.destroy(), this.flkty && this.flkty.destroy(), document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize);
        }
        constructor(e) {
            (this.container = e.container),
                (this.slideshowNav = this.container.querySelector(selectors$8.sliderLogos)),
                (this.slideshowText = this.container.querySelector(selectors$8.sliderText)),
                (this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState()),
                (this.flkty = null),
                (this.flktyNav = null),
                this.initSlideshowText(),
                this.initSlideshowNav();
        }
    };
    const LogoListSection = {
        onLoad() {
            sections$6[this.id] = new LogoList(this);
        },
        onUnload(e) {
            sections$6[this.id].onUnload(e);
        },
        onBlockSelect(e) {
            sections$6[this.id].onBlockSelect(e);
        },
        onBlockDeselect(e) {
            sections$6[this.id].onBlockDeselect(e);
        },
    };
    register("logos", [LogoListSection, blockScroll]);
    const selectors$7 = { videoPlay: "[data-video-play]", videoPlayValue: "data-video-play" };
    let VideoPlay = class {
        constructor(e, t = selectors$7.videoPlay, s = selectors$7.videoPlayValue) {
            (this.container = e),
                (this.videoPlay = this.container.querySelectorAll(t)),
                this.videoPlay.length &&
                    this.videoPlay.forEach((e) => {
                        e.addEventListener("click", (e) => {
                            const t = e.currentTarget;
                            if (t.hasAttribute(s) && "" !== t.getAttribute(s).trim()) {
                                e.preventDefault();
                                const i = [{ html: t.getAttribute(s) }];
                                new LoadPhotoswipe(i), (window.accessibility.lastElement = t);
                            }
                        });
                    });
        }
    };
    const videoPlay = {
            onLoad() {
                new VideoPlay(this.container);
            },
        },
        selectors$6 = { videoId: "[data-video-id]", videoPlayer: "[data-video-player]", videoTemplate: "[data-video-template]" },
        classes$5 = { loading: "is-loading" },
        sections$5 = {};
    let VideoBackground = class {
        init() {
            this.videoId &&
                (this.container.addEventListener(
                    "touchstart",
                    () => {
                        var e;
                        null === (e = this.video) || void 0 === e || e.play();
                    },
                    { passive: !0 }
                ),
                this.renderVideo());
        }
        renderVideo() {
            (this.videoTemplateObserver = new IntersectionObserver(
                (e, t) => {
                    e.forEach((e) => {
                        if (e.isIntersecting) {
                            const s = this.videoTemplate.innerHTML;
                            (this.videoPlayer.innerHTML = s), this.videoPlayer.classList.remove(classes$5.loading), (this.video = this.container.querySelector("video")), this.observeVideoPlayToggle(), t.unobserve(e.target);
                        }
                    });
                },
                { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
            )),
                this.videoTemplateObserver.observe(this.videoPlayer);
        }
        observeVideoPlayToggle() {
            if (!this.video) return;
            (this.videoPlayObserver = new IntersectionObserver(
                (e) => {
                    e.forEach((e) => {
                        const t = e.isIntersecting;
                        t && "function" == typeof this.video.play && this.video.play(), t || "function" != typeof this.video.pause || this.video.pause();
                    });
                },
                { rootMargin: "0px", threshold: [0, 1] }
            )),
                this.videoPlayObserver.observe(this.video);
        }
        onUnload() {
            this.videoTemplateObserver && this.videoTemplateObserver.disconnect(), this.videoPlayObserver && this.videoPlayObserver.disconnect();
        }
        constructor(e) {
            (this.container = e.container),
                (this.videoId = this.container.querySelector(selectors$6.videoId)),
                (this.videoPlayer = this.container.querySelector(selectors$6.videoPlayer)),
                (this.videoTemplate = this.container.querySelector(selectors$6.videoTemplate)),
                (this.video = null),
                this.init();
        }
    };
    const videoBackground = {
        onLoad() {
            sections$5[this.id] = new VideoBackground(this);
        },
        onUnload() {
            sections$5[this.id].onUnload();
        },
    };
    register("featured-video", [videoPlay, videoBackground, parallaxHero]), register("slideshow", [slider, parallaxHero]);
    const selectors$5 = { imagesHolder: "[data-images-holder]", imageHolder: "[data-image-holder]", imageElement: "[data-image-element]", imagesButton: "[data-images-button]", dataStartPosition: "data-start-position" },
        sections$4 = {};
    let CompareImages = class {
        init() {
            this.changeValues(), this.imagesButton.addEventListener("mousedown", this.onStartEvent), this.imagesButton.addEventListener("touchstart", this.onStartEvent);
        }
        changeValues(e) {
            const t = this.imagesHolder.offsetWidth,
                s = this.imagesButton.offsetWidth;
            if ((!e || (e && "touchmove" !== e.type && "mousemove" !== e.type)) && ((this.imageElement.style.width = `${t}px`), (this.imageHolder.style.width = 100 - parseInt(this.startPosition) + "%"), 0 !== this.startPosition)) {
                const e = (t * parseInt(this.startPosition)) / 100;
                this.x = e - s / 2;
            }
            this.x > t - s ? (this.x = t - s) : this.x < 0 && (this.x = 0), (this.imagesButton.style.left = (this.x / t) * 100 + "%"), (this.imageHolder.style.width = 100 - ((this.x + s / 2) / t) * 100 + "%");
        }
        onStart(e) {
            e.preventDefault();
            let t = e;
            e.touches && (t = e.touches[0]),
                (this.x = this.imagesButton.offsetLeft),
                (this.startX = t.pageX - this.x),
                this.imagesHolder.addEventListener("mousemove", this.onMoveEvent),
                this.imagesHolder.addEventListener("mouseup", this.onStopEvent),
                this.imagesHolder.addEventListener("touchmove", this.onMoveEvent),
                this.imagesHolder.addEventListener("touchend", this.onStopEvent);
        }
        onMove(e) {
            let t = e;
            e.touches && (t = e.touches[0]), (this.x = t.pageX - this.startX), this.changeValues(e);
        }
        onStop(e) {
            this.imagesHolder.removeEventListener("mousemove", this.onMoveEvent),
                this.imagesHolder.removeEventListener("mouseup", this.onStopEvent),
                this.imagesHolder.removeEventListener("touchmove", this.onMoveEvent),
                this.imagesHolder.removeEventListener("touchend", this.onStopEvent);
        }
        onUnload() {
            this.changeValuesEvent && document.removeEventListener("theme:resize", this.changeValuesEvent);
        }
        constructor(e) {
            (this.imagesHolder = e),
                this.imagesHolder &&
                    ((this.imageHolder = this.imagesHolder.querySelector(selectors$5.imageHolder)),
                    (this.imageElement = this.imagesHolder.querySelector(selectors$5.imageElement)),
                    (this.imagesButton = this.imagesHolder.querySelector(selectors$5.imagesButton)),
                    (this.startPosition = this.imagesHolder.hasAttribute(selectors$5.dataStartPosition) ? this.imagesHolder.getAttribute(selectors$5.dataStartPosition) : 0),
                    (this.startX = 0),
                    (this.x = 0),
                    (this.changeValuesEvent = (e) => this.changeValues(e)),
                    (this.onMoveEvent = (e) => this.onMove(e)),
                    (this.onStopEvent = (e) => this.onStop(e)),
                    (this.onStartEvent = (e) => this.onStart(e)),
                    this.init(),
                    document.addEventListener("theme:resize", this.changeValuesEvent));
        }
    };
    const compareImages = {
        onLoad() {
            sections$4[this.id] = [];
            this.container.querySelectorAll(selectors$5.imagesHolder).forEach((e) => {
                sections$4[this.id].push(new CompareImages(e));
            });
        },
        onUnload() {
            sections$4[this.id].forEach((e) => {
                "function" == typeof e.onUnload && e.onUnload();
            });
        },
    };
    register("custom-content", [slider, videoPlay, videoBackground, parallaxHero, swatchGridSection, compareImages, newsletterCheckForResultSection, siblings]),
        customElements.get("quick-add-product") || customElements.define("quick-add-product", QuickAddProduct);
    var styles = {};
    function mapStyle(e) {
        return styles[e];
    }
    (styles.basic = []),
        (styles.light = [
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (styles.white_label = [
            { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ gamma: "3.86" }, { lightness: "100" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (styles.dark_label = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "-82" }] },
            { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ invert_lightness: !0 }, { weight: "7.15" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (window.theme.allMaps = window.theme.allMaps || {});
    let allMaps = window.theme.allMaps;
    window.theme.mapAPI = window.theme.mapAPI || null;
    let Map = class {
        initMaps() {
            loadAPI(this.key)
                .then(() => ("true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new google.maps.LatLng(this.lat, this.long) : geocodeAddressPromise(this.address)))
                .then((e) => {
                    const t = { zoom: parseInt(this.zoomString, 10), styles: mapStyle(this.styleString), center: e, draggable: !0, clickableIcons: !1, scrollwheel: !1, zoomControl: !1, disableDefaultUI: !0 };
                    return createMap(this.mapContainer, t);
                })
                .then((e) => {
                    (this.map = e), (allMaps[this.id] = e);
                })
                .catch((e) => {
                    console.log("Failed to load Google Map"), console.log(e);
                });
        }
        unload() {
            void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize");
        }
        constructor(e) {
            (this.container = e.container),
                (this.mapContainer = this.container.querySelector("[data-map-container]")),
                (this.key = this.container.getAttribute("data-api-key")),
                (this.styleString = this.container.getAttribute("data-style") || ""),
                (this.zoomString = this.container.getAttribute("data-zoom") || 14),
                (this.address = this.container.getAttribute("data-address")),
                (this.enableCorrection = this.container.getAttribute("data-latlong-correction")),
                (this.lat = this.container.getAttribute("data-lat")),
                (this.long = this.container.getAttribute("data-long")),
                this.key && this.initMaps();
        }
    };
    const mapSection = {
        onLoad() {
            allMaps[this.id] = new Map(this);
        },
        onUnload() {
            "function" == typeof allMaps[this.id].unload && allMaps[this.id].unload();
        },
    };
    function loadAPI(e) {
        if (null === window.theme.mapAPI) {
            const t = `https://maps.googleapis.com/maps/api/js?key=${e}`;
            window.theme.mapAPI = loadScript({ url: t });
        }
        return window.theme.mapAPI;
    }
    function createMap(e, t) {
        var s = new google.maps.Map(e, t),
            i = s.getCenter();
        return (
            new google.maps.Marker({ map: s, position: i }),
            google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(s, "resize"), s.setCenter(i);
            }),
            s
        );
    }
    function geocodeAddressPromise(e) {
        return new Promise((t, s) => {
            new google.maps.Geocoder().geocode({ address: e }, function (e, i) {
                if ("OK" == i) {
                    var o = { lat: e[0].geometry.location.lat(), lng: e[0].geometry.location.lng() };
                    t(o);
                } else s(i);
            });
        });
    }
    register("map", mapSection), register("search", [swatchGridSection, siblings]), customElements.get("quick-add-product") || customElements.define("quick-add-product", QuickAddProduct);
    const selectors$4 = {
            largePromo: "[data-large-promo]",
            largePromoInner: "[data-large-promo-inner]",
            trackingInner: "[data-tracking-consent-inner]",
            tracking: "[data-tracking-consent]",
            trackingAccept: "[data-confirm-cookies]",
            cartBar: "cart-bar",
            close: "[data-close-modal]",
            modalUnderlay: "[data-modal-underlay]",
            modalBody: "[data-modal-body]",
            newsletterPopup: "[data-newsletter]",
            newsletterPopupHolder: "[data-newsletter-holder]",
            newsletterClose: "[data-newsletter-close]",
            newsletterHeading: "[data-newsletter-heading]",
            newsletterField: "[data-newsletter-field]",
            promoPopup: "[data-promo-text]",
            newsletterForm: "[data-newsletter-form]",
            delayAttribite: "data-popup-delay",
            cookieNameAttribute: "data-cookie-name",
            dataTargetReferrer: "data-target-referrer",
        },
        classes$4 = {
            hidden: "hidden",
            hasValue: "has-value",
            cartBarVisible: "cart-bar-visible",
            isVisible: "is-visible",
            success: "has-success",
            selected: "selected",
            hasBlockSelected: "has-block-selected",
            mobile: "mobile",
            desktop: "desktop",
            bottom: "bottom",
        },
        attributes$3 = { enable: "data-enable" };
    let sections$3 = {},
        DelayShow = class {
            always() {
                fadeIn(this.element, null, this.callback);
            }
            delayed(e = 10) {
                setTimeout(() => {
                    fadeIn(this.element, null, this.callback);
                }, 1e3 * e);
            }
            idle() {
                let e = 0;
                const t = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    s = ["load", "resize", "scroll"],
                    i = () => {
                        (e = setTimeout(() => {
                            (e = 0), fadeIn(this.element, null, this.callback);
                        }, 6e4)),
                            t.forEach((e) => {
                                document.addEventListener(e, o);
                            }),
                            s.forEach((e) => {
                                window.addEventListener(e, o);
                            });
                    },
                    o = () => {
                        e && clearTimeout(e),
                            t.forEach((e) => {
                                document.removeEventListener(e, o);
                            }),
                            s.forEach((e) => {
                                window.removeEventListener(e, o);
                            }),
                            i();
                    };
                i();
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (fadeIn(this.element, null, this.callback), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent));
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            constructor(e, t, s = null) {
                if (
                    ((this.element = t),
                    (this.delay = e.getAttribute(selectors$4.delayAttribite)),
                    (this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true")),
                    (this.callback = s),
                    (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
                    ("always" === this.delay || this.isSubmitted) && this.always(),
                    this.delay && this.delay.includes("delayed") && !this.isSubmitted)
                ) {
                    const e = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(e);
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle();
            }
        },
        TargetReferrer = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(selectors$4.dataTargetReferrer)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el);
            }
            constructor(e) {
                if (((this.el = e), (this.locationPath = location.href), !this.el.hasAttribute(selectors$4.dataTargetReferrer))) return !1;
                this.init();
            }
        },
        LargePopup = class {
            init() {
                const e = !1 !== this.cookie.read(),
                    t = this.popup.classList.contains(classes$4.mobile),
                    s = this.popup.classList.contains(classes$4.desktop),
                    i = isMobile();
                let o = !0;
                ((t && !i) || (s && i)) && (o = !1),
                    o
                        ? (e && !window.Shopify.designMode) ||
                          (window.Shopify.designMode || new DelayShow(this.popup, this.modal, () => this.scrollLock()), this.form && this.form.classList.contains(classes$4.success) && this.checkForSuccess(), this.initClosers())
                        : this.scrollUnlock();
            }
            checkForSuccess() {
                fadeIn(this.modal, null, () => this.scrollLock()), this.cookie.write();
            }
            initClosers() {
                this.close.addEventListener("click", this.closeModal.bind(this)), this.underlay.addEventListener("click", this.closeModal.bind(this));
            }
            closeModal(e) {
                e.preventDefault(), fadeOut(this.modal), this.cookie.write(), this.scrollUnlock();
            }
            scrollLock() {
                "none" !== window.getComputedStyle(this.popup).display && (this.a11y.trapFocus(this.modal), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.modalBody })));
            }
            scrollUnlock() {
                this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
            }
            onBlockSelect(e) {
                this.popup.contains(e.target) && (fadeIn(this.modal, null, () => this.scrollLock()), this.popup.classList.add(classes$4.selected), this.popup.parentNode.classList.add(classes$4.hasBlockSelected));
            }
            onBlockDeselect(e) {
                this.popup.contains(e.target) && (fadeOut(this.modal), this.scrollUnlock(), this.popup.classList.remove(classes$4.selected), this.popup.parentNode.classList.remove(classes$4.hasBlockSelected));
            }
            constructor(e) {
                (this.popup = e),
                    (this.modal = this.popup.querySelector(selectors$4.largePromoInner)),
                    (this.modalBody = this.popup.querySelector(selectors$4.modalBody)),
                    (this.close = this.popup.querySelector(selectors$4.close)),
                    (this.underlay = this.popup.querySelector(selectors$4.modalUnderlay)),
                    (this.form = this.popup.querySelector(selectors$4.newsletterForm)),
                    (this.cookie = new PopupCookie(this.popup.getAttribute(selectors$4.cookieNameAttribute), "user_has_closed")),
                    (this.isTargeted = new TargetReferrer(this.popup)),
                    (this.a11y = a11y),
                    this.init();
            }
        },
        Tracking = class {
            init() {
                this.showPopup && fadeIn(this.modal), this.clickEvents();
            }
            clickEvents() {
                this.acceptButton.addEventListener("click", (e) => {
                    e.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => fadeOut(this.modal)), document.documentElement.style.setProperty("--cookie-bar-height", "0px");
                }),
                    document.addEventListener("trackingConsentAccepted", () => {});
            }
            onBlockSelect(e) {
                this.popup.contains(e.target) && this.showPopup && (fadeIn(this.modal), this.popup.classList.add(classes$4.selected), this.popup.parentNode.classList.add(classes$4.hasBlockSelected));
            }
            onBlockDeselect(e) {
                this.popup.contains(e.target) && (fadeOut(this.modal), this.popup.classList.remove(classes$4.selected), this.popup.parentNode.classList.remove(classes$4.hasBlockSelected));
            }
            constructor(e) {
                (this.popup = e),
                    (this.modal = document.querySelector(selectors$4.tracking)),
                    (this.acceptButton = this.modal.querySelector(selectors$4.trackingAccept)),
                    (this.enable = "true" === this.modal.getAttribute(attributes$3.enable)),
                    (this.showPopup = !1),
                    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (e) => {
                        if (e) throw e;
                        const t = window.Shopify.customerPrivacy.userCanBeTracked(),
                            s = window.Shopify.customerPrivacy.getTrackingConsent();
                        (this.showPopup = !t && "no_interaction" === s && this.enable), window.Shopify.designMode && (this.showPopup = !0), this.init();
                    });
            }
        },
        PromoText = class {
            init() {
                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (window.Shopify.designMode ? fadeIn(this.popup) : new DelayShow(this.popup, this.popup), this.clickEvents());
            }
            clickEvents() {
                this.close.addEventListener("click", (e) => {
                    e.preventDefault(), fadeOut(this.popup), this.cookie.write();
                });
            }
            onBlockSelect(e) {
                this.popup.contains(e.target) && (fadeIn(this.popup), this.popup.classList.add(classes$4.selected), this.popup.parentNode.classList.add(classes$4.hasBlockSelected));
            }
            onBlockDeselect(e) {
                this.popup.contains(e.target) && (fadeOut(this.popup), this.popup.classList.remove(classes$4.selected), this.popup.parentNode.classList.remove(classes$4.hasBlockSelected));
            }
            constructor(e) {
                (this.popup = e),
                    (this.close = this.popup.querySelector(selectors$4.close)),
                    (this.cookie = new PopupCookie(this.popup.getAttribute(selectors$4.cookieNameAttribute), "user_has_closed")),
                    (this.isTargeted = new TargetReferrer(this.popup)),
                    this.init();
            }
        },
        NewsletterPopup = class {
            init() {
                const e = !1 !== this.cookie.read(),
                    t = -1 !== window.location.search.indexOf("?customer_posted=true"),
                    s = [...this.holder.classList].toString().includes(classes$4.bottom);
                t && (this.delay = 0), (e && !window.Shopify.designMode) || (this.show(), this.form.classList.contains(classes$4.success) && this.checkForSuccess()), s && this.observeCartBar();
            }
            show() {
                window.Shopify.designMode ? fadeIn(this.holder) : new DelayShow(this.popup, this.holder), this.showForm(), this.inputField(), this.closePopup();
            }
            checkForSuccess() {
                fadeIn(this.holder), this.cookie.write();
            }
            observeCartBar() {
                if (((this.cartBar = document.getElementById(selectors$4.cartBar)), !this.cartBar)) return;
                let e = this.cartBar.classList.contains(classes$4.isVisible);
                document.body.classList.toggle(classes$4.cartBarVisible, e);
                (this.observer = new MutationObserver((t) => {
                    for (const s of t) "attributes" === s.type && ((e = s.target.classList.contains(classes$4.isVisible)), document.body.classList.toggle(classes$4.cartBarVisible, e));
                })),
                    this.observer.observe(this.cartBar, { attributes: !0, childList: !1, subtree: !1 });
            }
            showForm() {
                this.heading.addEventListener("click", (e) => {
                    e.preventDefault(), this.heading.classList.add(classes$4.hidden), this.form.classList.remove(classes$4.hidden), this.newsletterField.focus();
                }),
                    this.heading.addEventListener("keyup", (e) => {
                        e.code === window.theme.keyboardKeys.ENTER && this.heading.dispatchEvent(new Event("click"));
                    });
            }
            closePopup() {
                this.close.addEventListener("click", (e) => {
                    e.preventDefault(), fadeOut(this.holder), this.cookie.write();
                });
            }
            inputField() {
                const e = () => {
                    this.resetClassTimer && clearTimeout(this.resetClassTimer), "" !== this.newsletterField.value && this.holder.classList.add(classes$4.hasValue);
                };
                this.newsletterField.addEventListener("input", e),
                    this.newsletterField.addEventListener("focus", e),
                    this.newsletterField.addEventListener("focusout", () => {
                        this.resetClassTimer && clearTimeout(this.resetClassTimer),
                            (this.resetClassTimer = setTimeout(() => {
                                this.holder.classList.remove(classes$4.hasValue);
                            }, 2e3));
                    });
            }
            onBlockSelect(e) {
                this.popup.contains(e.target) && (fadeIn(this.holder), this.popup.classList.add(classes$4.selected), this.popup.parentNode.classList.add(classes$4.hasBlockSelected));
            }
            onBlockDeselect(e) {
                this.popup.contains(e.target) && (fadeOut(this.holder), this.popup.classList.remove(classes$4.selected), this.popup.parentNode.classList.remove(classes$4.hasBlockSelected));
            }
            onUnload() {
                this.observer && this.observer.disconnect();
            }
            constructor(e) {
                (this.popup = e),
                    (this.holder = this.popup.querySelector(selectors$4.newsletterPopupHolder)),
                    (this.close = this.popup.querySelector(selectors$4.newsletterClose)),
                    (this.heading = this.popup.querySelector(selectors$4.newsletterHeading)),
                    (this.newsletterField = this.popup.querySelector(selectors$4.newsletterField)),
                    (this.cookie = new PopupCookie(this.popup.getAttribute(selectors$4.cookieNameAttribute), "newsletter_is_closed")),
                    (this.form = this.popup.querySelector(selectors$4.newsletterForm)),
                    (this.isTargeted = new TargetReferrer(this.popup)),
                    (this.resetClassTimer = 0),
                    this.init();
            }
        };
    const popupSection = {
        onLoad() {
            sections$3[this.id] = [];
            this.container.querySelectorAll(selectors$4.largePromo).forEach((e) => {
                sections$3[this.id].push(new LargePopup(e));
            });
            this.container.querySelectorAll(selectors$4.tracking).forEach((e) => {
                sections$3[this.id].push(new Tracking(e));
            });
            this.container.querySelectorAll(selectors$4.newsletterPopup).forEach((e) => {
                sections$3[this.id].push(new NewsletterPopup(e));
            });
            this.container.querySelectorAll(selectors$4.promoPopup).forEach((e) => {
                sections$3[this.id].push(new PromoText(e));
            });
        },
        onBlockSelect(e) {
            sections$3[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
        onBlockDeselect(e) {
            sections$3[this.id].forEach((t) => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
            });
        },
        onUnload() {
            sections$3[this.id].forEach((e) => {
                "function" == typeof e.onUnload && e.onUnload();
            });
        },
    };
    register("popups", [popupSection, newsletterCheckForResultSection]);
    const selectors$3 = { passwordLogin: "[data-password-login]", passwordModal: "[data-password-modal]", modalBody: "[data-modal-body]", close: "[data-modal-close]", loginErrors: "#login_form .errors" },
        classes$3 = { open: "is-open" };
    let Password = class {
        init() {
            this.passwordLogin.length &&
                this.modal &&
                this.modalBody &&
                (this.passwordLogin.forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), this.openModal();
                    });
                }),
                this.closeButtons.length &&
                    this.closeButtons.forEach((e) => {
                        e.addEventListener("click", (e) => {
                            e.preventDefault(), this.closeModal();
                        });
                    }),
                this.loginErrors && this.openModal());
        }
        openModal() {
            fadeIn(this.modal, "block", () => {
                this.modal.classList.add(classes$3.open);
            }),
                this.scrollLock();
        }
        closeModal() {
            fadeOut(this.modal), this.modal.classList.remove(classes$3.open), this.scrollUnlock();
        }
        scrollLock() {
            "none" !== window.getComputedStyle(this.modal).display && (this.a11y.trapFocus(this.modal), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.modalBody })));
        }
        scrollUnlock() {
            this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        constructor(e) {
            (this.container = e.container),
                (this.passwordLogin = this.container.querySelectorAll(selectors$3.passwordLogin)),
                (this.modal = this.container.querySelector(selectors$3.passwordModal)),
                (this.modalBody = this.container.querySelector(selectors$3.modalBody)),
                (this.closeButtons = this.container.querySelectorAll(selectors$3.close)),
                (this.a11y = a11y),
                (this.loginErrors = this.container.querySelector(selectors$3.loginErrors)),
                this.init();
        }
    };
    const passwordSection = {
        onLoad() {
            new Password(this);
        },
    };
    register("password-template", passwordSection),
        register("faq", accordions),
        register("list-collections", [slider, swatchGridSection, blockScroll, siblings]),
        customElements.get("quick-add-product") || customElements.define("quick-add-product", QuickAddProduct),
        register("columns", [blockScroll, slider]),
        register("newsletter", newsletterCheckForResultSection),
        register("before-after", [compareImages]);
    const selectors$2 = { scrollToElement: "[data-scroll-to]", accordionHolder: "[data-accordion-holder]", accordionToggle: "[data-accordion-toggle]", tooltip: "[data-tooltip]" },
        classes$2 = { open: "is-open" },
        attributes$2 = { scrollToElementValue: "data-scroll-to", tooltipStopMousenterValue: "data-tooltip-stop-mouseenter" },
        sections$2 = {};
    let ScrollToElement = class {
        init() {
            this.scrollToButtons.forEach((e) => {
                e.addEventListener("click", () => {
                    const t = this.container.querySelector(e.getAttribute(attributes$2.scrollToElementValue));
                    if (!t || "A" === e.tagName) return;
                    const s = t.querySelector(selectors$2.accordionToggle);
                    let i = !1;
                    if (s) {
                        const e = s.closest(selectors$2.accordionHolder);
                        !s.classList.contains(classes$2.open) && e && e.querySelector(`${selectors$2.accordionToggle}.${classes$2.open}`) && (i = !0), s.classList.contains(classes$2.open) || s.dispatchEvent(new Event("click"));
                    }
                    i ? setTimeout(() => this.scrollToElement(t), 500) : this.scrollToElement(t);
                });
            });
        }
        scrollToElement(e) {
            scrollTo(e.getBoundingClientRect().top + 1);
            const t = document.querySelectorAll(`${selectors$2.tooltip}:not([${attributes$2.tooltipStopMousenterValue}])`);
            t.length &&
                t.forEach((e) => {
                    e.setAttribute(attributes$2.tooltipStopMousenterValue, ""),
                        setTimeout(() => {
                            e.removeAttribute(attributes$2.tooltipStopMousenterValue);
                        }, 1e3);
                });
        }
        constructor(e) {
            (this.section = e), (this.container = e.container), (this.scrollToButtons = this.container.querySelectorAll(selectors$2.scrollToElement)), this.scrollToButtons.length && this.init();
        }
    };
    const scrollToElement = {
            onLoad() {
                sections$2[this.id] = new ScrollToElement(this);
            },
        },
        selectors$1 = { scrollSpy: "[data-scroll-spy]", headerSticky: "[data-header-sticky]" },
        classes$1 = { selected: "is-selected" },
        attributes$1 = { scrollSpy: "data-scroll-spy", mobile: "data-scroll-spy-mobile", desktop: "data-scroll-spy-desktop" },
        sections$1 = {};
    let ScrollSpy = class {
        init() {
            this.loopAnchors(), document.addEventListener("theme:resize:width", this.loopAnchors);
        }
        loopAnchors() {
            this.scrollSpyAnchors.length &&
                this.scrollSpyAnchors.forEach((e) => {
                    this.toggleObserver(e);
                });
        }
        toggleObserver(e) {
            const t = this.container.querySelector(e.getAttribute(attributes$1.scrollSpy));
            if (!t) return;
            this.observers[t.id] && this.observers[t.id].unobserve(t);
            const s = isDesktop();
            ((!s && e.hasAttribute(attributes$1.mobile)) || (s && e.hasAttribute(attributes$1.desktop)) || (!e.hasAttribute(attributes$1.desktop) && !e.hasAttribute(attributes$1.mobile))) && this.runObserver(t);
        }
        runObserver(e) {
            let { menuHeight: t } = readHeights();
            const s = Boolean(document.querySelector(selectors$1.headerSticky)),
                i = s ? t : 0,
                o = { rootMargin: s ? -1 * i + "px 0px 0px 0px" : "0px", threshold: [0.5, 1] };
            (this.observers[e.id] = new IntersectionObserver((e) => {
                e.forEach((e) => {
                    const t = this.container.querySelector(`[${attributes$1.scrollSpy}].${classes$1.selected}`),
                        s = this.container.querySelector(`[${attributes$1.scrollSpy}="#${e.target.id}"]`);
                    e.intersectionRatio > 0.5 && e.boundingClientRect.top - i <= e.boundingClientRect.height && (null == t || t.classList.remove(classes$1.selected), null == s || s.classList.add(classes$1.selected));
                });
            }, o)),
                this.observers[e.id].observe(e);
        }
        onUnload() {
            document.removeEventListener("theme:resize:width", this.loopAnchors),
                this.observers.length &&
                    this.observers.forEach((e) => {
                        e.disconnect();
                    });
        }
        constructor(e) {
            (this.section = e), (this.container = e.container), (this.scrollSpyAnchors = this.container.querySelectorAll(selectors$1.scrollSpy)), (this.loopAnchors = this.loopAnchors.bind(this)), (this.observers = []), this.init();
        }
    };
    const scrollSpy = {
        onLoad() {
            sections$1[this.id] = new ScrollSpy(this);
        },
        onUnload() {
            sections$1[this.id].onUnload();
        },
    };
    register("sidebar", [accordions, scrollToElement, scrollSpy]);
    const selectors = { button: "[data-hover-target]", image: "[data-collection-image]" },
        attributes = { target: "data-hover-target" },
        classes = { visible: "is-visible", selected: "is-selected" };
    let sections = {},
        CollectionsHover = class {
            init() {
                this.buttons.length &&
                    this.buttons.forEach((e) => {
                        e.addEventListener("mouseenter", (e) => {
                            const t = e.currentTarget.getAttribute(attributes.target);
                            this.updateState(t);
                        });
                    });
            }
            updateState(e) {
                const t = this.container.querySelector(`[${attributes.target}="${e}"]`),
                    s = this.container.querySelector(`#${e}:not(.${classes.visible})`),
                    i = this.container.querySelector(`${selectors.button}.${classes.selected}`),
                    o = this.container.querySelector(`${selectors.image}.${classes.visible}`);
                s && isDesktop() && (null == o || o.classList.remove(classes.visible), null == i || i.classList.remove(classes.selected), s.classList.add(classes.visible), t.classList.add(classes.selected));
            }
            onBlockSelect(e) {
                this.updateState(e.target.id);
            }
            constructor(e) {
                (this.container = e.container), (this.buttons = this.container.querySelectorAll(selectors.button)), this.init();
            }
        };
    const collectionsHover = {
        onLoad() {
            sections[this.id] = new CollectionsHover(this);
        },
        onBlockSelect(e) {
            sections[this.id].onBlockSelect(e);
        },
    };
    register("collections-hover", [collectionsHover, scrollSpy]),
        document.addEventListener("DOMContentLoaded", function () {
            load("*");
            const e = document.querySelector("[data-scroll-top-button]");
            e &&
                (e.addEventListener("click", () => {
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                }),
                document.addEventListener("theme:scroll", () => {
                    e.classList.toggle("is-visible", window.pageYOffset > window.innerHeight);
                })),
                window.self !== window.top && document.querySelector("html").classList.add("iframe"),
                "scrollBehavior" in document.documentElement.style || loadScript({ url: window.theme.assets.smoothscroll });
        }),
        window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"));
})(themeVendor.BodyScrollLock, themeVendor.themeAddresses, themeVendor.themeCurrency, themeVendor.Rellax, themeVendor.Flickity, themeVendor.FlickityFade, themeVendor.MicroModal, themeVendor.themeImages);
